<!-- Console0.1.160 / access diagnosis facts V1; 2026-10-30 02:08:33 CST; parent 521178d9cbe8e7b8edb7731894b29b9e05274860. Read-only source/certificate facts; never infer edge TLS verification from DNS. -->
<!-- Multi access domains V1.0; 2026-10-29 00:15:41 CST; parent 66595a52589c679584d5d9819a68d104859419b9. -->
<!-- Console action feedback 0.1.155; 2026-10-28 18:11:13 CST; parent 44dbda7a05c960e3c79c6c322d676ac5e4982b20. -->
<!-- Origin egress column 0.1.154; 2026-10-28 16:23:38 CST; parent 6eb2e62e13e2f6183fa985be42c2cbb1f19ed4e2. -->
<!-- Console restricted-session recovery 0.1.153; 2026-10-28 10:52:55 CST; parent 96e913c421cc309611c1b6a5efb973f80c9f78b8. -->
<!-- HotX Console 0.1.121 域名续费状态与线上验收可观测性。实际修改时间：2026-09-29 16:23:31 CST；精确父基线：dee46088d9a3ea1b8a3f2341c8227eadf022d2d8；变更：CONSOLE-HOME-DATA-PASSWORD-20260929。 -->
<!-- Console session recovery 0.1.152; 2026-10-28 10:33:55 CST; parent 5cc4139ab88215e2a94aab6d2c979dd79f4cf085. -->
<script setup lang="ts">
// Domain creation order V1; 2026-11-01 21:45:20 CST; parent af634cfe495a390f7c420624e9dad97c0cccb750.
import { creationTimeBeijing, newestDomainFirst } from '../features/domain-entry/domainCreatedTime';
// DNS task completion feedback V1; 2026-11-01 00:03:01 CST; parent c14910645115ad72fda85adf3bb2e2673a95f414.
// Domain activation readiness V1; 2026-10-31 23:45:42 CST; parent a84ae1fee6f6d8b4bbb6b307f09cfaa487b85c4e.
// Domain publication validation V1; 2026-10-31 23:12:19 CST; parent 81bdb256d5b7a94bb5a1265d806ce53aef0e0494.
// Wildcard acceleration V1; 2026-10-29 22:12 CST; parent c318343319b6812e0aba7ab02fbf64b65aca0196.
import { managedCertificateIdentity } from '../features/domain-plan/wildcardDomain';

import {
  accessPreviewSelection,
  previewDnsRecordValue as resolvePreviewDnsRecordValue,
  type DomainAccessPreview
} from '../features/domain-plan/domainAccessPreview';
// Root301 console V1.0 / v0.1.106; 2026-09-15 22:13:20 CST; parents 2babea5a62fff79dcdcc107cd525702ace774b11 / 46bed30ba11c7aa4c37387ae28f698f8a4031b9a.
import {
  buildDomainPlanChoices,
  buildGuestPaidPlanPreviews,
  describePushExpiry,
  formatDeletionCountdown,
  parseGuestPaidPlanPreviewKey,
  parseDomainPlanEntryKey,
  resolveEntryPlanChoice,
  type DomainPlanChoice,
  type DomainPlanEntryKey
} from '../features/domain-plan/domainPlanEntry';
import {
  buildDomainPlanCreatePayload,
  classifyDomainPlanError,
  domainPlanRequestFingerprint,
  resolveDomainPlanIntent
} from '../features/domain-plan/domainPlanSubmission';
import {
  assignedRootPartitionForDomain,
  buildDomainPlanPartitionRows,
  defaultPartitionForDomain,
  partitionOptions,
  partitionStatusLabel,
  type DomainPackageSelection,
  type DomainPlanPartitionOption
} from '../features/domain-plan/domainPlanPartitions';
import {
  openRechargeWindow,
  subscribeRechargeSuccess,
  type RechargeNetwork
} from '../features/domain-plan/rechargeReturn';
import {
  isConsoleAuthenticated,
  requireConsoleAuthentication
} from '../auth/guestAuthGate';
import DomainAccessTargets from '../components/DomainAccessTargets.vue';
import DomainDailyRenewCell from '../components/DomainDailyRenewCell.vue'
import DomainOriginIpCell from '../components/DomainOriginIpCell.vue'
import { useDomainDailyRenewState } from '../components/domainDailyRenewState'
// HotX Domain CTA Motion A V1.8 - latest production-development source.
// Updated: 2026-09-09 18:31 CST; parent baseline: f28c9457271e136130b276c11f98da5986608196.
// Visual-only boundary: preserve the three existing entry actions and change only color, depth and guidance motion.
// HotX Unified Edge V1.7 mature domain-flow integration - latest production source.
// Updated: 2026-09-09 CST; version: V1.7-flow-integration; parent baseline: c65f36872ccf8abca719303cc1bc7f76eb55d823.
/* HotX 域名管理跑通备份注释
 * 注释时间：2026-08-29 20:52 CST
 * 当前域名管理页已跑通：免费 CDN 申请入口、添加域名、域名列表、接入记录复制、右侧申请流程面板、域名状态统计都在这里维护。
 * 维护边界：域名页负责域名/源站/接入配置，不直接处理免费证书 ACME 重签状态；证书申请和重签置顶逻辑属于 HttpsView.vue。
 * 后续优化域名页时，优先保持提交后不阻塞、错误可恢复、列表状态清晰、用户下一步操作明确。
 */

/* HotX 域名管理跑通注释
 * 注释时间：2026-08-29 20:52 CST
 * 当前域名管理页已跑通：免费 CDN 申请入口、添加域名表单、域名列表状态、接入记录复制和右侧申请流程面板保持在同一页面内工作。
 * 后续维护请保持“域名接入”和“证书资产”边界：域名页负责域名/源站/接入配置，证书页负责 ACME 证书申请与重签，不要互相写死状态。
 */

// 域名管理当前运营版，注释更新时间：2026-08-29 20:52 CST。
// 本页同时承载域名列表、免费 CDN 申请、DNS 接入诊断和源站首配入口；后续优化要保持这些流程解耦，避免证书签发失败阻断域名保存。
/* 域名管理列表边界与操作闭环优化
 * 注释时间：2026-08-30 15:35 CST
 * 域名与免费证书共用底层域名数据，但本页只展示已经进入 CDN 交付流程的域名，避免证书申请记录混入加速域名统计。
 * 操作列仅保留有真实接口支撑的检测、配置、启用/暂停和删除，并在筛选区补充列表刷新入口。
 */
/* 添加域名接入指引与源站前置优化
 * 注释时间：2026-08-30 20:35 CST
 * 接入地址使用分步骤动画解释保存、复制和 DNS 检测流程；CDN 加速模式将源站配置前移并明确标记为必填。
 * 301 跳转模式继续隐藏源站配置，只要求填写跳转目标，提交接口和原有校验规则保持不变。
 */
/* 访问端口与多源站端口选择优化
 * 注释时间：2026-08-30 20:46 CST
 * 访问端口默认只开启 HTTPS 443，用户可单选 HTTP 80 或同时开启 80/443。
 * 源站默认使用 HTTPS 443 主端点；额外选择的 HTTP 80 和自定义端口分别保存为独立备用端点，符合每个域名仅允许一个主源站的约束。
 */
import { computed, nextTick, onBeforeUnmount, onMounted, reactive, ref, watch } from 'vue';
import { ElMessage, ElMessageBox } from 'element-plus';
import EmptyState from '@hotx-cdn/shared/components/EmptyState.vue';
import DomainConfigDialog from '../components/DomainConfigDialog.vue';
import { CONSOLE_SESSION_CHANGED_EVENT, consoleApi, tokenStorage } from '../api/client';
import { pointApi, type DomainDeletionHistoryItem, type DomainPlanItem, type DomainPlanOverview } from '../api/pointApi';
import { setConsoleNavigationDirty } from '../router/navigationState';
import { publishCurrentDomainConfig } from '../utils/autoPublish';
import { validateOriginProtocols } from './originCompatibility';
import type {
  Certificate,
  ConsolePlanResponse,
  CustomerDnsResponse,
  Domain,
  DomainSaveResponse,
  RootRedirectFields,
  FreeCdnApplyResponse,
  OriginProtocol,
  PortalDomainsPage
} from '../api/types';
import { displayDateTime } from '../utils/formatters';
import { rootCertificateView, rootProbeView, rootPublicationView, mergeRootRedirectFields, returnedIpv4Values } from '../features/domain-entry/rootRedirectStatus';
import { buildOriginCreatePayload } from './originPayload';
import {
  createService,
  deleteService as deleteUnifiedService,
  listServices,
  migrateService,
  publishService
} from '../features/unified-edge/api';
import {
  buildCreatePayloads,
  protocolDefaults,
  type DeploymentMode,
  type FrontendProtocol,
  type ServiceType,
  type ServiceView,
  type UnifiedEdgeForm
} from '../features/unified-edge/model';
import {
  ACCELERATION_REGION_OPTIONS,
  collectDomainEntryIssues,
  createDefaultProtocolSelection,
  parseOriginInput,
  toggleProtocolSelection,
  type AccelerationRegion,
  type DomainEntryIssue
} from '../features/domain-entry/domainEntryForm';

interface DiagnosisView {
  title: string;
  reason: string;
  nextStep: string;
  address: string;
  phase: string;
  tag: string;
  dnsStatusLabel?: string;
  taskId?: number;
  taskStatusLabel?: string;
  lastCheckedAt?: string;
}

interface DraftNotice {
  domain: string;
  reason: string;
  draftId?: string | number;
}

interface CertificateView {
  label: string;
  tone: 'ok' | 'waiting' | 'bad' | 'muted';
  reason?: string;
  certificateId?: number;
  canReissue: boolean;
}

const CURRENT_PLAN_CODE = 'current';
const FREE_CDN_PLAN_CODE = 'FREE';
const CREATE_FORM_DRAFT_STORAGE_KEY = 'hotx.domains.create-form-draft.v1';
const MONTHLY_PURCHASE_INTENT_STORAGE_KEY = 'hotx.domains.monthly-purchase-intents.v1';
const MAX_STORED_MONTHLY_PURCHASE_INTENTS = 40;

function restoreMonthlyPurchaseIntentKeys() {
  const restored = new Map<string, string>();
  if (typeof window === 'undefined') return restored;
  try {
    const raw = window.sessionStorage.getItem(MONTHLY_PURCHASE_INTENT_STORAGE_KEY);
    if (!raw) return restored;
    const parsed = JSON.parse(raw) as { version?: unknown; entries?: unknown };
    if (parsed.version !== 1 || !Array.isArray(parsed.entries)) throw new Error('invalid purchase intent storage');
    for (const entry of parsed.entries.slice(-MAX_STORED_MONTHLY_PURCHASE_INTENTS)) {
      if (!Array.isArray(entry) || entry.length !== 2) continue;
      const [signature, key] = entry;
      if (typeof signature === 'string' && signature && typeof key === 'string' && key) {
        restored.set(signature, key);
      }
    }
  } catch {
    try {
      window.sessionStorage.removeItem(MONTHLY_PURCHASE_INTENT_STORAGE_KEY);
    } catch {
      // Browser storage policy must not block package operations.
    }
  }
  return restored;
}

function persistMonthlyPurchaseIntentKeys(keys: Map<string, string>) {
  if (typeof window === 'undefined') return;
  try {
    const entries = [...keys.entries()].slice(-MAX_STORED_MONTHLY_PURCHASE_INTENTS);
    if (!entries.length) {
      window.sessionStorage.removeItem(MONTHLY_PURCHASE_INTENT_STORAGE_KEY);
      return;
    }
    window.sessionStorage.setItem(MONTHLY_PURCHASE_INTENT_STORAGE_KEY, JSON.stringify({ version: 1, entries }));
  } catch {
    // The in-memory key still protects retries during the current page lifetime.
  }
}

// 页面状态按「读取数据、提交域名、提交配置、单域名动作」分开维护，避免一个异步操作锁住整页。
const loading = ref(false);
const submitting = ref(false);
const configSubmitting = ref(false);
const certificateActionDomainId = ref<number>();
const error = ref('');
const success = ref('');
// 接入记录复制状态独立维护，避免全局成功提示被刷新覆盖；按钮内保留 5 秒读秒反馈。
const accessCopyCountdown = ref(0);
let accessCopyTimer: ReturnType<typeof setInterval> | undefined;
const createSubmitFeedback = ref('');
const draftNotice = ref<DraftNotice | null>(null);
const partitionContactFailure = ref('');
const page = ref<PortalDomainsPage | null>(null);
const planState = ref<ConsolePlanResponse | null>(null);
const freeCdnDecision = ref<FreeCdnApplyResponse | null>(null);
const createFormVisible = ref(false);
const freeCdnIntent = ref(false);
const configFormVisible = ref(false);
const configPanelRef = ref<HTMLElement>();
const configDomainId = ref<number>();
const selectedDomainId = ref<number>();
const dnsByDomainId = ref<Record<number, CustomerDnsResponse>>({});
const dnsLoadingDomainId = ref<number>();
const recheckingDomainId = ref<number>();
const togglingDomainId = ref<number>();
const deletingDomainId = ref<number>();
const domainPlanOverview = ref<DomainPlanOverview | null>(null);
const domainPlanLoading = ref(false);
const domainPlanLoadError = ref('');
const domainPlanState = computed(() => {
  if (domainPlanLoading.value) return 'loading';
  if (domainPlanLoadError.value) return 'error';
  return domainPlanOverview.value ? 'loaded' : 'idle';
});
const serverClockMs = ref<number>();
const domainDailyRenewState = useDomainDailyRenewState();
let domainPlanSnapshotRevision = 0;
let domainPlanLoadSequence = 0;
let domainPlanLoadPromise: Promise<boolean> | null = null;
let lifecycleClockTimer: ReturnType<typeof setInterval> | undefined;
let viewActive = true;
let listReadSequence = 0;
let dnsRequestSequence = 0;
let focusedDnsRequest = 0;
let recheckRequest = 0;
const dnsRequestByDomain = new Map<number, number>();
function beginDomainDnsRead(domainId: number): number {
  const sequence = ++dnsRequestSequence;
  dnsRequestByDomain.set(domainId, sequence);
  return sequence;
}
const originIpRefreshKey = ref(0);
let observedSession = currentReadSession();

function currentReadSession() {
  return { token: tokenStorage.getAccessToken(), customer: tokenStorage.getCustomerId() };
}

function sameReadSession(session: ReturnType<typeof currentReadSession>) {
  const current = currentReadSession();
  return viewActive && session.token === current.token && session.customer === current.customer;
}

function recoverSessionReads() {
  const current = currentReadSession();
  if (current.token === observedSession.token && current.customer === observedSession.customer) return;
  observedSession = current;
  // Invalidate only read snapshots. Keep the user's draft and never replay a mutation.
  listReadSequence += 1;
  domainPlanLoadSequence += 1;
  domainPlanLoadPromise = null;
  domainPlanSnapshotRevision += 1;
  page.value = null;
  planState.value = null;
  unifiedServices.value = [];
  dnsByDomainId.value = {};
  domainPlanOverview.value = null;
  domainPlanLoadError.value = '';
  error.value = '';
  if (current.token && !tokenStorage.getMustChangePassword()) void refreshDomainList();
}
const createPlanAutoRenew = ref(true);
const createPlanSelectionTouched = ref(false);
const createBusinessIntentId = ref('');
const createBusinessIntentFingerprint = ref('');
const requestedEntryPlan = ref<DomainPlanEntryKey | null>(null);
const selectedMonthlyAutoRenew = ref(true);
const rechargeChoiceVisible = ref(false);
const rechargeFailureMessage = ref('');
const packageActionDomainId = ref<number>();
const packageDialogVisible = ref(false);
const packageDomain = ref<Domain>();
const selectedMonthlyPlanId = ref<number>();
const selectedMonthlyPeriods = ref(1);
const monthlyPurchaseIntentKeys = restoreMonthlyPurchaseIntentKeys();
// V1.9 (2026-09-10): confirmation and order submission share this live selection,
// preventing the displayed plan and the purchased plan from drifting apart.
const selectedMonthlyPlan = computed(() => domainPlanOverview.value?.plans.find(
  (plan) => plan.id === selectedMonthlyPlanId.value
) ?? null);

function monthlyPlanDiscount(periods: number) {
  if (periods === 12) return 0.85;
  if (periods === 6) return 0.9;
  return 1;
}

const selectedMonthlyPayablePoints = computed(() => {
  if (!selectedMonthlyPlan.value) return 0;
  return Number((
    selectedMonthlyPlan.value.pointPrice
    * selectedMonthlyPeriods.value
    * monthlyPlanDiscount(selectedMonthlyPeriods.value)
  ).toFixed(3));
});

function formatPlanPoints(value: number) {
  return Number.isInteger(value) ? String(value) : value.toFixed(3).replace(/0+$/, '').replace(/\.$/, '');
}
const adminCancelVisible = ref(false);
const adminCancelCode = ref('');
const adminCancelCodeSent = ref(false);
const adminCancelSending = ref(false);
const adminCancelling = ref(false);
const searchKeyword = ref('');
const statusFilter = ref<'ALL' | 'NORMAL' | 'ONBOARDING' | 'ABNORMAL' | 'PAUSED'>('ALL');
const createServiceType = ref<ServiceType>('DOMAIN');
const unifiedServices = ref<ServiceView[]>([]);
const unifiedActionServiceId = ref<number>();
const unifiedActionFeedback = ref<Record<number, string>>({});

/* HotX domain workbench resizable split view - latest production source.
 * Updated: 2026-09-09 CST; version: V1.7-resizable-workbench; parent baseline: 7616870d13aceaf6073c301ff0713be04f6528ad.
 * This state only controls the customer-side layout. It does not alter domain,
 * origin, package, certificate, save or publish payloads.
 */
const CREATE_PANEL_WIDTH_STORAGE_KEY = 'hotx.domains.create-panel-width';
const CREATE_PANEL_DEFAULT_WIDTH = 560;
const CREATE_PANEL_MIN_WIDTH = 520;
const CREATE_PANEL_MAX_WIDTH = 720;
const DOMAIN_LIST_MIN_WIDTH = 520;
const WORKBENCH_SPLITTER_WIDTH = 22;
const domainWorkbenchRef = ref<HTMLElement>();
const createPanelWidth = ref(CREATE_PANEL_DEFAULT_WIDTH);
const isCreatePanelResizing = ref(false);
let resizePointerId: number | undefined;
let resizeStartX = 0;
let resizeStartWidth = CREATE_PANEL_DEFAULT_WIDTH;

function maximumCreatePanelWidth() {
  const workbenchWidth = domainWorkbenchRef.value?.getBoundingClientRect().width || window.innerWidth;
  return Math.max(
    CREATE_PANEL_MIN_WIDTH,
    Math.min(CREATE_PANEL_MAX_WIDTH, workbenchWidth - DOMAIN_LIST_MIN_WIDTH - WORKBENCH_SPLITTER_WIDTH)
  );
}

function clampCreatePanelWidth(width: number) {
  return Math.round(Math.min(maximumCreatePanelWidth(), Math.max(CREATE_PANEL_MIN_WIDTH, width)));
}

function centeredCreatePanelWidth() {
  const workbenchWidth = domainWorkbenchRef.value?.getBoundingClientRect().width || window.innerWidth;
  return clampCreatePanelWidth((workbenchWidth - WORKBENCH_SPLITTER_WIDTH) / 2);
}

function persistCreatePanelWidth() {
  try {
    window.localStorage.setItem(CREATE_PANEL_WIDTH_STORAGE_KEY, String(createPanelWidth.value));
  } catch {
    // Storage may be unavailable in private/restricted browser contexts; resizing still works for the current page.
  }
}

function restoreCreatePanelWidth() {
  createPanelWidth.value = centeredCreatePanelWidth();
}

function startCreatePanelResize(event: PointerEvent) {
  if (event.pointerType === 'mouse' && event.button !== 0) return;
  const splitter = event.currentTarget as HTMLElement;
  event.preventDefault();
  resizePointerId = event.pointerId;
  resizeStartX = event.clientX;
  resizeStartWidth = createPanelWidth.value;
  isCreatePanelResizing.value = true;
  splitter.setPointerCapture(event.pointerId);
  document.body.classList.add('domain-workbench-resizing');
}

function resizeCreatePanel(event: PointerEvent) {
  if (!isCreatePanelResizing.value || event.pointerId !== resizePointerId) return;
  createPanelWidth.value = clampCreatePanelWidth(resizeStartWidth + event.clientX - resizeStartX);
}

function finishCreatePanelResize(event?: PointerEvent) {
  if (event && event.currentTarget instanceof HTMLElement && event.currentTarget.hasPointerCapture(event.pointerId)) {
    event.currentTarget.releasePointerCapture(event.pointerId);
  }
  if (isCreatePanelResizing.value) persistCreatePanelWidth();
  isCreatePanelResizing.value = false;
  resizePointerId = undefined;
  document.body.classList.remove('domain-workbench-resizing');
}

function resizeCreatePanelWithKeyboard(event: KeyboardEvent) {
  const step = event.shiftKey ? 48 : 16;
  let nextWidth: number | undefined;
  if (event.key === 'ArrowLeft') nextWidth = createPanelWidth.value - step;
  if (event.key === 'ArrowRight') nextWidth = createPanelWidth.value + step;
  if (event.key === 'Home') nextWidth = CREATE_PANEL_MIN_WIDTH;
  if (event.key === 'End') nextWidth = maximumCreatePanelWidth();
  if (nextWidth === undefined) return;
  event.preventDefault();
  createPanelWidth.value = clampCreatePanelWidth(nextWidth);
  persistCreatePanelWidth();
}

function fitCreatePanelToWorkbench() {
  if (typeof window.matchMedia === 'function' && window.matchMedia('(max-width: 1180px)').matches) return;
  if (!isCreatePanelResizing.value) {
    createPanelWidth.value = centeredCreatePanelWidth();
    return;
  }
  createPanelWidth.value = clampCreatePanelWidth(createPanelWidth.value);
}

const createForm = reactive({
  serviceName: '',
  domain: '',
  accessMode: 'CDN' as 'CDN' | 'REDIRECT_301',
  // HotX V1.7 pure-IP mode parity.
  // Updated: 2026-09-09 CST; version: V1.7-mode-guidance; parent baseline: dbf4516c6af4426c457268848bf3cb5700883353.
  // Keep the selected node mode in the mature create form so save and publish
  // continue through the same service API instead of a second ad-hoc workflow.
  deploymentMode: 'SINGLE_NODE' as DeploymentMode,
  accelerationRegion: 'APAC' as AccelerationRegion,
  redirectTarget: '',
  httpEnabled: true,
  httpsEnabled: true,
  planCode: CURRENT_PLAN_CODE,
  originAddress: '',
  wildcardOriginHost: '',
  wildcardOriginTlsSni: '',
  originPort443Enabled: true,
  originPort80Enabled: false,
  customOriginPortEnabled: false,
  originPort: 8443,
  originProtocol: 'HTTPS' as OriginProtocol,
  sslMode: 'managed' as 'managed' | 'custom' | 'wildcardLater',
  cacheMode: 'default',
  websocketEnabled: true,
  tcpEnabled: false,
  udpEnabled: false,
  tcpListenPort: 10000,
  udpListenPort: 10000,
  tcpOriginPort: 10000,
  udpOriginPort: 10000,
  pureIpHttpOriginPort: 80,
  pureIpHttpsOriginPort: 443,
  preferredOriginProtocol: 'HTTPS' as 'HTTP' | 'HTTPS',
  preferredOriginPort: 443
});
const accessModeManuallySelected = ref(false);
const accessGuideAnimationKey = ref(0);
const createFieldTouched = reactive<Record<string, boolean>>({});
const createSubmitAttempted = ref(false);
let previousTcpListenPort = 10000;
let previousUdpListenPort = 10000;

const configForm = reactive({
  domain: ''
});

// 域名套餐展示与操作，更新时间：2026-09-04 20:40 CST。
// 后台专属推送套餐按账号共享；免费、每日积分和按月套餐始终按域名独立计算。
function domainPlan(row?: Domain): DomainPlanItem | undefined {
  if (!row) return undefined;
  return domainPlanOverview.value?.domains.find(item => item.domainId === row.id);
}

function remainingDays(seconds: number): string {
  if (seconds <= 0) return '已到期';
  if (seconds < 86400) return `剩余 ${Math.max(1, Math.ceil(seconds / 3600))} 小时`;
  return `剩余 ${Math.ceil(seconds / 86400)} 天`;
}

function protectionText(item?: DomainPlanItem): string {
  if (!item || item.billingMode === 'ADMIN_PUSH' || !item.deleteAt || serverClockMs.value === undefined) return '';
  return formatDeletionCountdown(item.deleteAt, new Date(serverClockMs.value).toISOString());
}

const deletionHistory = computed(() => domainPlanOverview.value?.deletionHistory || []);

function deletionCauseText(item: DomainDeletionHistoryItem) {
  if (item.cause === 'PARTITION_EXPIRED_90_DAYS') return '购买套餐分区到期 90 天自动删除';
  return item.cause === 'PLAN_EXPIRED_30_DAYS' ? '套餐到期 30 天自动删除' : '用户手动删除';
}

function writeDomainPlanOverview(overview: DomainPlanOverview) {
  domainPlanOverview.value = overview;
  const authoritativeNow = Date.parse(overview.serverNow || overview.serverTime);
  serverClockMs.value = Number.isFinite(authoritativeNow) ? authoritativeNow : undefined;
}

function applyDomainPlanOverview(overview: DomainPlanOverview) {
  domainPlanSnapshotRevision += 1;
  writeDomainPlanOverview(overview);
}

function packageLabel(item?: DomainPlanItem): string {
  if (!item) return '读取中';
  if (item.billingMode === 'ADMIN_PUSH') return `专属定制套餐 / ${item.planName || '定制方案'}`;
  if (item.billingMode === 'PARTITION') return item.partitionDisplayName || item.planName || '购买套餐分区';
  if (item.billingMode === 'MONTHLY') return item.planName || '按月套餐';
  return item.dailyAutoRenew ? '免费套餐 · 每日积分' : '免费套餐';
}

function paidUntilText(item?: DomainPlanItem): string {
  return item?.paidUntil ? displayDateTime(item.paidUntil) : '待生效';
}

// Daily billing guard UI V1.1 / 2026-09-10 CST / parent 15a7174ab:
// paid daily time remains visible even after the customer turns future renewal off.
function freePlanTimingText(item?: DomainPlanItem): string {
  if (item?.paidUntil) {
    return `积分有效至 ${paidUntilText(item)}；免费时长 ${remainingDays(item.freeRemainingSeconds || 0)} 已冻结`;
  }
  return remainingDays(item?.freeRemainingSeconds || 0);
}

async function loadDomainPlansOnce(): Promise<boolean> {
  const session = currentReadSession();
  const guestPreviewEntry = parseGuestPaidPlanPreviewKey(createForm.planCode);
  const requestSequence = ++domainPlanLoadSequence;
  const snapshotRevisionAtStart = domainPlanSnapshotRevision;
  domainPlanLoading.value = true;
  domainPlanLoadError.value = '';
  try {
    // 跨路由实例复用同一个在途读取。用户快速离开再返回时，旧实例已发出的请求
    // 由新实例继续消费，避免对同一套餐总览同时发出第二次请求。
    const result = await domainDailyRenewState.loadDomainPlans(true);
    if (!sameReadSession(session)) return false;
    // 忽略早于续费保存或新一轮刷新发起的旧快照，避免界面把已保存状态回滚。
    if (requestSequence !== domainPlanLoadSequence || snapshotRevisionAtStart !== domainPlanSnapshotRevision) {
      return true;
    }
    writeDomainPlanOverview(result);
    if (guestPreviewEntry && createFormVisible.value) {
      createForm.planCode = initialCreatePlanKey('PAID', guestPreviewEntry);
      createPlanSelectionTouched.value = true;
      if (!createForm.planCode) {
        error.value = '官网指定套餐暂不可用，请重新选择实时可用套餐。';
      }
    }
    const selectedOption = createPlanOptions.value.find(option => option.value === createForm.planCode);
    if (createFormVisible.value && selectedOption && isCreatePlanOptionDisabled(selectedOption)) {
      error.value = createPlanOptionUnavailableMessage(selectedOption);
      createForm.planCode = '';
      createPlanSelectionTouched.value = true;
    }
    return true;
  } catch (cause) {
    if (!sameReadSession(session)) return false;
    // 请求失败后禁止继续展示和操作旧套餐快照，避免用户把陈旧续费状态误认为实时状态。
    if (requestSequence !== domainPlanLoadSequence || snapshotRevisionAtStart !== domainPlanSnapshotRevision) {
      return false;
    }
    domainPlanOverview.value = null;
    // 游客仍可参观域名页；仅在执行套餐操作时要求登录，不能用 401 错误阻断页面。
    if (isConsoleAuthenticated()) {
      domainPlanLoadError.value = cause instanceof Error && cause.message.trim()
        ? cause.message.trim()
        : '套餐与自动续费状态加载失败，请刷新后重试。';
    }
    return false;
  } finally {
    if (viewActive && requestSequence === domainPlanLoadSequence) domainPlanLoading.value = false;
  }
}

async function loadDomainPlans(): Promise<boolean> {
  // 同一页面生命周期内只允许一个套餐总览读取在途。表格行挂载、页面初始化和刷新
  // 即使在同一时刻触发，也共享这一个 Promise，避免重复接口和长时间骨架占位。
  if (domainPlanLoadPromise) return domainPlanLoadPromise;
  const operation = loadDomainPlansOnce();
  domainPlanLoadPromise = operation;
  try {
    return await operation;
  } finally {
    if (domainPlanLoadPromise === operation) domainPlanLoadPromise = null;
  }
}

async function refreshDomainList(showFeedback = false): Promise<void> {
  // 0.1.121：页面唯一刷新入口必须同时重试列表与套餐快照；否则首次套餐读取失败后，
  // 自动续费单元格会一直停留在错误态，只能依赖整页刷新恢复。
  const session = currentReadSession();
  const [listReady, planReady] = await Promise.all([load(), loadDomainPlans()]);
  if (showFeedback && sameReadSession(session)) {
    if (listReady && planReady) ElMessage.success('域名列表已刷新。');
    else ElMessage.warning('刷新未全部完成，请查看页面中的具体错误后重试。');
  }
}

function openPackageDialog(row: Domain) {
  packageDomain.value = row;
  selectedMonthlyPlanId.value = domainPlanOverview.value?.plans[0]?.id;
  selectedMonthlyPeriods.value = 1;
  selectedMonthlyAutoRenew.value = true;
  packageDialogVisible.value = true;
}

function showPackageFailure(reason: unknown) {
  const failure = classifyDomainPlanError(reason);
  error.value = failure.message;
  if (failure.rechargeRequired) {
    rechargeFailureMessage.value = failure.message;
    rechargeChoiceVisible.value = true;
  }
  return failure;
}

function chooseRechargeNetwork(network: RechargeNetwork) {
  openRechargeWindow(network);
}

const stopRechargeReturn = subscribeRechargeSuccess(() => {
  // V1.0 / 2026-09-09 CST / parent 15a7174ab: refresh facts only. The preserved
  // form is intentionally not resubmitted, so a recharge can never double-charge.
  rechargeChoiceVisible.value = false;
  success.value = '充值成功，积分余额已刷新；请确认当前表单后手动再次提交。';
  window.dispatchEvent(new CustomEvent('hotx:points-updated'));
  void loadDomainPlans();
});

// 免费续期入口交互优化，更新时间：2026-09-04 CST。
// 按钮始终高亮可见；资格未开放时只解释规则，不调用后端续期接口。
async function handleFreeRenewClick(row: Domain) {
  if (!domainPlan(row)?.freeRenewAvailable) {
    await ElMessageBox.alert(
      '剩余天数充足，无需续期，剩余天数为1天时，方可继续免费续期7天',
      '免费续期提示',
      { confirmButtonText: '我知道了', type: 'info' }
    );
    return;
  }
  await renewFree(row);
}

async function renewFree(row: Domain) {
  packageActionDomainId.value = row.id;
  try {
    applyDomainPlanOverview(await pointApi.renewFreeDomain(row.id));
    success.value = `${row.domain} 的免费套餐已续期 7 天。`;
    await load();
  } catch (e) {
    error.value = e instanceof Error ? e.message : '免费续期失败。';
  } finally {
    packageActionDomainId.value = undefined;
  }
}

async function setDailyBilling(enabled: boolean) {
  if (!packageDomain.value) return;
  packageActionDomainId.value = packageDomain.value.id;
  try {
    const result = await pointApi.setDomainDailyAutoRenew(packageDomain.value.id, enabled);
    applyDomainPlanOverview(result);
    if (result.dailyChargeApplied) {
      window.dispatchEvent(new CustomEvent('hotx:points-updated'));
    }
    success.value = enabled
      ? result.dailyChargeApplied
        ? '已扣除 1 积分并续期 1 天；今日不会再次扣费。'
        : '自动续费已开启；今日已扣费或当前仍在有效期内，不会重复扣积分。'
      : '每日自动扣费已关闭；当前已付费有效期保留，到期后继续使用冻结的免费时间。';
    packageDialogVisible.value = false;
    await load();
  } catch (e) {
    showPackageFailure(e);
  } finally {
    packageActionDomainId.value = undefined;
  }
}

async function purchaseMonthlyPlan() {
  const domain = packageDomain.value;
  const plan = selectedMonthlyPlan.value;
  if (!domain || !plan) return;
  if (packageActionDomainId.value === domain.id) return;
  const packageSelection: DomainPackageSelection = {
    mode: 'NEW',
    planId: plan.id,
    periodCount: selectedMonthlyPeriods.value,
    autoRenew: selectedMonthlyAutoRenew.value,
    purchaseConfirmed: true
  };
  const intentSignature = [
    domain.id,
    packageSelection.planId,
    packageSelection.periodCount,
    packageSelection.autoRenew ? 1 : 0
  ].join(':');
  packageActionDomainId.value = domain.id;

  // The in-flight state is reserved before confirmation to block double clicks.
  // Returning or closing still cannot reach the API or deduct points.
  try {
    await ElMessageBox.confirm(
      [
        `域名：${domain.domain}`,
        `套餐：${plan.planName}`,
        `周期：${selectedMonthlyPeriods.value} 个月`,
        `应付积分：${formatPlanPoints(selectedMonthlyPayablePoints.value)} 积分`,
        `自动续费：${selectedMonthlyAutoRenew.value ? '已开启' : '已关闭'}`,
        '立即生效后将扣除积分，原免费套餐和按天加速剩余时间将作废。'
      ].join('\n'),
      '确认套餐立即生效',
      {
        type: 'warning',
        confirmButtonText: '确认并立即生效',
        cancelButtonText: '返回检查',
        distinguishCancelAndClose: true
      }
    );
  } catch {
    packageActionDomainId.value = undefined;
    return;
  }

  const domainPrefix = `${domain.id}:`;
  for (const storedSignature of monthlyPurchaseIntentKeys.keys()) {
    if (storedSignature.startsWith(domainPrefix) && storedSignature !== intentSignature) {
      monthlyPurchaseIntentKeys.delete(storedSignature);
    }
  }
  const idempotencyKey = monthlyPurchaseIntentKeys.get(intentSignature)
    || `domain-plan-${intentSignature.replaceAll(':', '-')}-${crypto.randomUUID()}`;
  monthlyPurchaseIntentKeys.set(intentSignature, idempotencyKey);
  persistMonthlyPurchaseIntentKeys(monthlyPurchaseIntentKeys);

  try {
    applyDomainPlanOverview(await pointApi.assignDomainPackagePartition(
      domain.id,
      packageSelection,
      idempotencyKey
    ));
    monthlyPurchaseIntentKeys.delete(intentSignature);
    persistMonthlyPurchaseIntentKeys(monthlyPurchaseIntentKeys);
    packageDialogVisible.value = false;
    success.value = '新套餐分区已立即生效，原免费和按天剩余时间已作废。';
    await load();
  } catch (e) {
    showPackageFailure(e);
  } finally {
    packageActionDomainId.value = undefined;
  }
}

async function setMonthlyBilling(enabled: boolean) {
  if (!packageDomain.value) return;
  packageActionDomainId.value = packageDomain.value.id;
  try {
    applyDomainPlanOverview(await pointApi.setDomainMonthlyAutoRenew(packageDomain.value.id, enabled));
    success.value = enabled
      ? '按月套餐自动续费已开启；余额充足时会自动扣费并恢复暂停的域名。'
      : '按月套餐自动续费已关闭；到期后进入 90 天保护期，不会自动扣积分。';
  } catch (e) {
    showPackageFailure(e);
  } finally {
    packageActionDomainId.value = undefined;
  }
}

async function requestAdminCancelCode() {
  if (adminCancelSending.value || adminCancelling.value || adminCancelCodeSent.value) return;
  adminCancelSending.value = true; error.value = ''; success.value = '';
  try {
    const result = await pointApi.requestAdminPushCancelCode();
    adminCancelCodeSent.value = true;
    success.value = `验证码已发送到 ${result.maskedEmail}，未收到时请检查垃圾邮件。`;
    ElMessage.success(success.value);
  } catch (e) {
    error.value = e instanceof Error ? e.message : '验证码发送失败，请重试。';
    ElMessage.error(error.value);
  } finally { adminCancelSending.value = false; }
}

async function confirmAdminCancel() {
  if (adminCancelling.value || adminCancelSending.value) return;
  adminCancelling.value = true; error.value = ''; success.value = '';
  try {
    applyDomainPlanOverview(await pointApi.cancelAdminPush(adminCancelCode.value));
    adminCancelVisible.value = false;
    success.value = '管理员专属套餐已取消，现有域名进入 15 天保护期；恢复免费套餐需删除域名并完整重新添加。';
    ElMessage.success(success.value);
    await load();
  } catch (e) {
    error.value = e instanceof Error ? e.message : '取消失败，请核对验证码后重试。';
    ElMessage.error(error.value);
  } finally { adminCancelling.value = false; }
}

// Console 0.1.101 / 2026-09-15 14:46 CST / parent 100f5b30716e211528102566acce5db7efc794ea.
// CDN-PACKAGE-DEEPLINK-FIX-20260915: 先加载套餐并恢复真实草稿；无草稿时才消费官网语义参数，避免覆盖已填写内容。
onMounted(async () => {
  window.addEventListener(CONSOLE_SESSION_CHANGED_EVENT, recoverSessionReads);
  restoreCreatePanelWidth();
  window.addEventListener('resize', fitCreatePanelToWorkbench);
  await load();
  // 路由已离开时，旧页面的列表请求仍可能稍后完成；禁止其继续启动套餐请求，
  // 否则重新进入域名页会同时出现旧实例和新实例各一次读取。
  if (!viewActive) return;
  await loadDomainPlans();
  if (!viewActive) return;
  lifecycleClockTimer = setInterval(() => {
    if (serverClockMs.value !== undefined) serverClockMs.value += 60_000;
  }, 60_000);
  const restoredDraft = restoreCreateFormDraft();
  if (!restoredDraft) {
    const params = new URLSearchParams(window.location.search);
    const entry = params.get('entry')?.trim().toLowerCase();
    const entryPlan = parseDomainPlanEntryKey(params.get('plan'));
    if (entry === 'add-domain') {
      openCreateForm({ entryPlan: entryPlan === 'free' ? undefined : entryPlan });
    } else if (entry === 'free-cdn' || shouldOpenFreeCdnFromLocation() || entryPlan === 'free') {
      openFreeCdnForm();
    } else if (entryPlan) {
      openCreateForm({ entryPlan });
    }
  }
});
onBeforeUnmount(() => {
  window.removeEventListener(CONSOLE_SESSION_CHANGED_EVENT, recoverSessionReads);
  viewActive = false;
  loading.value = false;
  dnsLoadingDomainId.value = undefined;
  domainPlanLoading.value = false;
  persistCreateFormDraft();
  stopRechargeReturn();
  setConsoleNavigationDirty(false);
  if (accessCopyTimer) clearInterval(accessCopyTimer);
  if (lifecycleClockTimer) clearInterval(lifecycleClockTimer);
  window.removeEventListener('resize', fitCreatePanelToWorkbench);
  finishCreatePanelResize();
});

// 自动证书选择保持规则，更新时间：2026-08-30 21:31 CST。根域名不再被强制切换为“稍后配置”，仅响应用户主动改选。
watch(createForm, () => {
  updateNavigationDirty();
  persistCreateFormDraft();
}, { deep: true });

watch([createFormVisible, freeCdnIntent, createServiceType], () => {
  updateNavigationDirty();
  persistCreateFormDraft();
});

watch(configForm, () => {
  updateNavigationDirty();
}, { deep: true });

// 智能访问端口与免费证书，更新时间：2026-08-30 21:12 CST。客户无需判断访客协议，系统自动兼容 HTTP 80 与 HTTPS 443。
watch(createFormVisible, visible => {
  if (visible && isDomainCreate.value) {
    createForm.httpEnabled = true;
    createForm.httpsEnabled = true;
    createForm.sslMode = 'managed';
  }
  if (visible) {
    void nextTick(fitCreatePanelToWorkbench);
  } else {
    finishCreatePanelResize();
  }
});

watch(() => createForm.domain, () => {
  accessGuideCopied.value = false;
  dnsHostCopied.value = false;
});

// CDN 列表识别规则，更新时间：2026-08-30 15:35 CST。
// 普通加速域名必须已经保存源站；301 跳转本身不需要源站，因此以跳转模式作为同等有效的 CDN 交付凭据。
function isCdnDeliveryDomain(domain: Domain) {
  return domain.accessMode === 'REDIRECT_301' || domain.hasActiveRuntime === true || Number(domain.originCount || 0) > 0;
}

const domains = computed(() => (page.value?.domains ?? []).filter(isCdnDeliveryDomain));
function unifiedField(service: ServiceView, camel: string, snake: string): unknown {
  const row = service as unknown as Record<string, unknown>;
  return row[camel] ?? row[snake];
}

function unifiedServiceType(service: ServiceView): ServiceType {
  return String(unifiedField(service, 'serviceType', 'service_type') || 'DOMAIN') as ServiceType;
}

function unifiedLifecycle(service: ServiceView): string {
  return String(unifiedField(service, 'lifecycleStatus', 'lifecycle_status') || 'DRAFT');
}

function unifiedStatusText(service: ServiceView): string {
  const status = unifiedLifecycle(service);
  return ({
    DRAFT: '已保存',
    PENDING: '等待发布',
    PUBLISHING: '发布中',
    VERIFYING: '验证中',
    ACTIVE: '运行正常',
    FAILED: '发布失败',
    DRAINING: '安全下线中',
    DELETED: '已删除'
  } as Record<string, string>)[status] || status || '无法判断';
}

function unifiedRowVersion(service: ServiceView): number {
  return Number(unifiedField(service, 'rowVersion', 'row_version') || 0);
}

function unifiedEndpointValue(endpoint: unknown, camel: string, snake: string): unknown {
  const row = endpoint as Record<string, unknown>;
  return row?.[camel] ?? row?.[snake];
}

function unifiedProtocolSummary(service: ServiceView): string {
  return (service.endpoints || []).map(endpoint => {
    const protocol = unifiedEndpointValue(endpoint, 'frontendProtocol', 'frontend_protocol');
    const port = unifiedEndpointValue(endpoint, 'listenPort', 'listen_port');
    return `${protocol}:${port}`;
  }).join(' / ') || '协议待配置';
}

function unifiedPublicIp(service: ServiceView): string {
  for (const assignment of service.assignments || []) {
    const ip = unifiedEndpointValue(assignment, 'publicIp', 'public_ip');
    if (ip) return String(ip);
  }
  return '节点分配中';
}

const pureIpServices = computed(() => unifiedServices.value.filter(service => unifiedServiceType(service) === 'PURE_IP'));
const filteredPureIpServices = computed(() => {
  const keyword = searchKeyword.value.trim().toLowerCase();
  return pureIpServices.value.filter(service => !keyword
    || service.name.toLowerCase().includes(keyword)
    || unifiedPublicIp(service).toLowerCase().includes(keyword)
    || unifiedProtocolSummary(service).toLowerCase().includes(keyword));
});

function domainUnifiedService(domain: Domain): ServiceView | undefined {
  return unifiedServices.value.find(service => Number(unifiedField(service, 'domainId', 'domain_id')) === domain.id);
}

function domainProtocolSummary(domain: Domain): string {
  const service = domainUnifiedService(domain);
  return service ? unifiedProtocolSummary(service) : '';
}

function unifiedLastError(service: ServiceView): string {
  return String(unifiedField(service, 'lastErrorMessage', 'last_error_message') || '');
}
const filteredDomains = computed(() => {
  const keyword = searchKeyword.value.trim().toLowerCase();
  return domains.value.filter(domain => {
    const matchesKeyword = !keyword
      || domain.domain.toLowerCase().includes(keyword)
      || (domain.rootDomain || '').toLowerCase().includes(keyword)
      || (domain.cnameTarget || '').toLowerCase().includes(keyword);
    const matchesStatus = statusFilter.value === 'ALL' || domainStatusGroup(domain) === statusFilter.value;
    return matchesKeyword && matchesStatus;
  }).sort(newestDomainFirst);
});
// 右侧诊断面板始终跟随当前选中域名；未选中时回退到列表第一条，保证刷新后有可读状态。
const focusedDomain = computed(() =>
  domains.value.find(domain => domain.id === selectedDomainId.value) ?? domains.value[0]
);
const configuredDomain = computed(() =>
  domains.value.find(domain => domain.id === configDomainId.value)
);
const focusedDns = computed(() => {
  const domainId = focusedDomain.value?.id;
  return domainId ? dnsByDomainId.value[domainId] : undefined;
});
const focusedRootProbe = computed(() => rootProbeView(focusedDomain.value?.redirectTargetProbe));
const focusedRootPublication = computed(() => rootPublicationView(focusedDomain.value?.publicationState));
const rootAddressWaiting = '节点正在更新，请完成流程，稍后再来查看接入 IP 地址';
const focusedCertificate = computed(() =>
  focusedDomain.value ? domainCertificateView(focusedDomain.value) : undefined
);
const diagnosisDomain = computed(() =>
  focusedDns.value?.customerDomain || focusedDns.value?.domain || focusedDomain.value?.domain || '暂无数据'
);
const totalDomains = computed(() => domains.value.length);
const runningDomains = computed(() =>
  domains.value.filter(domain => domainStatusGroup(domain) === 'NORMAL').length
);
const pendingDomains = computed(() =>
  domains.value.filter(domain => domainStatusGroup(domain) === 'ONBOARDING').length
);
const abnormalDomains = computed(() =>
  domains.value.filter(domain => domainStatusGroup(domain) === 'ABNORMAL').length
);
const pausedDomains = computed(() =>
  domains.value.filter(domain => domainStatusGroup(domain) === 'PAUSED').length
);
const normalizedCreateDomain = computed(() => createForm.domain.trim().toLowerCase());
const isPureIpCreate = computed(() => createServiceType.value === 'PURE_IP');
const isDomainCreate = computed(() => !isPureIpCreate.value);
const selectedFrontendProtocols = computed<FrontendProtocol[]>(() => {
  const protocols: FrontendProtocol[] = [];
  if (createForm.httpEnabled) protocols.push('HTTP');
  if (createForm.httpsEnabled) protocols.push('HTTPS');
  if (createForm.tcpEnabled) protocols.push('TCP');
  if (createForm.udpEnabled) protocols.push('UDP');
  return protocols;
});
const selectedLayer4Protocols = computed(() =>
  selectedFrontendProtocols.value.filter(protocol => protocol === 'TCP' || protocol === 'UDP')
);
const unifiedOriginSummary = computed(() => selectedFrontendProtocols.value.map(protocol => {
  const port = protocol === 'HTTP'
    ? createForm.pureIpHttpOriginPort
    : protocol === 'HTTPS'
      ? createForm.pureIpHttpsOriginPort
      : protocol === 'TCP'
        ? createForm.tcpOriginPort
        : createForm.udpOriginPort;
  return `${protocol}:${port}`;
}).join(' / ') || '未选择协议');
const createDomainGuideActive = computed(() => createFormVisible.value && !normalizedCreateDomain.value);
const normalizedConfigDomain = computed(() => configForm.domain.trim().toLowerCase());
const normalizedRedirectTarget = computed(() => createForm.redirectTarget.trim());
const isCreateRootDomain = computed(() =>
  Boolean(normalizedCreateDomain.value) && normalizedCreateDomain.value === deriveRootDomain(normalizedCreateDomain.value)
);
  /* 来源：console-root-a-access-guide-20260915；CST 2026-09-15 20:01:27；父基线 bae151b85b5ba94eb6df34d1dd60e3d61bde5ced。
   * 根域名在客户界面统一使用“根域名”而非 DNS 服务商方言 @；根域名接入固定走 A 记录引导，
   * 实际 IPv4 仅在服务端创建/诊断结果返回后展示，绝不以静态示例 IP 代替节点分配。 */
  const previewAccessDomain = computed(() => normalizedCreateDomain.value);
  const previewDnsHostRecord = computed(() => {
  const domain = previewAccessDomain.value;
  if (!domain) {
    return '';
  }
    const rootDomain = deriveRootDomain(domain);
    if (domain === rootDomain) {
      return '根域名';
  }
  const rootSuffix = `.${rootDomain}`;
  return domain.endsWith(rootSuffix) ? domain.slice(0, -rootSuffix.length) : domain;
});
const accessGuideCopied = ref(false);
const dnsHostCopied = ref(false);
const canRequestManagedCertificateForCreate = computed(() =>
  Boolean(createForm.httpsEnabled && createForm.sslMode === 'managed')
);
  const cnamePreviewTargets = ref<string[]>([]);
  const frozenAccessTargets = ref<Record<number,string[]>>({});
  const previewCnameTarget = computed(() => cnamePreviewTargets.value[0] || '等待服务端确认接入地址');
  const previewDnsRecordType = computed<'A' | 'CNAME'>(() => isCreateRootDomain.value ? 'A' : 'CNAME');
  // Console 0.1.107 / 2026-09-16 11:27:15 CST / parent ededcab95716ac1a5dced24f1c7bf368ce280467.
  // 根域名创建前只读取当前账号已选套餐的服务端拓扑预览；创建后的真实调度结果仍优先覆盖预览。
  const rootAccessPreview = ref<DomainAccessPreview | null>(null);
  const rootAccessPreviewLoading = ref(false);
  let rootAccessPreviewRequest = 0;
  // HotX Console 0.1.108, 2026-09-16 12:11:00 CST, parent da76328588d2aaf4a76047e4ec0eac311ea859b6.
  // The immediate watcher can run before the authenticated plan overview is ready.
  // Re-run once that fact arrives so a restored draft does not remain in the waiting state.
  watch([
    isCreateRootDomain,
    () => createForm.planCode,
    () => domainPlanOverview.value?.serverTime || ''
  ], async ([rootDomain, planKey]) => {
    const request = ++rootAccessPreviewRequest;
    rootAccessPreview.value = null;
    rootAccessPreviewLoading.value = false;
    if (!rootDomain) return;
    const selection = accessPreviewSelection(String(planKey || ''));
    if (!selection) return;
    rootAccessPreviewLoading.value = true;
    try {
      const preview = await pointApi.domainAccessPreview(selection);
      if (request === rootAccessPreviewRequest) rootAccessPreview.value = preview;
    } catch {
      if (request === rootAccessPreviewRequest) rootAccessPreview.value = null;
    } finally {
      if (request === rootAccessPreviewRequest) rootAccessPreviewLoading.value = false;
    }
  }, { immediate: true });
  const previewDnsRecordValue = computed(() => resolvePreviewDnsRecordValue(
    previewDnsRecordType.value,
    previewCnameTarget.value,
    rootAccessPreview.value,
    rootAddressWaiting
  ));
  const previewDnsRecordHint = computed(() => previewDnsRecordType.value === 'CNAME'
    ? '创建完成后任选一个已发布的最终地址配置 CNAME'
    : rootAccessPreviewLoading.value
      ? '正在读取套餐当前可调度节点'
      : rootAccessPreview.value?.state === 'READY'
        ? '套餐当前预计接入 IPv4；提交后以实际调度结果为准'
        : '暂无可用节点，完成流程后自动更新');
  const canCopyPreviewDnsRecordValue = computed(() => Boolean(normalizedCreateDomain.value)
    && (previewDnsRecordType.value === 'CNAME' ? false : rootAccessPreview.value?.state === 'READY'));
  const previewRedirectTarget = computed(() =>
  normalizedCreateDomain.value ? `https://www.${normalizedCreateDomain.value.replace(/^\*\./, '')}` : '输入域名后自动建议'
);
  const isRedirectAccessMode = computed(() => createForm.accessMode === 'REDIRECT_301');
  watch(normalizedCreateDomain, () => {
    if (!isDomainCreate.value || !normalizedCreateDomain.value || accessModeManuallySelected.value) return;
    createForm.accessMode = isCreateRootDomain.value ? 'REDIRECT_301' : 'CDN';
    accessGuideAnimationKey.value += 1;
  });

  function markAccessModeAsManuallySelected() {
    accessModeManuallySelected.value = true;
    accessGuideAnimationKey.value += 1;
  }

  function replayAccessGuide() {
    accessGuideAnimationKey.value += 1;
  }
// 源站输入引导状态，更新时间：2026-08-30 20:35 CST。仅在 CDN 模式且尚未填写源站时展示呼吸提示。
const createOriginGuideActive = computed(() => {
  const hasSelectedPort = isPureIpCreate.value
    ? selectedFrontendProtocols.value.length > 0
    : createForm.originPort443Enabled || createForm.originPort80Enabled || createForm.customOriginPortEnabled
      || selectedLayer4Protocols.value.length > 0;
  return createFormVisible.value
    && !isRedirectAccessMode.value
    && (!createForm.originAddress.trim() || !hasSelectedPort);
});

function unifiedEndpointForm(protocol: FrontendProtocol, domainId?: number): UnifiedEdgeForm {
  const originPort = protocol === 'HTTP'
    ? createForm.pureIpHttpOriginPort
    : protocol === 'HTTPS'
      ? createForm.pureIpHttpsOriginPort
      : protocol === 'TCP'
        ? createForm.tcpOriginPort
        : createForm.udpOriginPort;
  const listenPort = protocol === 'TCP'
    ? createForm.tcpListenPort
    : protocol === 'UDP'
      ? createForm.udpListenPort
      : protocolDefaults[protocol];
  return {
    serviceType: createServiceType.value,
    name: isPureIpCreate.value ? createForm.serviceName.trim() : normalizedCreateDomain.value,
    domainId,
    hostname: isDomainCreate.value ? normalizedCreateDomain.value : '',
    deploymentMode: isPureIpCreate.value ? createForm.deploymentMode : 'SINGLE_NODE',
    accelerationRegion: createForm.accelerationRegion,
    frontendProtocol: protocol,
    listenPort,
    originProtocol: protocol,
    originAddress: createForm.originAddress.trim(),
    originPort,
    backupEnabled: false,
    backupAddress: '',
    backupPort: originPort,
    tcpIdleTimeoutSeconds: 300,
    tcpConnectTimeoutSeconds: 10,
    tcpHalfClose: true,
    udpIdleTimeoutSeconds: 60,
    udpMaxPacketBytes: 1350,
    healthProbeType: protocol === 'HTTP' || protocol === 'HTTPS' ? protocol : 'NETWORK',
    healthProbePayload: '',
    healthProbeExpect: ''
  };
}

function unifiedCreatePayload(protocols: FrontendProtocol[], domainId?: number) {
  return buildCreatePayloads(protocols.map(protocol => unifiedEndpointForm(protocol, domainId)));
}
// 多端口会保存为独立源站端点，更新时间：2026-08-30 20:46 CST。443 优先作为默认主端点，其余端口按顺序作为备用端点。
const selectedOriginEndpoints = computed(() => {
  const endpoints: Array<{ port: number; protocol: OriginProtocol }> = [];
  if (createForm.originPort443Enabled) {
    endpoints.push({ port: 443, protocol: 'HTTPS' });
  }
  if (createForm.originPort80Enabled) {
    endpoints.push({ port: 80, protocol: 'HTTP' });
  }
  if (createForm.customOriginPortEnabled
    && !endpoints.some(endpoint => endpoint.port === createForm.originPort)) {
    endpoints.push({ port: createForm.originPort, protocol: createForm.originProtocol });
  }
  return endpoints.sort((left, right) => {
    const leftPreferred = left.protocol === createForm.preferredOriginProtocol
      && left.port === createForm.preferredOriginPort;
    const rightPreferred = right.protocol === createForm.preferredOriginProtocol
      && right.port === createForm.preferredOriginPort;
    return Number(rightPreferred) - Number(leftPreferred);
  });
});
const customOriginPortIsDuplicate = computed(() =>
  createForm.customOriginPortEnabled
  && ((createForm.originPort443Enabled && createForm.originPort === 443)
    || (createForm.originPort80Enabled && createForm.originPort === 80))
);
const originEndpointSummary = computed(() =>
  selectedOriginEndpoints.value
    .map((endpoint, index) => `${index === 0 ? '主' : '备用'} ${endpoint.protocol}:${endpoint.port}`)
    .join(' / ') || '未选择端口'
);
const createPlanChoices = computed(() => buildDomainPlanChoices(
  domainPlanOverview.value,
  freeCdnIntent.value ? 'FREE' : 'PAID'
));
const freeCdnQuotaUsed = computed(() => Math.min(1, domainPlanOverview.value?.domains
  .filter(item => item.billingMode === 'FREE' && item.status !== 'DELETED').length || 0));
const freeCdnQuotaFull = computed(() => freeCdnQuotaUsed.value >= 1);
const paidPartitionOptions = computed(() => buildDomainPlanPartitionRows(
  partitionOptions(domainPlanOverview.value),
  normalizedCreateDomain.value,
  domainPlanOverview.value
).map(option => ({
  label: option.label,
  value: option.key,
  disabled: option.disabled,
  partitionSelection: option.selection,
  partitionOption: option,
  preview: undefined,
  choice: {
    key: option.key,
    kind: 'PAID' as const,
    label: option.label,
    pointPrice: option.pointPrice,
    locked: false,
    supportsAutoRenew: option.isNew,
    planId: option.planId,
    planCode: option.planCode
  }
})));
const guestPaidPlanOptions = computed(() => (
  !domainPlanOverview.value && !isConsoleAuthenticated()
    ? buildGuestPaidPlanPreviews().map(preview => ({
        label: preview.label,
        value: preview.key,
        preview,
        choice: {
          key: preview.key,
          kind: 'PAID' as const,
          label: preview.label,
          pointPrice: preview.pointPrice,
          locked: false,
          supportsAutoRenew: true,
          planId: undefined,
          planCode: preview.planCode
        }
      }))
    : []
));
const createPlanOptions = computed(() => {
  const legacyChoices = createPlanChoices.value;
  if (domainPlanOverview.value?.activePush) {
    return legacyChoices.map(choice => ({ label: choice.label, value: choice.key, choice, preview: undefined }));
  }
  const freeChoices = freeCdnIntent.value
    ? legacyChoices.filter(choice => choice.kind === 'FREE').map(choice => ({
        label: choice.label,
        value: choice.key,
        choice,
        disabled: freeCdnQuotaFull.value,
        preview: undefined
      }))
    : [];
  const paidChoices = domainPlanOverview.value ? paidPartitionOptions.value : guestPaidPlanOptions.value;
  return [...freeChoices, ...paidChoices];
});
const createPlanRows = computed(() => {
  const partitionRows = new Map(
    paidPartitionOptions.value.map(option => [option.value, option.partitionOption])
  );
  return createPlanOptions.value.map(option => ({
    ...option,
    partitionRow: partitionRows.get(option.value),
    freeQuota: option.choice.kind === 'FREE'
      ? {
          quotaLabel: `单域名${freeCdnQuotaUsed.value}/1`,
          postSubmitQuotaLabel: '单域名1/1',
          full: freeCdnQuotaFull.value
        }
      : undefined
  }));
});
const selectedCreatePlanOption = computed(() =>
  createPlanOptions.value.find(option => option.value === createForm.planCode) || null
);
const selectedCreatePlan = computed<DomainPlanChoice | null>(() =>
  selectedCreatePlanOption.value?.choice || null
);
const selectedPartitionSelection = computed<DomainPackageSelection | undefined>(() => {
  const option = selectedCreatePlanOption.value;
  return option && 'partitionSelection' in option
    ? option.partitionSelection as DomainPackageSelection
    : undefined;
});
const selectedAccelerationRegionLabel = computed(() =>
  ACCELERATION_REGION_OPTIONS.find(option => option.value === createForm.accelerationRegion)?.label || '亚太加速'
);
const createIssues = computed<DomainEntryIssue[]>(() => collectDomainEntryIssues({
  serviceType: createServiceType.value,
  name: isPureIpCreate.value ? createForm.serviceName : normalizedCreateDomain.value,
  originAddress: createForm.originAddress,
  selectedProtocols: selectedFrontendProtocols.value,
  selectedPlanKey: createForm.planCode,
  tcpListenPort: createForm.tcpListenPort,
  tcpOriginPort: createForm.tcpOriginPort,
  udpListenPort: createForm.udpListenPort,
  udpOriginPort: createForm.udpOriginPort,
  requireOrigin: !isRedirectAccessMode.value
}));
const currentPlanLabel = computed(() => {
  const plan = planState.value?.currentPlan;
  if (plan?.snapshot?.planName) {
    return `${plan.snapshot.planName}${plan.status === 'ACTIVE' ? '' : `（${planStatusText(plan.status)}）`}`;
  }
  return '当前可用套餐';
});
const freeCdnPlanLabel = computed(() =>
  freeCdnDecision.value?.plan?.snapshot?.planName
    || stringField(freeCdnDecision.value?.plan, ['name', 'planName'])
    || '免费 CDN 套餐'
);
const selectedPlanLabel = computed(() =>
  createPlanOptions.value.find(option => option.value === createForm.planCode)?.label || '请先选择套餐'
);
const selectedPlanHint = computed(() => {
  const choice = selectedCreatePlan.value;
  if (!choice) return '暂未获取到可用套餐，请刷新套餐信息后重试。';
  if (choice.kind === 'ADMIN_PUSH' && domainPlanOverview.value?.activePush) {
    return `${describePushExpiry(domainPlanOverview.value.activePush, domainPlanOverview.value.serverTime)}；推送套餐到期后继续服务，直到管理员手动调整。`;
  }
  if (choice.kind === 'PAID') {
    if (selectedCreatePlanOption.value?.preview) {
      return '当前为官网公开套餐预览；登录后将刷新真实积分和额度，已填写内容不会丢失。';
    }
    const option = selectedCreatePlanOption.value && 'partitionOption' in selectedCreatePlanOption.value
      ? selectedCreatePlanOption.value.partitionOption as DomainPlanPartitionOption
      : undefined;
    if (option?.isNew) {
      return `将购买新的独立分区，首次提交扣除 ${choice.pointPrice} 积分；自动续费可在保存前关闭。`;
    }
    const partition = option?.partition;
    const now = Date.parse(domainPlanOverview.value?.serverNow || domainPlanOverview.value?.serverTime || '');
    const expiry = Date.parse(partition?.expireAt || '');
    const unavailable = partition?.status !== 'ACTIVE'
      || Number.isFinite(now) && Number.isFinite(expiry) && expiry <= now;
    if (partition && unavailable) {
      return `原分区${partitionStatusLabel(partition.status)}，同根域名必须使用该分区；请先续费或处理原分区。`;
    }
    return '使用已有分区的剩余额度，本次添加域名不重复扣费。';
  }
  return freeCdnDecision.value
    ? freeCdnDecisionMessage(freeCdnDecision.value)
    : '默认使用免费 CDN 套餐；也可以改选上方任一付费套餐。';
});
const sslModeOptions = computed(() =>
  isCreateRootDomain.value
    ? [
        { label: '稍后申请泛域名证书（推荐）', value: 'wildcardLater' },
        { label: '上传已有证书', value: 'custom' }
      ]
    : [
        { label: normalizedCreateDomain.value.startsWith('*.') ? '自动泛域名证书（DNS 验证）' : '自动免费证书（推荐）', value: 'managed' },
        { label: '上传已有证书', value: 'custom' },
        { label: '稍后配置', value: 'wildcardLater' }
      ]
);
const sslModeHint = computed(() =>
  isRedirectAccessMode.value
    ? '系统优先匹配有效泛域名证书，无匹配时自动申请免费证书；保存后可查看 DNS 验证和节点发布进度。'
    : normalizedCreateDomain.value.startsWith('*.')
    ? '泛域名证书需要 DNS 验证；创建后请完成证书页的 DNS 委托，HTTPS 以签发及节点应用回执为准。'
    : isCreateRootDomain.value
    ? '根域名不会申请普通自动免费证书；保存域名后可前往 HTTPS 证书页申请泛域名证书。'
    : '自动免费证书只记录申请意图，具体签发和验证继续使用现有 HTTPS 证书模块。'
);
const hasCreateDraft = computed(() =>
  Boolean(
    createFormVisible.value
      || createForm.serviceName.trim()
      || createForm.domain.trim()
      || createForm.redirectTarget.trim()
      || createForm.originAddress.trim()
      || createForm.originPort !== 80
      || createForm.originProtocol !== 'HTTP'
      || !createForm.httpEnabled
      || !createForm.httpsEnabled
  )
);
const hasConfigDraft = computed(() =>
  Boolean(configFormVisible.value && configuredDomain.value && normalizedConfigDomain.value !== configuredDomain.value.domain.toLowerCase())
);

function createIssue(field: DomainEntryIssue['field']) {
  return createIssues.value.find(issue => issue.field === field);
}

function initialPaidPartitionKey(domain = '', selectedPlanId?: number) {
  const planId = selectedPlanId || domainPlanOverview.value?.plans[0]?.id;
  if (!planId) return '';
  const existing = defaultPartitionForDomain(domain, domainPlanOverview.value, planId);
  return existing ? `PARTITION:EXISTING:${existing.id}` : `PARTITION:NEW:${planId}`;
}

function initialCreatePlanKey(entryMode: 'FREE' | 'PAID', entryPlan = requestedEntryPlan.value) {
  if (domainPlanOverview.value?.activePush) {
    return createPlanChoices.value[0]?.key || '';
  }
  if (entryMode === 'FREE') return freeCdnQuotaFull.value ? '' : 'FREE';
  if (!domainPlanOverview.value && !isConsoleAuthenticated()) {
    const guestEntry = entryPlan && entryPlan !== 'free' ? entryPlan : 'developer';
    return `PREVIEW:${guestEntry}`;
  }
  const requested = resolveEntryPlanChoice(createPlanChoices.value, entryPlan);
  if (entryPlan && !requested) return '';
  return initialPaidPartitionKey(normalizedCreateDomain.value, requested?.planId);
}

function assignedPartitionForCurrentSelection(domain: string) {
  const selected = createPlanOptions.value.find(option => option.value === createForm.planCode);
  if (selected?.choice.kind !== 'PAID' || !selected.choice.planId) return null;
  return assignedRootPartitionForDomain(domain, domainPlanOverview.value, selected.choice.planId);
}

async function handleCreatePlanSelectionChange(planCode: string) {
  createPlanSelectionTouched.value = true;
  createForm.planCode = planCode;
  await nextTick();
  const assigned = assignedPartitionForCurrentSelection(normalizedCreateDomain.value);
  if (assigned) createForm.planCode = `PARTITION:EXISTING:${assigned.id}`;
}

watch(normalizedCreateDomain, domain => {
  if (!domain) return;
  const selected = selectedCreatePlanOption.value;
  if (selected?.choice.kind !== 'PAID') return;
  const planId = selected?.choice.planId || domainPlanOverview.value?.plans[0]?.id;
  if (!planId) return;
  const assigned = assignedRootPartitionForDomain(domain, domainPlanOverview.value, planId);
  if (assigned) {
    createForm.planCode = `PARTITION:EXISTING:${assigned.id}`;
    return;
  }
  if (createPlanSelectionTouched.value) return;
  const existing = defaultPartitionForDomain(domain, domainPlanOverview.value, planId);
  createForm.planCode = existing
    ? `PARTITION:EXISTING:${existing.id}`
    : `PARTITION:NEW:${planId}`;
});


function showCreateIssue(field: DomainEntryIssue['field']) {
  return Boolean(createIssue(field) && (createSubmitAttempted.value || createFieldTouched[field]));
}

function markCreateFieldTouched(field: DomainEntryIssue['field']) {
  createFieldTouched[field] = true;
}

function isCreatePlanOptionDisabled(option: unknown) {
  const candidate = option as { disabled?: boolean; partitionRow?: { disabled: boolean } };
  return Boolean(candidate.disabled || candidate.partitionRow?.disabled);
}

function createPlanOptionUnavailableMessage(option: unknown) {
  const candidate = option as {
    choice?: { kind?: string };
    partitionRow?: { unavailableReason?: string };
    partitionOption?: { unavailableReason?: string };
  };
  if (candidate.choice?.kind === 'FREE') {
    return '免费套餐额度已满，请选择其他可用套餐。';
  }
  const reason = candidate.partitionRow?.unavailableReason
    || candidate.partitionOption?.unavailableReason
    || '当前状态不允许使用';
  return `当前套餐不可用：${reason}，请重新选择可用套餐。`;
}

async function focusFirstCreateIssue(issue: DomainEntryIssue) {
  await nextTick();
  const target = document.querySelector<HTMLElement>(`[data-required-field="${issue.field}"]`);
  target?.scrollIntoView({ behavior: 'smooth', block: 'center' });
  target?.querySelector<HTMLElement>('input,button,[tabindex]')?.focus();
}

function toggleFrontendProtocol(protocol: FrontendProtocol, enabled: boolean) {
  const result = toggleProtocolSelection({
    httpEnabled: createForm.httpEnabled,
    httpsEnabled: createForm.httpsEnabled,
    tcpEnabled: createForm.tcpEnabled,
    udpEnabled: createForm.udpEnabled
  }, protocol, enabled);
  if (result.blocked) {
    error.value = '请至少保留一个加速协议。';
    return;
  }
  Object.assign(createForm, result.selection);
  error.value = '';
}

function normalizeOriginAddressField() {
  markCreateFieldTouched('originAddress');
  const hasExplicitScheme = /^https?:\/\//i.test(createForm.originAddress.trim());
  const parsed = parseOriginInput(createForm.originAddress);
  createForm.originAddress = parsed.address;
  createForm.preferredOriginProtocol = parsed.preferredProtocol;
  createForm.preferredOriginPort = parsed.explicitPort
    || (parsed.preferredProtocol === 'HTTPS' ? 443 : 80);
  if (hasExplicitScheme || parsed.explicitPort) {
    const port = createForm.preferredOriginPort;
    createForm.originPort80Enabled = port === 80 && parsed.preferredProtocol === 'HTTP';
    createForm.originPort443Enabled = port === 443 && parsed.preferredProtocol === 'HTTPS';
    createForm.customOriginPortEnabled = !createForm.originPort80Enabled && !createForm.originPort443Enabled;
    if (createForm.customOriginPortEnabled) {
      createForm.originPort = port;
      createForm.originProtocol = parsed.preferredProtocol;
    }
  }
}

function syncLayer4ListenPort(protocol: 'TCP' | 'UDP', value: number) {
  if (protocol === 'TCP') {
    if (createForm.tcpOriginPort === previousTcpListenPort) createForm.tcpOriginPort = value;
    previousTcpListenPort = value;
    return;
  }
  if (createForm.udpOriginPort === previousUdpListenPort) createForm.udpOriginPort = value;
  previousUdpListenPort = value;
}
const accessDnsEffective = computed(() => Boolean(focusedDns.value?.verified
  || ['CORRECT', 'VERIFIED', 'ACTIVE'].includes(focusedDns.value?.dnsStatus || '')));

function originDiagnosis(domain: Domain): string {
  if (domain.originStatusKnown === false) return '源站状态待确认';
  return Number(domain.originCount) > 0 ? '源站已配置' : '待配置源站';
}

function configuredAccessAdvice(domain: Domain): string {
  if (domain.originStatusKnown === false) return '源站状态暂未确认，请刷新后查看；无需重复添加源站。';
  if (!Number(domain.originCount)) return '请先配置源站，再检查回源及节点发布状态。';
  const certificate = domainCertificateView(domain);
  const status = normalizedCertificateStatus(domain);
  if (['EXPIRED', 'REVOKED'].includes(status)) return '源站已配置，请处理过期或已撤销的证书。';
  if (['FAILED', 'ERROR', 'REJECTED'].includes(status) || certificate.tone === 'bad') return '源站已配置，请查看证书失败原因并处理。';
  if (certificate.tone === 'waiting') return '源站已配置，等待证书签发；可在证书管理中查看进度。';
  if (['ISSUED', 'VALID', 'ACTIVE', 'BOUND'].includes(status)) return '源站配置与证书签发已完成，可查看运行状态和访问日志。';
  if (certificate.tone === 'ok') return '源站已配置，证书状态待确认；请查看证书管理。';
  return '源站已配置，可按需配置 HTTPS 证书。';
}

const accessFlow = computed(() => {
  const root = focusedDomain.value;
  if (root?.accessMode === 'REDIRECT_301') return [
    { name: '客户访问', status: '已创建域名' },
    { name: 'A 接入', status: focusedDns.value?.verified ? 'DNS 已生效' : '等待客户配置' },
    { name: '301 跳转', status: rootProbeView(root.redirectTargetProbe).label },
    { name: '节点发布', status: rootPublicationView(root.publicationState).label }
  ];
  const hasDomain = Boolean(focusedDomain.value);
  const isChecking = diagnosis.value.title === '检测中';
  const dnsEffective = accessDnsEffective.value;
  const platformBlocked = Boolean(root && !domainPlatformReady(root, focusedDns.value));
  const recordType = focusedDomain.value ? dnsRecordTypeFor(focusedDomain.value) : '接入记录';
  return [
    {
      name: '客户访问',
      status: hasDomain ? '已创建域名' : '待添加域名'
    },
    {
      name: `${recordType} 接入`,
      status: dnsEffective ? 'DNS 已生效' : (isChecking ? '检测中' : '等待客户配置')
    },
    {
      name: '源站回源',
      status: platformBlocked ? '等待平台恢复' : (root ? originDiagnosis(root) : '待添加域名')
    },
    {
      name: 'HTTPS 就绪',
      status: root ? domainCertificateView(root).label : '待添加域名'
    }
  ];
});

const diagnosis = computed<DiagnosisView>(() => {
  const domain = focusedDomain.value;
  if (!domain) {
    return {
      title: '暂无接入诊断',
      reason: '还没有添加域名。',
      nextStep: '点击右上角“添加域名”，完成域名、源站和端口配置。',
      address: '暂无数据',
      phase: '用户访问',
      tag: '暂无数据'
    };
  }
  const dns = focusedDns.value;
  if (domain.accessMode === 'REDIRECT_301') {
    const publication = rootPublicationView(domain.publicationState);
    return {
      title: publication.label,
      reason: publication.reason || '证书、目标访问和节点发布状态分别显示如下。',
      nextStep: domain.certificateState?.status === 'WAITING_DNS'
        ? '完成证书 DNS 验证；取得接入 IP 后添加 A 记录，再点击“重新检测”。'
        : '按实际接入 IP 配置 A 记录，可点击“重新检测”更新证书、目标访问及发布状态。',
      address: dnsExpectedValuesFor(domain, dns).join(' / ') || rootAddressWaiting,
      phase: '301 跳转', tag: publication.label,
      dnsStatusLabel: dns ? dnsStatusText(dns.dnsStatus, dns.verified) : undefined,
      taskId: dns?.taskId, taskStatusLabel: dns ? taskStatusText(dns.taskStatus) : undefined,
      lastCheckedAt: dns?.lastCheckedAt
    };
  }
  if (['PAUSED', 'SUSPENDED', 'DISABLED', 'FAILED', 'CONFIG_ERROR', 'ERROR', 'DEGRADED'].includes(domain.status)) {
    return {
      title: domainStatusText(domain.status),
      reason: '当前域名服务尚未正常启用，已有 DNS 记录不能作为加速生效依据。',
      nextStep: '请检查套餐与域名服务状态；无需重复添加域名。',
      address: dnsExpectedValuesFor(domain, dns).join(' / ') || '暂无数据',
      phase: '服务状态', tag: domainStatusText(domain.status)
    };
  }
  if (dns) {
    const recordType = dnsRecordTypeFor(domain, dns);
    const recordValue = dnsExpectedValuesFor(domain, dns).join(' / ') || '暂无数据';
    const base = {
      address: recordValue,
      phase: dnsStatusPhase(dns.dnsStatus),
      tag: dnsStatusText(dns.dnsStatus, dns.verified),
      dnsStatusLabel: dnsStatusText(dns.dnsStatus, dns.verified),
      taskId: dns.taskId,
      taskStatusLabel: taskStatusText(dns.taskStatus),
      lastCheckedAt: dns.lastCheckedAt
    };
    if (dns.verified || ['CORRECT', 'VERIFIED', 'ACTIVE'].includes(dns.dnsStatus)) {
      if (!domainPlatformReady(domain, dns)) {
        return {
          ...base,
          title: '平台节点发布未完成',
          reason: dns.platformMessage || 'DNS 接入记录已生效，但平台加速节点尚未完成发布。',
          nextStep: '平台正在自动恢复，请稍后点击“重新检测”；无需修改当前 DNS 记录。',
          phase: '节点发布',
          tag: '等待平台恢复'
        };
      }
      return {
        ...base,
        title: '正常加速',
        reason: '已经检测到可用的 CDN 解析记录。',
        nextStep: configuredAccessAdvice(domain),
        phase: '源站回源',
        tag: 'DNS 已生效'
      };
    }
    if (['CHECKING', 'IN_PROGRESS'].includes(dns.dnsStatus)) {
      return {
        ...base,
        title: '检测中',
        reason: `平台已创建 DNS 检测任务，正在确认 ${recordType} 记录是否指向 HotX CDN。`,
        nextStep: '请稍等片刻，DNS 生效后可再次点击“重新检测”。',
        phase: '接入检测'
      };
    }
    return {
      ...base,
      title: `请先完成域名 ${recordType} 接入`,
      reason: recordType === 'CNAME'
        ? '请按下方已发布的接入地址配置 CNAME；任选一个最终地址，不要为同名添加多个 CNAME。'
        : dns.instructions || '当前 DNS 解析尚未指向 HotX CDN，或解析仍在生效中。',
      nextStep: `登录你的 DNS 服务商控制台，按页面给出的记录名和值添加 ${recordType} 记录后点击“重新检测”。`,
      phase: '接入检测'
    };
  }
  return {
    title: '状态待确认',
    reason: '尚未取得本次 DNS 与节点发布状态，不能确认加速是否生效。',
    nextStep: '请刷新列表或点击“重新检测”；无需重复添加域名。',
    address: dnsExpectedValuesFor(domain).join(' / ') || '暂无数据',
    phase: '接入检测',
    tag: '状态待确认'
  };
});

async function load(): Promise<boolean> {
  if (!viewActive) return false;
  const sequence = ++listReadSequence;
  const session = currentReadSession();
  const isCurrent = () => sameReadSession(session) && sequence === listReadSequence;
  loading.value = true;
  error.value = '';
  try {
    // 域名证书状态回填，更新时间：2026-08-31 CST。
    // 域名列表接口与证书资产接口保持业务解耦；这里按 domainIds 合并只读展示状态，避免证书已经签发并部署后仍误显示“未配置证书”。
    const [domainPage, plan, certificates, services] = await Promise.all([
      consoleApi.portal.domains(),
      consoleApi.plan.current().catch(() => null),
      consoleApi.certificates.list().catch(() => [] as Certificate[]),
      listServices().catch(() => [] as ServiceView[])
    ]);
    // Vue 不会自动取消 setup 中已经启动的 async 续体。路由卸载后必须在每个
    // 网络阶段之间停止，避免旧页面继续读取逐域名源站、发布配置和 DNS。
    if (!isCurrent()) return false;
    // CDN 域名列表源站识别修复，更新时间：2026-08-30 22:56 CST。
    // 后端域名列表不返回 originCount，因此逐域名读取真实源站数量后再执行“仅显示 CDN 域名”的过滤，避免已创建且已有源站的域名在刷新后消失。
    const dnsSequences = new Map((domainPage.domains || []).map(domain => [domain.id, beginDomainDnsRead(domain.id)]));
    const nextDnsByDomainId: Record<number, CustomerDnsResponse> = {};
    const domainsWithRuntimeStatus = await Promise.all((domainPage.domains || []).map(async domain => {
      if (!isCurrent()) return domain;
      const previousOriginCount = page.value?.domains.find(item => item.id === domain.id)?.originCount;
      const [originsResult, activeConfigResult] = await Promise.allSettled([
        consoleApi.origins.list(domain.id),
        consoleApi.publish.activeConfig(domain.id)
      ]);
      if (!isCurrent()) return domain;
      try {
        nextDnsByDomainId[domain.id] = await consoleApi.dns.get(domain.id);
      } catch {
        // A missing current read must never inherit an old successful DNS snapshot.
      }
      const originCount = originsResult.status === 'fulfilled'
        ? originsResult.value.length
        : domain.originCount ?? previousOriginCount ?? 0;
      const withCertificate = mergeDomainCertificateAsset({
        ...domain, originCount, originStatusKnown: originsResult.status === 'fulfilled'
      }, certificates);
      return mergeDomainActiveRuntime(
        withCertificate,
        activeConfigResult.status === 'fulfilled' ? activeConfigResult.value : null
      );
    }));
    if (!isCurrent()) return false;
    const mergedDns = { ...dnsByDomainId.value };
    for (const domain of domainPage.domains || []) {
      if (dnsRequestByDomain.get(domain.id) !== dnsSequences.get(domain.id)) continue;
      if (nextDnsByDomainId[domain.id]) mergedDns[domain.id] = nextDnsByDomainId[domain.id];
      else delete mergedDns[domain.id];
    }
    dnsByDomainId.value = mergedDns;
    originIpRefreshKey.value++;
    page.value = {
      ...domainPage,
      domains: domainsWithRuntimeStatus.map(domain => {
        if (domain.accessMode !== 'REDIRECT_301') return domain;
        const latestFacts = dnsRequestByDomain.get(domain.id) === dnsSequences.get(domain.id)
          ? nextDnsByDomainId[domain.id] : page.value?.domains.find(row => row.id === domain.id);
        return latestFacts ? mergeRootRedirectFields(domain, latestFacts) : domain;
      })
    };
    planState.value = plan;
    unifiedServices.value = services;
    if (!selectedDomainId.value || !domains.value.some(domain => domain.id === selectedDomainId.value)) {
      selectedDomainId.value = domains.value[0]?.id;
    }
    // DNS facts were read for every row in the same generation above.
    if (!isCurrent()) return false;
    return true;
  } catch (e) {
    if (!isCurrent()) return false;
    dnsByDomainId.value = {};
    // A guest's private read may legitimately return 401. The shell already explains login.
    if (session.token || (e as { status?: number })?.status !== 401) {
      error.value = e instanceof Error ? e.message : '域名列表加载失败';
    }
    return false;
  } finally {
    if (isCurrent()) loading.value = false;
  }
}

function clearDomainDnsSnapshot(domainId: number) {
  const next = { ...dnsByDomainId.value };
  delete next[domainId];
  dnsByDomainId.value = next;
}

async function loadDnsStatus(domainId?: number) {
  if (!viewActive || !domainId) {
    return;
  }
  dnsLoadingDomainId.value = domainId;
  const dnsSequence = beginDomainDnsRead(domainId);
  focusedDnsRequest = dnsSequence;
  const session = currentReadSession();
  const sequence = listReadSequence;
  const isCurrent = () => sameReadSession(session) && sequence === listReadSequence && dnsRequestByDomain.get(domainId) === dnsSequence;
  try {
    const dns = await consoleApi.dns.get(domainId);
    if (!isCurrent()) return;
    dnsByDomainId.value = { ...dnsByDomainId.value, [domainId]: dns };
    applyRootFacts(domainId, dns);
  } catch (e) {
    if (!isCurrent()) return;
    clearDomainDnsSnapshot(domainId);
    error.value = e instanceof Error ? e.message : 'DNS 接入状态加载失败';
  } finally {
    if (sameReadSession(session) && focusedDnsRequest === dnsSequence) dnsLoadingDomainId.value = undefined;
  }
}

function updateNavigationDirty() {
  setConsoleNavigationDirty(
    (createFormVisible.value && hasCreateDraft.value)
      || (configFormVisible.value && hasConfigDraft.value)
  );
}

/**
 * V1.0 draft handoff, 2026-09-10 CST, parent 3a2546b4.
 * Confirmed navigation may leave the page, so the in-progress form is stored in
 * sessionStorage and restored on return without leaking it across browser sessions.
 */
function persistCreateFormDraft() {
  if (typeof window === 'undefined' || !createFormVisible.value) return;
  try {
    window.sessionStorage.setItem(CREATE_FORM_DRAFT_STORAGE_KEY, JSON.stringify({
      version: 2,
      serviceType: createServiceType.value,
      freeCdnIntent: freeCdnIntent.value,
      autoRenew: createPlanAutoRenew.value,
      planSelectionTouched: createPlanSelectionTouched.value,
      businessIntentId: createBusinessIntentId.value,
      businessIntentFingerprint: createBusinessIntentFingerprint.value,
      form: { ...createForm }
    }));
  } catch {
    // Storage is best-effort; the live form remains authoritative.
  }
}

function clearCreateFormDraft() {
  try {
    window.sessionStorage.removeItem(CREATE_FORM_DRAFT_STORAGE_KEY);
  } catch {
    // Storage policy must never block closing or submitting the form.
  }
}

function restoreCreateFormDraft() {
  try {
    const raw = window.sessionStorage.getItem(CREATE_FORM_DRAFT_STORAGE_KEY);
    if (!raw) return false;
    const draft = JSON.parse(raw) as {
      version?: number;
      serviceType?: ServiceType;
      freeCdnIntent?: boolean;
      autoRenew?: boolean;
      planSelectionTouched?: boolean;
      businessIntentId?: string;
      businessIntentFingerprint?: string;
      form?: Partial<typeof createForm>;
    };
    if (![1, 2].includes(Number(draft.version)) || !draft.form) return false;
    Object.assign(createForm, draft.form);
    createServiceType.value = draft.serviceType === 'PURE_IP' ? 'PURE_IP' : 'DOMAIN';
    freeCdnIntent.value = Boolean(draft.freeCdnIntent);
    if (draft.version === 2) {
      createPlanAutoRenew.value = draft.autoRenew !== false;
      createPlanSelectionTouched.value = Boolean(draft.planSelectionTouched);
      createBusinessIntentId.value = typeof draft.businessIntentId === 'string' ? draft.businessIntentId : '';
      createBusinessIntentFingerprint.value = typeof draft.businessIntentFingerprint === 'string'
        ? draft.businessIntentFingerprint
        : '';
    }
    createFormVisible.value = true;
    if (!createPlanOptions.value.some(option => option.value === createForm.planCode)) {
      createForm.planCode = initialCreatePlanKey(freeCdnIntent.value ? 'FREE' : 'PAID');
    }
    createPlanSelectionTouched.value = draft.planSelectionTouched === undefined
      ? true
      : Boolean(draft.planSelectionTouched);
    updateNavigationDirty();
    return true;
  } catch {
    clearCreateFormDraft();
    return false;
  }
}

// DNS 名称与 CNAME 记录值复制，更新时间：2026-09-05 CST。优先使用安全剪贴板，并保留旧浏览器兼容方案。
async function writeClipboardText(value: string) {
  if (navigator.clipboard?.writeText) {
    try {
      await navigator.clipboard.writeText(value);
      return;
    } catch {
      // 浏览器可能因权限或非安全上下文拒绝 Clipboard API，继续使用兼容复制。
    }
  }
  const textarea = document.createElement('textarea');
  textarea.value = value;
  textarea.style.position = 'fixed';
  textarea.style.opacity = '0';
  document.body.appendChild(textarea);
  textarea.select();
  const copied = document.execCommand('copy');
  textarea.remove();
  if (!copied) throw new Error('copy failed');
}

async function copyAccessValue(recordValue: string, valueType: 'host' | 'target') {
  if (!normalizedCreateDomain.value) {
    error.value = '请先填写加速域名，再复制系统生成的 DNS 配置值。';
    return;
  }
  try {
    await writeClipboardText(recordValue);
    if (valueType === 'host') {
      dnsHostCopied.value = true;
      ElMessage.success('DNS 主机记录已复制。');
    } else {
      accessGuideCopied.value = true;
      ElMessage.success('DNS 接入记录值已复制。');
    }
    window.setTimeout(() => {
      if (valueType === 'host') {
        dnsHostCopied.value = false;
      } else {
        accessGuideCopied.value = false;
      }
    }, 1800);
  } catch {
    error.value = '复制失败，请手动选择对应内容后复制。';
    ElMessage.error(error.value);
  }
}

function copyPreviewDnsHostRecord() {
  return copyAccessValue(previewDnsHostRecord.value, 'host');
}

function copyPreviewCnameTarget() {
  return copyAccessValue(previewCnameTarget.value, 'target');
}

// Domain onboarding boundary:
// This page owns only domain creation/free-CDN application UX. It may request the
// backend to create a domain and generate the CNAME/onboarding state, but it must
// not take over the certificate asset workflow. Wildcard/free certificate issuance,
// renewal, download and DNS-01 challenge handling stay in the HTTPS certificate
// module. Keeping this boundary prevents a domain UI cleanup from breaking the
// already verified automatic certificate flow.
//
// Product invariant for future repairs:
// - "申请免费 CDN/添加域名" is the domain onboarding flow.
// - "免费泛域名证书申请" is the certificate asset flow.
// - Applying for a free certificate must not auto-bind a domain.
// - Adding/configuring a domain may request certificate help, but only for this
//   current domain and only through the backend's official domain/certificate API.
// - Save/publish is scoped to the changed domain; do not accumulate unrelated page
//   edits and do not trigger a global publish from this customer page.
function updateEntryButtonTilt(event: PointerEvent) {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  const button = event.currentTarget as HTMLElement | null;
  if (!button) return;
  const bounds = button.getBoundingClientRect();
  const horizontalRatio = (event.clientX - bounds.left) / bounds.width;
  const verticalRatio = (event.clientY - bounds.top) / bounds.height;
  button.style.setProperty('--entry-tilt-x', `${((0.5 - verticalRatio) * 8).toFixed(2)}deg`);
  button.style.setProperty('--entry-tilt-y', `${((horizontalRatio - 0.5) * 10).toFixed(2)}deg`);
}

function resetEntryButtonTilt(event: Event) {
  const button = event.currentTarget as HTMLElement | null;
  button?.style.removeProperty('--entry-tilt-x');
  button?.style.removeProperty('--entry-tilt-y');
}

function openCreateForm(options: { freeCdn?: boolean; entryPlan?: unknown } = {}) {
  resetCreateForm();
  createServiceType.value = 'DOMAIN';
  error.value = '';
  createSubmitFeedback.value = '';
  draftNotice.value = null;
  partitionContactFailure.value = '';
  freeCdnDecision.value = null;
  requestedEntryPlan.value = parseDomainPlanEntryKey(options.entryPlan);
  freeCdnIntent.value = Boolean(options.freeCdn) || requestedEntryPlan.value === 'free';
  createForm.planCode = initialCreatePlanKey(freeCdnIntent.value ? 'FREE' : 'PAID', requestedEntryPlan.value);
  if (freeCdnIntent.value && freeCdnQuotaFull.value) {
    error.value = '免费套餐额度已满，请选择其他可用套餐。';
  } else if (requestedEntryPlan.value && requestedEntryPlan.value !== 'free' && !createForm.planCode) {
    error.value = '官网指定套餐暂不可用，请重新选择实时可用套餐。';
  }
  createPlanSelectionTouched.value = false;
  createBusinessIntentId.value = crypto.randomUUID();
  createBusinessIntentFingerprint.value = '';
  createPlanAutoRenew.value = true;
  success.value = freeCdnIntent.value
    ? '已进入免费 CDN 申请流程，请填写域名和源站后提交；无需已有套餐，已有正式套餐不会被降级。'
    : '';
  configFormVisible.value = false;
  createFormVisible.value = true;
  updateNavigationDirty();
}

function openPureIpForm() {
  resetCreateForm();
  createServiceType.value = 'PURE_IP';
  freeCdnIntent.value = false;
  createForm.planCode = initialCreatePlanKey('PAID');
  createPlanSelectionTouched.value = false;
  createBusinessIntentId.value = crypto.randomUUID();
  createBusinessIntentFingerprint.value = '';
  configFormVisible.value = false;
  error.value = '';
  success.value = '';
  createSubmitFeedback.value = '';
  createFormVisible.value = true;
  updateNavigationDirty();
}

function openFreeCdnForm() {
  openCreateForm({ freeCdn: true, entryPlan: 'free' });
}

function cancelCreateForm() {
  createFormVisible.value = false;
  clearCreateFormDraft();
  resetCreateForm();
  createSubmitFeedback.value = '';
  freeCdnIntent.value = false;
  createServiceType.value = 'DOMAIN';
  updateNavigationDirty();
}

async function ensureFreeCdnPlanForDomain(domainName: string) {
  try {
    freeCdnDecision.value = await consoleApi.freeCdn.apply({
      entry: 'DOMAINS',
      userTriggered: true,
      domainName
    });
    if (freeCdnDecision.value?.quota) {
      planState.value = {
        currentPlan: freeCdnDecision.value.plan,
        quota: freeCdnDecision.value.quota,
        servicePolicy: planState.value?.servicePolicy || {
          accelerationEnabled: true,
          preserveBusinessConfiguration: true,
          cdnSwitchMutable: true
        },
        writeAccess: { canModifyBusiness: true }
      };
    }
  } catch (e) {
    const data = apiErrorData(e);
    const reasonCode = String(data?.reasonCode || data?.code || (e as { code?: unknown })?.code || '');
    if (['FREE_PLAN_EXISTS', 'FORMAL_PLAN_EXISTS', 'PLAN_EXISTS'].includes(reasonCode)) {
      return;
    }
    throw e;
  }
}

async function openConfigPanel(row: Domain) {
  error.value = '';
  success.value = '';
  draftNotice.value = null;
  createFormVisible.value = false;
  configDomainId.value = row.id;
  selectedDomainId.value = row.id;
  configForm.domain = row.domain;
  configFormVisible.value = true;
  updateNavigationDirty();
  // 配置入口可见性修复，更新时间：2026-09-04 CST。
  // 列表会在配置面板打开后切换为左右布局；等待 Vue 完成渲染，再把面板滚动到视野并聚焦，
  // 避免长页面或刚关闭其他弹窗时用户点击“配置”却误以为没有响应。这里只改善入口反馈，不改保存接口。
  await nextTick();
  configPanelRef.value?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  configPanelRef.value?.focus({ preventScroll: true });
  void loadDnsStatus(row.id);
}

function closeConfigPanel() {
  configFormVisible.value = false;
  configDomainId.value = undefined;
  configForm.domain = '';
  updateNavigationDirty();
}

async function submitDomainConfig() {
  const domain = configuredDomain.value;
  if (!domain || !configDomainId.value) {
    error.value = '请选择需要配置的域名。';
    return;
  }
  configSubmitting.value = true;
  error.value = '';
  try {
    await loadDnsStatus(domain.id);
    const publish = await publishCurrentDomainConfig(
      domain.id,
      `客户刷新 ${domain.domain} 域名配置后自动发布当前域名配置`
    );
    success.value = [
      '域名配置已刷新，域名创建后不可改名；如需更换域名，请删除后重新添加。',
      publish?.message
    ].filter(Boolean).join(' ');
    selectedDomainId.value = domain.id;
    closeConfigPanel();
    await load();
  } catch (e) {
    error.value = e instanceof Error ? e.message : '域名配置保存失败，请稍后重试。';
  } finally {
    configSubmitting.value = false;
  }
}

async function refreshUnifiedServices() {
  try {
    unifiedServices.value = await listServices();
  } catch (e) {
    error.value = readableErrorReason(e, '四协议服务状态无法判断，请稍后刷新。');
  }
}

function publishUnifiedInBackground(service: ServiceView, label: string) {
  const id = service.id;
  unifiedActionFeedback.value = { ...unifiedActionFeedback.value, [id]: '已保存，正在独立发布各协议' };
  void publishService(id, unifiedRowVersion(service), `publish-${id}-${Date.now()}`)
    .then(operation => {
      unifiedActionFeedback.value = {
        ...unifiedActionFeedback.value,
        [id]: operation.status === 'FAILED'
          ? `发布失败：${operation.errorMessage || operation.errorCode || '无法判断'}`
          : '发布任务已提交，其他页面操作不受影响'
      };
      success.value = `${label}已保存，发布任务已提交；各协议独立生效。`;
      return refreshUnifiedServices();
    })
    .catch(e => {
      const reason = readableErrorReason(e, '无法判断');
      unifiedActionFeedback.value = { ...unifiedActionFeedback.value, [id]: `发布失败：${reason}` };
      error.value = `${label}已保存，但发布失败：${reason}`;
    });
}

async function submitPureIpAccess() {
  if (page.value?.writeAccess?.canModifyBusiness === false) {
    error.value = page.value?.writeAccess?.message || '当前账号尚未开通套餐，请联系商务确认。';
    return;
  }
  if (!createForm.serviceName.trim()) {
    error.value = '请填写纯 IP 服务名称。';
    return;
  }
  if (!selectedFrontendProtocols.value.length) {
    error.value = '请至少选择一个加速协议。';
    return;
  }
  if (!createForm.originAddress.trim()) {
    error.value = '请填写主源站地址。';
    return;
  }
  submitting.value = true;
  createSubmitFeedback.value = '正在保存纯 IP 服务，各协议保存后将独立发布。';
  try {
    const payload = unifiedCreatePayload(selectedFrontendProtocols.value);
    const service = await createService(
      payload as unknown as Parameters<typeof createService>[0],
      `create-pure-ip-${Date.now()}`
    );
    const label = `纯 IP 服务“${service.name}”`;
    success.value = `${label}已保存，正在分配节点公网 IP。`;
    cancelCreateForm();
    await refreshUnifiedServices();
    publishUnifiedInBackground(service, label);
  } catch (e) {
    error.value = `纯 IP 服务保存失败：${readableErrorReason(e, '无法判断')}`;
    createSubmitFeedback.value = '';
  } finally {
    submitting.value = false;
  }
}

async function retryUnifiedPublish(service: ServiceView) {
  publishUnifiedInBackground(service, `服务“${service.name}”`);
}

async function migrateUnifiedPublicIp(service: ServiceView) {
  unifiedActionServiceId.value = service.id;
  try {
    const operation = await migrateService(
      service.id,
      unifiedRowVersion(service),
      `migrate-${service.id}-${Date.now()}`
    );
    unifiedActionFeedback.value = {
      ...unifiedActionFeedback.value,
      [service.id]: operation.status === 'FAILED'
        ? `迁移失败：${operation.errorMessage || operation.errorCode || '无法判断'}`
        : '新旧公网 IP 正在并行验证，确认切换前旧 IP 继续服务'
    };
    await refreshUnifiedServices();
  } catch (e) {
    unifiedActionFeedback.value = {
      ...unifiedActionFeedback.value,
      [service.id]: `迁移失败：${readableErrorReason(e, '无法判断')}`
    };
  } finally {
    unifiedActionServiceId.value = undefined;
  }
}

async function removeUnifiedService(service: ServiceView) {
  try {
    await ElMessageBox.confirm(
      `确认删除纯 IP 服务“${service.name}”吗？各协议将独立下线。`,
      '删除纯 IP 服务',
      { confirmButtonText: '确认删除', cancelButtonText: '取消', type: 'warning' }
    );
  } catch {
    return;
  }
  unifiedActionServiceId.value = service.id;
  try {
    await deleteUnifiedService(service.id, `delete-${service.id}-${Date.now()}`);
    success.value = `纯 IP 服务“${service.name}”已进入安全下线流程。`;
    await refreshUnifiedServices();
  } catch (e) {
    error.value = `纯 IP 服务删除失败：${readableErrorReason(e, '无法判断')}`;
  } finally {
    unifiedActionServiceId.value = undefined;
  }
}

async function submitDomainAccess() {
  if (submitting.value) {
    createSubmitFeedback.value = '正在处理当前提交，请稍候。';
    return;
  }
  error.value = '';
  success.value = '';
  createSubmitFeedback.value = '';
  partitionContactFailure.value = '';
  createSubmitAttempted.value = true;
  const firstIssue = createIssues.value[0];
  if (firstIssue) {
    error.value = firstIssue.message;
    await focusFirstCreateIssue(firstIssue);
    return;
  }
  if (isPureIpCreate.value) {
    await submitPureIpAccess();
    return;
  }
  if (!isConsoleAuthenticated()) {
    try {
      await requireConsoleAuthentication('登录后确认域名申请');
      const loaded = await loadDomainPlans();
      if (!loaded) {
        error.value = '登录成功，但实时套餐加载失败；当前内容已保留，请刷新后重新选择。';
        return;
      }
      if (!selectedCreatePlan.value) {
        if (!error.value) {
          error.value = '登录成功，但官网指定套餐暂不可用；当前内容已保留，请重新选择。';
        }
        return;
      }
      success.value = '登录成功，已刷新积分和套餐信息；请确认当前表单后再次提交。';
    } catch {
      createSubmitFeedback.value = '已取消登录，当前申请尚未提交。';
    }
    return;
  }
  if (page.value?.writeAccess?.canModifyBusiness === false && !freeCdnIntent.value) {
    error.value = page.value?.writeAccess?.message || '当前账号尚未开通套餐，请联系商务确认。';
    return;
  }
  if (!normalizedCreateDomain.value) {
    error.value = '请输入需要添加的加速域名。';
    return;
  }
  if (!selectedFrontendProtocols.value.length) {
    error.value = '请至少选择一个访问端口。';
    return;
  }
  if (isRedirectAccessMode.value && !normalizedRedirectTarget.value) {
    createForm.redirectTarget = previewRedirectTarget.value;
  }
  if (!isRedirectAccessMode.value && !createForm.originAddress.trim()) {
    error.value = '请填写主源站地址。';
    return;
  }
  if (!isRedirectAccessMode.value && !selectedOriginEndpoints.value.length) {
    error.value = '请至少选择一个回源端口。';
    return;
  }
  if (isDomainCreate.value && !isRedirectAccessMode.value) {
    try { validateOriginProtocols(selectedOriginEndpoints.value); }
    catch (cause) { error.value = cause instanceof Error ? cause.message : '请核对主备回源协议。'; return; }
  }
  if (!isRedirectAccessMode.value && customOriginPortIsDuplicate.value) {
    error.value = '自定义端口不能与已经选择的 80 或 443 端口重复。';
    return;
  }
  if (normalizedCreateDomain.value.startsWith('*.') && [createForm.wildcardOriginHost, createForm.wildcardOriginTlsSni].some(value => value.includes('*') || value.includes('$') && value.trim() !== '$host')) {
    error.value = '回源 Host 和 TLS SNI 请填写具体域名，留空即跟随访客访问的子域名，不能填写泛域名或其他变量。';
    return;
  }
  const planChoice = selectedCreatePlan.value;
  if (!planChoice) {
    error.value = '请选择一个可用套餐；添加域名不会默认选择付费套餐。';
    return;
  }
  if (selectedCreatePlanOption.value && isCreatePlanOptionDisabled(selectedCreatePlanOption.value)) {
    error.value = createPlanOptionUnavailableMessage(selectedCreatePlanOption.value);
    return;
  }
  if (planChoice.kind === 'PAID' && (!Number.isSafeInteger(planChoice.planId) || Number(planChoice.planId) <= 0)) {
    error.value = '请登录并刷新实时套餐后重新选择。';
    return;
  }

  submitting.value = true;
  createSubmitFeedback.value = planChoice.kind === 'FREE'
    ? '正在确认免费 CDN 套餐，请稍候。'
    : '正在提交域名接入申请，请稍候。';
  draftNotice.value = null;
  let createdDomain: Domain | undefined;
  let createdMessage = '';
  let certificateMessage = '';
  let protocolMessage = '';
  const originEndpoints = selectedOriginEndpoints.value;
  try {
    if (planChoice.kind === 'FREE') {
      await ensureFreeCdnPlanForDomain(normalizedCreateDomain.value);
      createSubmitFeedback.value = '免费 CDN 套餐已确认，正在创建域名和源站配置。';
    }
    // Certificate request scope:
    // This flag only asks backend to start the current domain's managed-certificate
    // companion flow when product rules allow it. It does not mean the HTTPS page's
    // free wildcard certificate should be created, changed, or auto-bound here.
    const requestManagedCertificate = !isRedirectAccessMode.value && (freeCdnIntent.value
      ? Boolean(createForm.httpsEnabled && !isCreateRootDomain.value)
      : canRequestManagedCertificateForCreate.value);
    const payloadWithoutStableIntent = buildDomainPlanCreatePayload({
      domain: normalizedCreateDomain.value,
      accessMode: createForm.accessMode,
      redirectTarget: isRedirectAccessMode.value ? normalizedRedirectTarget.value || previewRedirectTarget.value : undefined,
      httpEnabled: createForm.httpEnabled,
      httpsEnabled: createForm.httpsEnabled,
      serviceEnabled: true,
      requestManagedCertificate,
      saveDraftOnQuotaExceeded: true,
      form: {
        accelerationRegion: createForm.accelerationRegion,
        originAddress: createForm.originAddress.trim(),
        ...(normalizedCreateDomain.value.startsWith('*.') ? { originHost: createForm.wildcardOriginHost.trim(), originTlsSni: createForm.wildcardOriginTlsSni.trim() } : {}),
        originPort: originEndpoints[0]?.port || 443,
        originProtocol: originEndpoints[0]?.protocol || 'HTTPS',
        sslMode: createForm.sslMode,
        cacheMode: createForm.cacheMode,
        websocketEnabled: createForm.websocketEnabled
      }
    }, planChoice, createPlanAutoRenew.value, createBusinessIntentId.value || 'pending', selectedPartitionSelection.value);
    const requestFingerprint = domainPlanRequestFingerprint(payloadWithoutStableIntent);
    const intent = resolveDomainPlanIntent(
      createBusinessIntentId.value
        ? {
            idempotencyKey: createBusinessIntentId.value,
            fingerprint: createBusinessIntentFingerprint.value
          }
        : null,
      requestFingerprint,
      () => crypto.randomUUID()
    );
    createBusinessIntentId.value = intent.idempotencyKey;
    createBusinessIntentFingerprint.value = intent.fingerprint;
    const payload = {
      ...payloadWithoutStableIntent,
      idempotencyKey: createBusinessIntentId.value
    };
    persistCreateFormDraft();
    const saveResponse = await createDomainWithPartitionConfirmation(payload, planChoice);
    if (!saveResponse) {
      createSubmitFeedback.value = '';
      return;
    }
    createdDomain = mergeDomainCertificate(saveResponse.domain, saveResponse);
    if (isCreateRootDomain.value) {
      const selection = accessPreviewSelection(createForm.planCode);
      if (selection) {
        try {
          const assignment = await pointApi.domainAccessPreview(selection, createdDomain.id);
          if (assignment.actual && assignment.addresses.length) {
            createdDomain = { ...createdDomain, expectedValues: assignment.addresses };
          }
        } catch {
          // 域名已经成功创建；接入IP回读失败只保留等待态，不得回滚或误报创建失败。
        }
      }
    }
    if (!isRedirectAccessMode.value) {
      // 多源站端口持久化，更新时间：2026-08-30 20:46 CST。第一个端点为主源站，其余端点为备用源站并使用独立优先级。
      for (const [index, endpoint] of originEndpoints.entries()) {
        createSubmitFeedback.value = `域名已创建，正在保存源站端点 ${index + 1}/${originEndpoints.length}。`;
        await consoleApi.origins.create(buildOriginCreatePayload({
          originType: index === 0 ? 'PRIMARY' : 'BACKUP',
          originAddress: createForm.originAddress,
          originPort: endpoint.port,
          host: normalizedCreateDomain.value.startsWith('*.') ? createForm.wildcardOriginHost : '',
          tlsSni: normalizedCreateDomain.value.startsWith('*.') ? createForm.wildcardOriginTlsSni : '',
          protocol: endpoint.protocol,
          originPath: '/',
          weight: 100,
          priority: index + 1,
          connectTimeoutMs: 3000,
          readTimeoutMs: 30000,
          sendTimeoutMs: 3000
        }, createdDomain.id, createdDomain.domain || normalizedCreateDomain.value));
      }
    }
    if (!isRedirectAccessMode.value && selectedLayer4Protocols.value.length) {
      try {
        createSubmitFeedback.value = '域名和源站已保存，正在保存 TCP/UDP 协议端点。';
        const payload = unifiedCreatePayload(selectedLayer4Protocols.value, createdDomain.id);
        const service = await createService(
          payload as unknown as Parameters<typeof createService>[0],
          `create-domain-l4-${createdDomain.id}-${Date.now()}`
        );
        protocolMessage = `已保存 ${selectedLayer4Protocols.value.join('、')} 协议端点。`;
        publishUnifiedInBackground(service, `${createdDomain.domain} 的四层端点`);
      } catch (e) {
        protocolMessage = `TCP/UDP 端点保存失败：${readableErrorReason(e, '无法判断')}；HTTP/HTTPS 域名配置不受影响。`;
      }
    }
    // 自动免费证书独立提交，更新时间：2026-08-30 22:13 CST。
    // 域名和源站先落库，再为当前域名单独创建 HTTP 验证证书；证书服务暂不可用时只提示后续处理，不回滚已创建的域名和源站。
    if (createdDomain.accessMode !== 'REDIRECT_301' && requestManagedCertificate) {
      createSubmitFeedback.value = '域名和源站已保存，正在创建自动免费证书申请。';
      try {
        const certificateDomain = createdDomain.domain || normalizedCreateDomain.value;
        await consoleApi.certificates.managed({
          certificateName: `自动免费证书-${certificateDomain}`,
          ...managedCertificateIdentity(certificateDomain),
          domainIds: [createdDomain.id],
          autoRenew: true,
          highRiskAction: {
            acknowledged: true,
            actionLabel: '创建自动免费证书',
            reason: `用户在域名管理页为 ${certificateDomain} 选择自动免费证书`,
            impactPreview: ['仅为当前加速域名创建自动免费证书', '证书申请失败不会删除域名或源站配置']
          }
        });
        certificateMessage = certificateDomain.startsWith('*.') ? '泛域名证书申请已创建，请在证书页完成 DNS 委托；签发并应用到节点后 HTTPS 才生效。' : '自动免费证书申请已创建，接入记录生效后将继续签发。';
      } catch {
        certificateMessage = '域名和源站已保存；自动免费证书暂未创建，接入记录生效后可在证书管理页继续申请。';
      }
      createSubmitFeedback.value = certificateMessage;
    } else if (!isRedirectAccessMode.value && isCreateRootDomain.value && createForm.sslMode === 'wildcardLater') {
      certificateMessage = 'HTTPS 状态为待配置，可前往 HTTPS 证书页申请泛域名证书。';
      createSubmitFeedback.value = `根域名已保存，${certificateMessage}`;
    }
    if (createdDomain.accessMode === 'REDIRECT_301') {
      certificateMessage = [rootCertificateView(createdDomain.certificateState).label,
        rootProbeView(createdDomain.redirectTargetProbe).label,
        rootPublicationView(createdDomain.publicationState).label].join('；') + '。';
    }
      const createdRecordType = dnsRecordTypeFor(createdDomain);
      const createdAccessValues = dnsExpectedValuesFor(createdDomain);
      const createdAccessAddress = createdAccessValues.join(' / ') || '节点正在更新，请完成流程，稍后再来查看接入 IP 地址';
      const createdDnsGuide = createdRecordType === 'CNAME'
        ? '请查看下方接入记录的发布状态，并任选一个已发布的最终地址配置 CNAME。'
        : `请配置 ${createdRecordType} 接入记录：${createdAccessAddress}`;
      createdMessage = isRedirectAccessMode.value
        ? `301 跳转域名已创建，目标地址已保存。域名：${createdDomain.domain}。${createdDnsGuide}`
        : `域名已创建，已保存 ${originEndpoints.length} 个源站端点。域名：${createdDomain.domain}。${createdDnsGuide}`;
    if (protocolMessage) createdMessage = `${createdMessage} ${protocolMessage}`;
    success.value = `${createdMessage}${certificateMessage ? ` ${certificateMessage}` : ''} 正在刷新域名状态。`;
    selectedDomainId.value = createdDomain.id;
    cancelCreateForm();
    const domainListRefreshed = await load();
    if (!domainListRefreshed) {
      error.value = '';
    }
    if (createdDomain.accessMode === 'REDIRECT_301' && !domains.value.some(row => row.id === createdDomain?.id)) {
      page.value = { ...page.value, domains: [...(page.value?.domains || []), createdDomain] };
      selectedDomainId.value = createdDomain.id;
    }
    // Save-is-publish rule:
    // After the customer saves a domain/origin change, publish only this domain's
    // config. Do not batch unrelated domains or wait for a later "publish all" step;
    // that was a major source of accidental cross-page regressions.
    const publish = createdDomain.accessMode === 'REDIRECT_301' ? null : await publishCurrentDomainConfig(
      createdDomain.id,
      `客户创建 ${createdDomain.domain || normalizedCreateDomain.value} 后自动发布当前域名配置`
    );
    success.value = [
      `${createdMessage}${certificateMessage ? ` ${certificateMessage}` : ''} ${domainListRefreshed
        ? '域名列表已刷新。'
        : '配置已保存；最新状态刷新失败，请手动刷新。'}`,
      publish?.message
    ].filter(Boolean).join(' ');
  } catch (e) {
    createSubmitFeedback.value = '';
    const quotaDraft = draftNoticeFromError(e, normalizedCreateDomain.value);
    if (quotaDraft) {
      draftNotice.value = quotaDraft;
      error.value = `域名额度不足，已保存为草稿：${quotaDraft.reason}`;
      success.value = '';
      return;
    }
    createdDomain = createdDomain || createdDomainFromError(e);
    const failure = classifyDomainPlanError(e);
    const message = failure.message;
    if (failure.rechargeRequired && !createdDomain) {
      rechargeFailureMessage.value = message;
      rechargeChoiceVisible.value = true;
    }
    if (failure.contactRequired && !createdDomain) {
      partitionContactFailure.value = message;
      if (failure.retainedPartitionId) {
        try {
          applyDomainPlanOverview(await pointApi.domainPlans());
          const retainedKey = `PARTITION:EXISTING:${failure.retainedPartitionId}`;
          if (createPlanOptions.value.some(option => option.value === retainedKey)) {
            createForm.planCode = retainedKey;
            createPlanSelectionTouched.value = true;
            partitionContactFailure.value = `${message} 已自动改用保留的套餐分区，修改后再次提交不会重复购买。`;
          } else {
            partitionContactFailure.value = `${message} 套餐分区已保留，但列表尚未同步，请刷新后重试或联系我们。`;
          }
        } catch {
          partitionContactFailure.value = `${message} 套餐分区已保留，但最新状态刷新失败，请手动刷新后重试或联系我们。`;
        }
      }
    }
    const partialFailureMessage = createdDomain
      ? `域名已创建，但后续配置保存失败：${message}。你可以稍后继续补充配置；证书签发与域名添加已解耦，免费证书申请不受影响。`
      : `域名创建失败：${message}`;
    error.value = partialFailureMessage;
    if (createdDomain) {
      selectedDomainId.value = createdDomain.id;
      success.value = '域名已创建，请查看接入记录的发布状态，并任选一个已发布目标配置 DNS。';
      await load();
      error.value = partialFailureMessage;
    }
  } finally {
    submitting.value = false;
  }
}

async function createDomainWithPartitionConfirmation(
  payload: ReturnType<typeof buildDomainPlanCreatePayload>,
  choice: DomainPlanChoice
) {
  try {
    return await consoleApi.domains.createWithFlow(payload);
  } catch (reason) {
    const failure = classifyDomainPlanError(reason);
    if (!failure.quotaFull || payload.packageSelection.mode !== 'EXISTING' || !choice.planId) {
      throw reason;
    }
    try {
      await ElMessageBox.confirm(failure.message, '套餐域名额度已满', {
        confirmButtonText: '确定购买',
        cancelButtonText: '返回',
        showClose: false,
        closeOnClickModal: false,
        closeOnPressEscape: false
      });
    } catch {
      return null;
    }
    const packageSelection: DomainPackageSelection = {
      mode: 'NEW',
      planId: choice.planId,
      periodCount: 1,
      autoRenew: createPlanAutoRenew.value,
      purchaseConfirmed: true
    };
    createForm.planCode = `PARTITION:NEW:${choice.planId}`;
    const retryPayloadWithoutStableIntent: ReturnType<typeof buildDomainPlanCreatePayload> = {
      ...payload,
      packageSelection
    };
    const retryFingerprint = domainPlanRequestFingerprint(retryPayloadWithoutStableIntent);
    const retryIntent = resolveDomainPlanIntent(
      {
        idempotencyKey: payload.idempotencyKey,
        fingerprint: createBusinessIntentFingerprint.value
      },
      retryFingerprint,
      () => crypto.randomUUID()
    );
    createBusinessIntentId.value = retryIntent.idempotencyKey;
    createBusinessIntentFingerprint.value = retryIntent.fingerprint;
    const retryPayload: ReturnType<typeof buildDomainPlanCreatePayload> = {
      ...retryPayloadWithoutStableIntent,
      idempotencyKey: retryIntent.idempotencyKey
    };
    persistCreateFormDraft();
    return consoleApi.domains.createWithFlow(retryPayload);
  }
}

async function reissueAutoCertificate(row: Domain) {
  // Domain page reissue boundary:
  // This button retries the already-associated automatic certificate for this domain.
  // It must not recreate the free wildcard certificate asset, must not alter DNS CNAME
  // delegation records, and must not bind certificates to other domains.
  const state = domainCertificateView(row);
  if (!state.certificateId) {
    error.value = '当前域名没有可重签的自动证书记录，请前往 HTTPS 证书页重新申请。';
    return;
  }
  certificateActionDomainId.value = row.id;
  error.value = '';
  success.value = '';
  try {
    await consoleApi.certificates.autoReissue(state.certificateId, {
      reason: `客户在域名管理页触发 ${row.domain} 自动证书重签`,
      highRiskAction: {
        acknowledged: true,
        actionLabel: '自动证书重签',
        reason: `客户在域名管理页重签 ${row.domain} 的自动证书`,
        impactPreview: ['仅重新发起该域名自动证书签发', '不会删除域名、源站或 DNS 接入配置']
      }
    });
    success.value = `${row.domain} 自动证书重签已提交，域名配置保持不变。`;
    await load();
  } catch (e) {
    error.value = e instanceof Error ? e.message : '自动证书重签失败，请稍后重试。';
  } finally {
    certificateActionDomainId.value = undefined;
  }
}

async function copyAccessAddress(address = diagnosis.value.address) {
  if (!address || address === '暂无数据' || address === rootAddressWaiting || accessCopyCountdown.value > 0) return;
  try {
    await writeClipboardText(address);
    success.value = '接入记录已复制，可直接粘贴到 DNS 服务商。';
    ElMessage.success(success.value);
    accessCopyCountdown.value = 5;
    if (accessCopyTimer) clearInterval(accessCopyTimer);
    accessCopyTimer = setInterval(() => {
      accessCopyCountdown.value -= 1;
      if (accessCopyCountdown.value <= 0 && accessCopyTimer) {
        clearInterval(accessCopyTimer);
        accessCopyTimer = undefined;
      }
    }, 1000);
  } catch {
    error.value = '复制失败，请手动选择接入记录后复制。';
  }
}

async function recheckDomain(row = focusedDomain.value) {
  if (!row) {
    return;
  }
  const dnsSequence = beginDomainDnsRead(row.id);
  recheckRequest = dnsSequence;
  const session = currentReadSession();
  const isCurrent = () => sameReadSession(session) && dnsRequestByDomain.get(row.id) === dnsSequence;
  error.value = '';
  success.value = '';
  recheckingDomainId.value = row.id;
  try {
    if (row.accessMode === 'REDIRECT_301') {
      const result = await consoleApi.rootRedirects.recheck(row.id);
      if (!isCurrent()) return;
      dnsByDomainId.value = { ...dnsByDomainId.value, [row.id]: result.dns };
      applyRootFacts(row.id, result.redirect);
      selectedDomainId.value = row.id;
      success.value = `重新检测已完成：${rootCertificateView(result.redirect.certificateState).label}；${rootProbeView(result.redirect.redirectTargetProbe).label}；${rootPublicationView(result.redirect.publicationState).label}。`;
      return;
    }
    let dns = await consoleApi.dns.recheck(row.id);
    if (!isCurrent()) return;
    dnsByDomainId.value = { ...dnsByDomainId.value, [row.id]: dns };
    selectedDomainId.value = row.id;
    const nextStep = ['CHECKING', 'IN_PROGRESS'].includes(dns.dnsStatus)
      ? '请稍等片刻，DNS 生效后可再次点击“重新检测”。'
      : `根据检测结果完成 ${dnsRecordTypeFor(row, dns)} 记录配置后再次点击“重新检测”。`;
    success.value = dns.taskId
      ? `检测任务已提交 #${dns.taskId}（已创建 DNS 检测任务 #${dns.taskId}），当前状态：${dnsStatusText(dns.dnsStatus, dns.verified)}。下一步建议：${nextStep}`
      : `已发起 DNS 重新检测，当前状态：${dnsStatusText(dns.dnsStatus, dns.verified)}。下一步建议：${nextStep}`;
    // One mutation starts the task; bounded reads observe completion without re-enqueueing it.
    for (let attempt = 0; attempt < 15 && ['CHECKING', 'IN_PROGRESS'].includes(dns.dnsStatus); attempt += 1) {
      await new Promise(resolve => setTimeout(resolve, 2000));
      if (!isCurrent()) return;
      dns = await consoleApi.dns.get(row.id);
      if (!isCurrent()) return;
      dnsByDomainId.value = { ...dnsByDomainId.value, [row.id]: dns };
      if (!['CHECKING', 'IN_PROGRESS'].includes(dns.dnsStatus)) {
        success.value = `检测已完成：DNS ${dnsStatusText(dns.dnsStatus, dns.verified)}；${domainStatusText(domainDisplayStatus(row))}。`;
      }
    }
  } catch (e) {
    if (!isCurrent()) return;
    clearDomainDnsSnapshot(row.id);
    error.value = e instanceof Error ? e.message : '重新检测失败，请稍后重试。';
  } finally {
    if (sameReadSession(session) && recheckRequest === dnsSequence) recheckingDomainId.value = undefined;
  }
}

function focusDomain(row: Domain) {
  selectedDomainId.value = row.id;
  void loadDnsStatus(row.id);
}

async function pause(row: Domain) {
  togglingDomainId.value = row.id;
  error.value = '';
  let successMessage = '';
  try {
    applyDomainPlanOverview(await pointApi.pauseDomainPlan(row.id));
    successMessage = `${row.domain} 已暂停并进入 15 天保护期；源站、证书和节点绑定均已保留。`;
    success.value = successMessage;
    selectedDomainId.value = row.id;
  } catch (e) {
    error.value = e instanceof Error ? e.message : '域名暂停失败，请稍后重试。';
    return;
  } finally {
    togglingDomainId.value = undefined;
  }
  if (!await load()) {
    error.value = '';
    success.value = `${successMessage} 操作已成功，最新状态刷新失败，请手动刷新。`;
  }
}

async function enable(row: Domain) {
  togglingDomainId.value = row.id;
  error.value = '';
  let successMessage = '';
  try {
    applyDomainPlanOverview(await pointApi.resumeDomainPlan(row.id));
    successMessage = `${row.domain} 已恢复调度，原有配置将继续使用。`;
    success.value = successMessage;
    selectedDomainId.value = row.id;
  } catch (e) {
    error.value = e instanceof Error ? e.message : '域名启用失败，请稍后重试。';
    return;
  } finally {
    togglingDomainId.value = undefined;
  }
  if (!await load()) {
    error.value = '';
    success.value = `${successMessage} 操作已成功，最新状态刷新失败，请手动刷新。`;
  }
}

// CDN 域名删除操作，更新时间：2026-08-30 15:35 CST。
// 删除前必须二次确认；确认后只调用域名管理已有的真实删除接口，并重新读取整页数据，避免前端自行删行造成状态错位。
async function deleteCdnDomain(row: Domain) {
  const confirmationPhrase = `删除 ${row.domain}`;
  try {
    // 高风险删除保护，更新时间：2026-09-04 20:47 CST。沿用后台节点删除的完整确认短语规则，
    // 防止误触；套餐剩余时间和已扣积分均不退还，历史审计记录仍由后端保留。
    await ElMessageBox.prompt(
      `删除后配置、套餐剩余时间和已扣积分均不退还。若只是更换域名，请使用“配置”。请输入“${confirmationPhrase}”继续。`,
      '确认删除 CDN 域名',
      {
        confirmButtonText: '确认删除',
        cancelButtonText: '取消',
        type: 'warning',
        inputPlaceholder: confirmationPhrase,
        inputValidator: value => value === confirmationPhrase || `请输入完整确认短语：${confirmationPhrase}`,
        closeOnClickModal: false
      }
    );
  } catch {
    return;
  }

  deletingDomainId.value = row.id;
  error.value = '';
  success.value = '';
  let successMessage = '';
  try {
    await pointApi.deleteDomainPlan(row.id);
    if (configDomainId.value === row.id) {
      closeConfigPanel();
    }
    if (selectedDomainId.value === row.id) {
      selectedDomainId.value = undefined;
    }
    successMessage = `${row.domain} 已从 CDN 域名列表删除。`;
    success.value = successMessage;
  } catch (e) {
    error.value = e instanceof Error ? e.message : '域名删除失败，请稍后重试。';
    return;
  } finally {
    deletingDomainId.value = undefined;
  }
  const [overviewResult, domainListResult] = await Promise.allSettled([
    pointApi.domainPlans(),
    load()
  ]);
  if (overviewResult.status === 'fulfilled') {
    applyDomainPlanOverview(overviewResult.value);
  }
  const domainListFresh = domainListResult.status === 'fulfilled' && domainListResult.value;
  if (overviewResult.status === 'rejected' || !domainListFresh) {
    error.value = '';
    success.value = `${successMessage} 操作已成功，最新状态刷新失败，请手动刷新。`;
  }
}

function resetCreateForm() {
  const defaults = createDefaultProtocolSelection();
  createForm.serviceName = '';
  createForm.domain = '';
  createForm.accessMode = 'CDN';
  accessModeManuallySelected.value = false;
  accessGuideAnimationKey.value += 1;
  createForm.deploymentMode = 'SINGLE_NODE';
  createForm.accelerationRegion = 'APAC';
  createForm.redirectTarget = '';
  createForm.httpEnabled = defaults.httpEnabled;
  createForm.httpsEnabled = defaults.httpsEnabled;
  createForm.planCode = '';
  createPlanAutoRenew.value = true;
  createPlanSelectionTouched.value = false;
  createBusinessIntentId.value = '';
  createBusinessIntentFingerprint.value = '';
  partitionContactFailure.value = '';
  createForm.originAddress = '';
  createForm.wildcardOriginHost = '';
  createForm.wildcardOriginTlsSni = '';
  createForm.originPort443Enabled = defaults.originPort443Enabled;
  createForm.originPort80Enabled = defaults.originPort80Enabled;
  createForm.customOriginPortEnabled = false;
  createForm.originPort = 8443;
  createForm.originProtocol = 'HTTPS';
  createForm.sslMode = 'managed';
  createForm.cacheMode = 'default';
  createForm.websocketEnabled = true;
  createForm.tcpEnabled = defaults.tcpEnabled;
  createForm.udpEnabled = defaults.udpEnabled;
  createForm.tcpListenPort = 10000;
  createForm.udpListenPort = 10000;
  createForm.tcpOriginPort = 10000;
  createForm.udpOriginPort = 10000;
  createForm.pureIpHttpOriginPort = 80;
  createForm.pureIpHttpsOriginPort = 443;
  createForm.preferredOriginProtocol = 'HTTPS';
  createForm.preferredOriginPort = 443;
  previousTcpListenPort = 10000;
  previousUdpListenPort = 10000;
  createSubmitAttempted.value = false;
  Object.keys(createFieldTouched).forEach(key => delete createFieldTouched[key]);
}

function shouldOpenFreeCdnFromLocation() {
  const params = new URLSearchParams(window.location.search);
  // 防回归：官网使用 freeCdn；applyFreeCdn 是旧链接兼容参数，二者都只能展开表单，不能自动提交。
  return params.get('freeCdn') === '1' || params.get('applyFreeCdn') === '1';
}

function applyRootFacts(id: number, facts: RootRedirectFields) {
  if (!page.value) return;
  page.value = { ...page.value, domains: page.value.domains.map(row => row.id === id && row.accessMode === 'REDIRECT_301'
    ? mergeRootRedirectFields(row, facts) : row) };
}

function mergeDomainCertificate(domain: Domain, response: DomainSaveResponse): Domain {
  domain = mergeRootRedirectFields(domain, response);
  if (!response.certificate) {
    return domain;
  }
  return {
    ...domain,
    certificate: response.certificate,
    certificateStatus: response.certificate.status
  };
}

// 活动配置运行态回填，更新时间：2026-08-31 CST。
// 域名基础接口没有持久化 HTTP/HTTPS 开关；正式发布成功后以活动配置包和可用证书为准，避免节点已监听 80/443 但列表仍显示“待启用”。
function mergeDomainActiveRuntime(
  domain: Domain,
  activeConfig: { activeConfigPackageId?: number; status?: string } | null
): Domain {
  if (domain.accessMode === 'REDIRECT_301') return domain;
  const hasActivePackage = Boolean(
    activeConfig?.activeConfigPackageId
      && ['ACTIVE', 'PUBLISHED', 'SUCCEEDED'].includes(String(activeConfig.status ?? '').toUpperCase())
  );
  if (!hasActivePackage) {
    return domain;
  }
  const certificateStatus = normalizedCertificateStatus(domain);
  const hasUsableCertificate = ['ISSUED', 'VALID', 'ACTIVE', 'BOUND'].includes(certificateStatus);
  return {
    ...domain,
    hasActiveRuntime: true,
    serviceEnabled: true,
    httpEnabled: true,
    httpsEnabled: hasUsableCertificate || domain.httpsEnabled === true
  };
}

// 域名证书资产关联，更新时间：2026-08-31 CST。
// 优先展示已签发资产，其次展示正在处理或失败的最新可见状态；这里只补充域名页视图字段，不修改证书或泛域名申请流程。
function mergeDomainCertificateAsset(domain: Domain, certificates: Certificate[]): Domain {
  const related = certificates.filter(certificate => certificate.domainIds?.includes(domain.id));
  const certificate = related.find(item => ['ISSUED', 'VALID', 'ACTIVE', 'BOUND'].includes(item.status.toUpperCase()))
    ?? related.find(item => ['ISSUING', 'PENDING', 'PENDING_DNS', 'WAITING_DNS', 'CHECKING', 'IN_PROGRESS', 'PROCESSING'].includes(item.status.toUpperCase()))
    ?? related[0];
  if (!certificate) {
    return domain;
  }
  return {
    ...domain,
    certificateId: certificate.id,
    certificateSource: certificate.source,
    certificateStatus: certificate.status as Domain['certificateStatus'],
    certificateFailureReason: certificate.latestFailureReason || certificate.lastError
  };
}

function deriveRootDomain(domain: string) {
  const parts = domain.replace(/^\*\./, '').split('.').filter(Boolean);
  if (parts.length <= 2) {
    return parts.join('.');
  }
  return parts.slice(-2).join('.');
}

function planStatusText(status?: string) {
  const mapping: Record<string, string> = {
    ACTIVE: '生效中',
    PAUSED: '已暂停',
    EXPIRED: '已过期',
    NO_PLAN: '未开通'
  };
  return status ? mapping[status] || status : '待确认';
}

function servicePolicyText(plan: ConsolePlanResponse | null) {
  const reason = plan?.servicePolicy?.reasonCode;
  const mapping: Record<string, string> = {
    PLAN_REQUIRED: '当前账号尚未开通 CDN 套餐，普通域名创建需要先开通套餐；免费 SSL 可直接前往 HTTPS 证书页申请。',
    PLAN_PAUSED: '当前套餐已暂停，业务配置会保留，恢复套餐后可继续修改。',
    PLAN_EXPIRED: '当前套餐已过期，业务配置会保留，续费后可继续修改。'
  };
  return reason ? mapping[reason] || reason : '使用当前账号已有套餐创建域名。';
}

function freeCdnDecisionMessage(decision: FreeCdnApplyResponse) {
  const mapping: Record<string, string> = {
    OPEN_FREE_PLAN: '免费 CDN 套餐已开通，将使用免费套餐创建域名。',
    KEEP_FREE_PLAN: '当前账号已有免费 CDN 套餐，将继续使用免费套餐创建域名。',
    KEEP_EXISTING_FORMAL_PLAN: '当前账号已有正式套餐，将保留正式套餐，不会降级为免费套餐。',
    REJECT_NEEDS_USER_ACTION: '需要用户主动点击申请免费 CDN 后才能继续。'
  };
  return readableApiMessage(stringField(decision, ['message', 'reason']) || mapping[decision.action] || '免费 CDN 套餐已确认。');
}

function stringField(source: unknown, fields: string[]) {
  return firstStringField(source, fields);
}

function readableApiMessage(message: string) {
  const mapping: Record<string, string> = {
    'Network Error': '网络连接失败，请检查网络后重试。',
    'Request failed with status code 401': '登录状态已失效，请重新登录。',
    'Request failed with status code 403': '当前账号没有执行该操作的权限。',
    'Request failed with status code 404': '请求的资源不存在或当前版本暂未开放。',
    'Request failed with status code 409': '当前资源状态冲突，请刷新后重试。',
    'Request failed with status code 429': '操作过于频繁，请稍后再试。',
    'Request failed with status code 500': '服务器暂时不可用，请稍后重试。'
  };
  return mapping[message] || message;
}

function domainStatusText(status: string) {
  const mapping: Record<string, string> = {
    PUBLICATION_FAILED: '节点发布失败',
    PUBLICATION_PENDING: '节点发布中',
    READINESS_UNKNOWN: '状态待确认',
    ENABLED: '运行正常',
    ACTIVE: '运行正常',
    RUNNING: '运行正常',
    PENDING_DNS: '等待接入',
    WAITING_DNS: '等待接入',
    CREATED: '等待接入',
    CHECKING: '正在检测',
    ISSUING: '证书申请中',
    FAILED: '配置异常',
    CONFIG_ERROR: '配置异常',
    ERROR: '配置异常',
    PAUSED: '已暂停',
    SUSPENDED: '已暂停',
    DISABLED: '已暂停',
    DEGRADED: '部分异常'
  };
  return mapping[status] || status || '-';
}

// Administrative ENABLED is intent, not proof that DNS and node publication completed.
function domainPlatformReady(row: Domain, dns?: CustomerDnsResponse): boolean {
  return dns?.platformReady === true || (dns?.platformReady === undefined && row.hasActiveRuntime === true);
}

function domainDisplayStatus(row: Domain): string {
  if (row.accessMode === 'REDIRECT_301') return row.status;
  if (['PAUSED', 'SUSPENDED', 'DISABLED', 'FAILED', 'CONFIG_ERROR', 'ERROR', 'DEGRADED'].includes(row.status)) return row.status;
  const dns = dnsByDomainId.value[row.id];
  if (!dns) return 'READINESS_UNKNOWN';
  if (dns.platformReady === false) {
    return ['FAILED', 'BLOCKED'].includes(dns.platformPhase || '') ? 'PUBLICATION_FAILED' : 'PUBLICATION_PENDING';
  }
  if (!domainPlatformReady(row, dns)) return 'PUBLICATION_PENDING';
  if (!(dns.verified || ['CORRECT', 'VERIFIED', 'ACTIVE'].includes(dns.dnsStatus))) return 'PENDING_DNS';
  return 'ACTIVE';
}

function domainStatusGroup(row: Domain) {
  const status = domainDisplayStatus(row);
  if (['ENABLED', 'ACTIVE', 'RUNNING'].includes(status)) return 'NORMAL';
  if (['PENDING_DNS', 'WAITING_DNS', 'CREATED', 'CHECKING', 'ISSUING', 'PUBLICATION_PENDING', 'READINESS_UNKNOWN'].includes(status)) return 'ONBOARDING';
  if (['PAUSED', 'SUSPENDED', 'DISABLED'].includes(status)) return 'PAUSED';
  return 'ABNORMAL';
}

function dnsStatusText(status?: string, verified = false) {
  if (verified) return '接入正常';
  const mapping: Record<string, string> = {
    CORRECT: '接入正常',
    VERIFIED: '接入正常',
    ACTIVE: '接入正常',
    CHECKING: '检测中',
    IN_PROGRESS: '检测中',
    PENDING: '等待接入',
    PENDING_DNS: '等待接入',
    WAITING_DNS: '等待接入',
    NOT_FOUND: '未检测到记录',
    MISMATCH: '解析不匹配',
    FAILED: '检测失败',
    ERROR: '检测失败'
  };
  return mapping[status || ''] || status || '暂无数据';
}

function taskStatusText(status?: string) {
  const mapping: Record<string, string> = {
    PENDING: '排队中',
    RUNNING: '检测中',
    SUCCEEDED: '已完成',
    FAILED: '检测失败',
    CANCELLED: '已取消'
  };
  return status ? mapping[status] || status : undefined;
}

function dnsStatusPhase(status?: string) {
  if (['CORRECT', 'VERIFIED', 'ACTIVE'].includes(status || '')) {
    return '源站回源';
  }
  return '接入检测';
}

function statusClass(status: string) {
  if (['ENABLED', 'ACTIVE', 'RUNNING'].includes(status)) return 'status-ok';
  if (['PENDING_DNS', 'WAITING_DNS', 'CREATED', 'CHECKING', 'ISSUING', 'PUBLICATION_PENDING', 'READINESS_UNKNOWN'].includes(status)) return 'status-waiting';
  if (['PAUSED', 'SUSPENDED', 'DISABLED'].includes(status)) return 'status-paused';
  if (['FAILED', 'CONFIG_ERROR', 'ERROR', 'DEGRADED', 'PUBLICATION_FAILED'].includes(status)) return 'status-bad';
  return 'status-muted';
}

function domainCertificateView(row: Domain): CertificateView {
  if (row.accessMode === 'REDIRECT_301') return { ...rootCertificateView(row.certificateState),
    certificateId: row.certificateState?.certificateId ?? undefined, canReissue: false };
  const source = normalizedCertificateSource(row);
  const status = normalizedCertificateStatus(row);
  const reason = firstStringField(row, [
    'certificateFailureReason',
    'certificateLastError',
    'certificateError',
    'failureReason',
    'errorReason',
    'acmeFailureReason',
    'acmeLastError',
    'latestFailureReason',
    'lastCertificateError'
  ]) || firstStringField(certificateObject(row), [
    'latestFailureReason',
    'failureReason',
    'errorReason',
    'lastError',
    'message'
  ]);
  const certificateId = numberField(row, [
    'certificateId',
    'managedCertificateId',
    'currentCertificateId'
  ]) || numberField(certificateObject(row), ['id', 'certificateId', 'managedCertificateId']);
  const autoReissueAvailable = booleanField(row, [
    'autoReissueAvailable',
    'certificateAutoReissueAvailable'
  ]) ?? booleanField(certificateObject(row), ['autoReissueAvailable']);

  if (['CUSTOMER_UPLOAD', 'CUSTOMER_UPLOADED', 'UPLOAD', 'UPLOADED', 'CUSTOM'].includes(source)) {
    return { label: '客户上传证书', tone: 'ok', certificateId, reason, canReissue: false };
  }
  if (['ISSUED', 'VALID', 'ACTIVE', 'BOUND'].includes(status)) {
    return { label: '自动证书已签发', tone: 'ok', certificateId, reason, canReissue: false };
  }
  if (['ISSUING', 'PENDING', 'PENDING_DNS', 'WAITING_DNS', 'CHECKING', 'IN_PROGRESS', 'PROCESSING'].includes(status)) {
    return { label: '自动证书签发中', tone: 'waiting', certificateId, reason, canReissue: false };
  }
  if (['FAILED', 'ERROR', 'REJECTED'].includes(status)) {
    return {
      label: '自动证书失败',
      tone: 'bad',
      certificateId,
      reason,
      canReissue: Boolean(certificateId) && autoReissueAvailable !== false
    };
  }
  return { label: '未配置证书', tone: 'muted', certificateId, reason, canReissue: false };
}

function normalizedCertificateSource(row: Domain) {
  return (firstStringField(row, ['certificateSource', 'certSource', 'sslSource'])
    || firstStringField(certificateObject(row), ['source'])
    || '').trim().toUpperCase();
}

function normalizedCertificateStatus(row: Domain) {
  return (firstStringField(row, ['certificateStatus', 'certStatus', 'sslStatus', 'managedCertificateStatus', 'acmeStatus'])
    || firstStringField(certificateObject(row), ['status', 'acmeStatus'])
    || '').trim().toUpperCase();
}

function certificateObject(row: Domain) {
  const value = (row as Record<string, unknown>).certificate;
  return value && typeof value === 'object' ? value as Partial<Certificate> & Record<string, unknown> : undefined;
}

function firstStringField(source: unknown, fields: string[]) {
  if (!source || typeof source !== 'object') {
    return undefined;
  }
  const record = source as Record<string, unknown>;
  for (const field of fields) {
    const value = record[field];
    if (typeof value === 'string' && value.trim()) {
      return value;
    }
  }
  return undefined;
}

function numberField(source: unknown, fields: string[]) {
  if (!source || typeof source !== 'object') {
    return undefined;
  }
  const record = source as Record<string, unknown>;
  for (const field of fields) {
    const value = record[field];
    if (typeof value === 'number' && Number.isFinite(value)) {
      return value;
    }
  }
  return undefined;
}

function booleanField(source: unknown, fields: string[]) {
  if (!source || typeof source !== 'object') {
    return undefined;
  }
  const record = source as Record<string, unknown>;
  for (const field of fields) {
    const value = record[field];
    if (typeof value === 'boolean') {
      return value;
    }
  }
  return undefined;
}

function draftNoticeFromError(errorValue: unknown, domain: string): DraftNotice | null {
  const data = apiErrorData(errorValue);
  const draftSaved = data?.draftSaved === true
    || data?.domainDraftSaved === true
    || Boolean(data?.draft && typeof data.draft === 'object');
  const code = typeof (errorValue as { code?: unknown })?.code === 'string'
    ? String((errorValue as { code?: unknown }).code)
    : '';
  const message = errorValue instanceof Error ? errorValue.message : '';
  const quotaLike = code.includes('QUOTA')
    || code.includes('LIMIT')
    || message.includes('额度不足')
    || message.includes('域名额度');
  if (!draftSaved || !quotaLike) {
    return null;
  }
  const draft = data?.draft && typeof data.draft === 'object' ? data.draft as Record<string, unknown> : undefined;
  const draftId = data?.draftId || data?.domainDraftId || draft?.id;
  return {
    domain,
    draftId: typeof draftId === 'string' || typeof draftId === 'number' ? draftId : undefined,
    reason: firstStringField(data, ['reason', 'message']) || message || '当前套餐域名额度不足，正式保存失败。'
  };
}

function createdDomainFromError(errorValue: unknown) {
  const data = apiErrorData(errorValue);
  const candidate = data?.createdDomain || data?.domain;
  if (candidate && typeof candidate === 'object' && typeof (candidate as Domain).id === 'number') {
    return candidate as Domain;
  }
  return undefined;
}

function apiErrorData(errorValue: unknown) {
  const data = (errorValue as { data?: unknown })?.data;
  return data && typeof data === 'object' ? data as Record<string, unknown> : undefined;
}

function readableErrorReason(errorValue: unknown, fallback: string) {
  const data = apiErrorData(errorValue);
  return readableApiMessage(firstStringField(data, ['reason', 'message', 'error'])
    || (errorValue instanceof Error && errorValue.message ? errorValue.message : '')
    || fallback);
}

function draftRoute() {
  return {
    path: '/domains',
    query: {
      tab: 'drafts',
      domain: draftNotice.value?.domain || normalizedCreateDomain.value,
      ...(draftNotice.value?.draftId ? { draftId: String(draftNotice.value.draftId) } : {})
    }
  };
}

function contactAdminRoute() {
  return {
    path: '/support',
    query: {
      topic: 'domain-quota',
      domain: draftNotice.value?.domain || normalizedCreateDomain.value
    }
  };
}

function displayTimeOrDash(value: unknown) {
  if (value === undefined || value === null || value === '') {
    return '-';
  }
  return displayDateTime(value);
}

function rootDomainSummaryText(row: Domain) {
  return row.rootDomain ? `主域名 ${row.rootDomain}` : '主域名待识别';
}

function accessAddressText(row: Domain) {
  return dnsExpectedValuesFor(row).join(' / ') || '等待生成接入记录';
}

function dnsRecordTypeFor(row: Domain, dns = dnsByDomainId.value[row.id]) {
  if (isRootDomain(row)) return 'A';
  return (dns?.recordType || row.recordType || fallbackRecordType(row)).trim().toUpperCase();
}

function fallbackRecordType(row: Domain) {
  // Record type is a domain-access decision. Normal CDN access uses CNAME; root-domain
  // redirect can use A according to backend DNS diagnosis. Do not copy ACME DNS-01
  // certificate CNAME logic into this function.
  return row.accessMode === 'REDIRECT_301' && row.rootDomain && row.domain === row.rootDomain ? 'A' : 'CNAME';
}

function dnsExpectedValuesFor(row: Domain, dns = dnsByDomainId.value[row.id]) {
  const values = dns?.expectedValues || row.expectedValues;
  if (isRootDomain(row)) return returnedIpv4Values(values || []);
  if (Object.prototype.hasOwnProperty.call(frozenAccessTargets.value, row.id)) return frozenAccessTargets.value[row.id];
  if (values?.length) {
    return values.filter(Boolean);
  }
  return [dns?.cnameTarget || row.cnameTarget].filter(Boolean) as string[];
}

function accessModeText(row: Domain) {
  return row.accessMode === 'REDIRECT_301' ? '301 跳转' : 'CDN 加速';
}

function serviceEnabledText(row: Domain) {
  return row.serviceEnabled === false || ['PAUSED', 'SUSPENDED', 'DISABLED'].includes(row.status) ? '服务暂停' : '服务启用';
}

function redirectSummaryText(row: Domain) {
  if (row.accessMode !== 'REDIRECT_301') {
    return '无跳转';
  }
  return row.redirectTarget ? `跳转到 ${row.redirectTarget}` : '301 目标待配置';
}

function originSummaryText(row: Domain) {
  const count = Number(row.originCount ?? 0);
  return count > 0 ? `${count} 个源站` : '未配置源站';
}

function protocolSummaryText(label: 'HTTP' | 'HTTPS', enabled?: boolean) {
  return enabled ? `${label} 已开启` : `${label} 待启用`;
}

function lastCheckedSummaryText(row: Domain) {
  const checkedAt = row.lastCheckedAt || row.updatedAt;
  return checkedAt ? displayDateTime(checkedAt) : '等待检测';
}

function freeSslRoute(row: Domain) {
  if (row.accessMode === 'REDIRECT_301' || domainCertificateView(row).tone !== 'muted'
    || ['EXPIRED', 'REVOKED'].includes(normalizedCertificateStatus(row))) return { path: '/https' };
  return {
    path: '/https',
    query: { domain: row.domain }
  };
}

function freeSslCtaText(row: Domain) {
  if (row.accessMode === 'REDIRECT_301') return '查看证书验证';
  if (['EXPIRED', 'REVOKED'].includes(normalizedCertificateStatus(row))) return '处理证书问题';
  const certificate = domainCertificateView(row);
  if (certificate.tone === 'ok') return '查看证书';
  if (certificate.tone === 'waiting') return '查看证书进度';
  if (certificate.tone === 'bad') return '处理证书问题';
  return isRootDomain(row) ? '申请泛域名证书' : '申请免费证书';
}

function sslModeSummaryText(mode: typeof createForm.sslMode) {
  const mapping: Record<typeof createForm.sslMode, string> = {
    managed: '自动免费证书',
    custom: '上传已有证书',
    wildcardLater: isCreateRootDomain.value ? '稍后申请泛域名证书' : '稍后配置'
  };
  return mapping[mode];
}

function isRootDomain(row: Domain) {
  const root = row.rootDomain || row.registeredDomain || deriveRootDomain(row.domain);
  return row.domain === root;
}
</script>

<template>
  <section class="page domains-page" :data-domain-plan-state="domainPlanState">
    <div class="page-title page-title-row">
      <div>
        <h1>域名管理</h1>
        <p>管理已添加的加速域名，查看接入状态和配置情况。</p>
      </div>
      <div class="add-domain-guide add-domain-guide--animated" aria-label="添加域名引导">
        <span class="guide-step-badge">第一步</span>
        <strong>添加域名、纯 IP 加速或申请免费 CDN</strong>
        <span>统一使用当前成熟接入流程</span>
        <el-button
          class="entry-action-button add-domain-button"
          data-test="create-domain"
          type="primary"
          aria-label="第一步：添加域名，开始接入并生成接入记录"
          @pointermove="updateEntryButtonTilt"
          @pointerleave="resetEntryButtonTilt"
          @pointercancel="resetEntryButtonTilt"
          @click="openCreateForm"
        >
          添加域名
        </el-button>
        <el-button
          class="entry-action-button pure-ip-button"
          data-test="create-pure-ip"
          type="primary"
          aria-label="纯 IP 加速，复用现有添加域名侧栏"
          @pointermove="updateEntryButtonTilt"
          @pointerleave="resetEntryButtonTilt"
          @pointercancel="resetEntryButtonTilt"
          @click="openPureIpForm"
        >
          纯IP加速
        </el-button>
        <el-button
          class="entry-action-button free-cdn-button"
          data-test="domains-apply-free-cdn"
          type="primary"
          aria-label="申请免费 CDN，复用添加域名流程"
          @pointermove="updateEntryButtonTilt"
          @pointerleave="resetEntryButtonTilt"
          @pointercancel="resetEntryButtonTilt"
          @click="openFreeCdnForm"
        >
          申请免费 CDN
        </el-button>
      </div>
    </div>
    <el-alert v-if="error" :title="error" type="error" show-icon />
    <el-alert v-if="success" :title="success" type="success" show-icon />
    <section v-if="partitionContactFailure" class="domain-draft-notice" data-test="partition-contact-failure">
      <div>
        <strong>套餐已购买，域名仍需处理</strong>
        <p>{{ partitionContactFailure }}</p>
      </div>
      <div class="draft-notice-actions">
        <RouterLink class="draft-action-link draft-action-link--primary" :to="contactAdminRoute()">联系我们</RouterLink>
      </div>
    </section>
    <section v-if="draftNotice" class="domain-draft-notice" data-test="quota-draft-notice">
      <div>
        <strong>域名额度不足，已保存为草稿</strong>
        <p>{{ draftNotice.reason }}</p>
      </div>
      <div class="draft-notice-actions">
        <RouterLink class="draft-action-link" :to="draftRoute()">查看草稿</RouterLink>
        <RouterLink class="draft-action-link draft-action-link--primary" :to="contactAdminRoute()">联系管理员</RouterLink>
      </div>
    </section>

    <el-card class="domain-summary-card">
      <div class="summary-item">
        <span>域名总数</span>
        <strong>{{ totalDomains }}</strong>
      </div>
      <div class="summary-item">
        <span class="summary-dot ok" />
        <span>运行正常</span>
        <strong>{{ runningDomains }}</strong>
      </div>
      <div class="summary-item">
        <span class="summary-dot warning" />
        <span>等待接入</span>
        <strong>{{ pendingDomains }}</strong>
      </div>
      <div class="summary-item">
        <span class="summary-dot danger" />
        <span>配置异常</span>
        <strong>{{ abnormalDomains }}</strong>
      </div>
      <div class="summary-item">
        <span class="summary-dot muted" />
        <span>已暂停</span>
        <strong>{{ pausedDomains }}</strong>
      </div>
    </el-card>

    <section
      ref="domainWorkbenchRef"
      class="domain-workbench"
      :class="{
        'with-create-panel': createFormVisible,
        'is-resizing': isCreatePanelResizing
      }"
      :style="{ '--create-panel-width': `${createPanelWidth}px` }"
    >
      <div class="domain-list-panel">
        <el-card class="domain-filter-card">
          <div class="domain-filter-row">
            <el-input
              v-model="searchKeyword"
              data-test="domain-search-input"
              clearable
              placeholder="搜索域名 / 服务名 / 接入地址"
            />
            <!-- 域名列表常规操作补齐，更新时间：2026-08-30 15:35 CST。刷新只重新读取本页数据，不修改任何域名状态。 -->
            <div class="domain-filter-controls">
              <el-button
                data-test="refresh-domain-list"
                :loading="loading || domainPlanLoading"
                :disabled="loading || domainPlanLoading"
                @click="refreshDomainList(true)"
              >刷新列表</el-button>
              <el-radio-group v-model="statusFilter" class="domain-filter-tabs">
                <el-radio-button label="ALL">全部</el-radio-button>
                <el-radio-button label="NORMAL">运行正常</el-radio-button>
                <el-radio-button label="ONBOARDING">接入中</el-radio-button>
                <el-radio-button label="ABNORMAL">异常</el-radio-button>
                <el-radio-button label="PAUSED">已暂停</el-radio-button>
              </el-radio-group>
            </div>
          </div>
        </el-card>
        <el-skeleton v-if="loading" :rows="5" animated />
        <EmptyState
          v-else-if="!domains.length && !pureIpServices.length"
          title="暂无加速服务"
          description="通过添加域名、纯 IP 加速或申请免费 CDN 完成接入后，会在这里显示服务和状态。"
          home-to="/domains"
        />
        <EmptyState
          v-else-if="!filteredDomains.length && !filteredPureIpServices.length"
          title="没有匹配的加速服务"
          description="调整搜索内容或筛选条件后再查看。"
          home-to="/domains"
        />
        <el-table v-else-if="filteredDomains.length" :data="filteredDomains" row-class-name="domain-row" @row-click="focusDomain">
          <!-- HotX Domains Table Fit V1.0 | 2026-09-09 20:44:12 CST | parent 7ca87f4928860d3265746e07dc467e199fa2f589
               Desktop columns total 1385px: fit the standard content pane without hiding data; narrow panes retain native horizontal scrolling. -->
          <el-table-column label="加速域名" min-width="210">
            <template #default="{ row }">
              <div class="domain-name-cell">
                <strong>{{ row.domain }}</strong>
                <span>{{ rootDomainSummaryText(row) }}</span>
                <span class="cell-subtext">创建时间（北京时间） {{ creationTimeBeijing(row.createdAt) }}</span>
                <span v-if="domainProtocolSummary(row)" class="unified-protocol-badge">
                  {{ domainProtocolSummary(row) }}
                </span>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="接入状态" min-width="155">
            <template #default="{ row }">
              <div class="domain-status-cell">
                <span class="status-pill" :class="statusClass(domainDisplayStatus(row))">{{ domainStatusText(domainDisplayStatus(row)) }}</span>
                <span class="cell-subtext">最近检测 {{ lastCheckedSummaryText(row) }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="证书状态" min-width="210">
            <template #default="{ row }">
              <div class="certificate-status-cell" :data-test="`domain-certificate-${row.id}`">
                <span class="certificate-pill" :class="`certificate-pill--${domainCertificateView(row).tone}`">
                  {{ domainCertificateView(row).label }}
                </span>
                <span v-if="domainCertificateView(row).reason" class="cell-subtext">
                  {{ domainCertificateView(row).reason }}
                </span>
                <el-button
                  v-if="domainCertificateView(row).canReissue"
                  size="small"
                  :data-test="`reissue-domain-certificate-${row.id}`"
                  :loading="certificateActionDomainId === row.id"
                  :disabled="certificateActionDomainId === row.id"
                  @click.stop="reissueAutoCertificate(row)"
                >
                  自动证书重签
                </el-button>
              </div>
            </template>
          </el-table-column>
          <!-- 套餐列替代重复接入记录与配置标签，更新时间：2026-09-04 20:40 CST。 -->
          <el-table-column label="套餐与有效期" min-width="285">
            <template #default="{ row }">
              <div class="domain-package-cell">
                <strong>{{ packageLabel(domainPlan(row)) }}</strong>
                <span v-if="domainPlan(row)?.billingMode === 'FREE'" class="cell-subtext">
                  {{ freePlanTimingText(domainPlan(row)) }}
                </span>
                <span v-else-if="domainPlan(row)?.paidUntil" class="cell-subtext">
                  有效至 {{ paidUntilText(domainPlan(row)) }}
                </span>
                <span v-if="domainPlan(row)?.status === 'PROTECTION'" class="protection-countdown">
                  {{ protectionText(domainPlan(row)) }}
                </span>
                <!-- 免费续期入口可见性修复，更新时间：2026-09-04 CST。
                     免费套餐切入按天续期后仍属于免费体系，按钮必须保持可见；仅最后 24 小时高亮可用。 -->
                <el-button
                  v-if="domainPlan(row) && !['MONTHLY', 'PARTITION', 'ADMIN_PUSH'].includes(domainPlan(row)?.billingMode || '')"
                  size="small"
                  type="success"
                  :loading="packageActionDomainId === row.id"
                  :disabled="packageActionDomainId === row.id"
                  @click.stop="handleFreeRenewClick(row)"
                >免费续期7天</el-button>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="回源节点 IP" min-width="230">
            <template #default="{ row }">
              <DomainOriginIpCell :domain-id="Number(row.id)" :refresh-key="originIpRefreshKey" :copy-text="writeClipboardText" />
            </template>
          </el-table-column>
        <el-table-column label="自动续费" width="210" align="center">
          <template #default="scope">
            <DomainDailyRenewCell
              v-if="scope.row?.id"
              :domain-id="Number(scope.row.id)"
              :domain-label="String(scope.row.domain || scope.row.serviceName || '')"
              :overview="domainPlanOverview"
              :loading="domainPlanLoading"
              :load-error="domainPlanLoadError"
              @overview-updated="applyDomainPlanOverview"
            />
            <span v-else class="daily-renew-unavailable">不适用</span>
          </template>
        </el-table-column>

          <el-table-column label="操作" min-width="315" fixed="right">
            <template #default="{ row }">
              <div class="domain-actions">
                <el-button
                  size="small"
                  :loading="recheckingDomainId === row.id"
                  :disabled="recheckingDomainId === row.id"
                  @click.stop="recheckDomain(row)"
                >
                  检测
                </el-button>
                <el-button size="small" @click.stop="openConfigPanel(row)">配置</el-button>
                <el-button
                  size="small"
                  type="primary"
                  :disabled="domainPlan(row)?.switchBlocked"
                  @click.stop="openPackageDialog(row)"
                >{{ domainPlan(row)?.switchBlocked ? '管理员专属套餐生效中，暂不可切换' : '升级套餐' }}</el-button>
                <el-button
                  v-if="domainPlan(row)?.switchBlocked"
                  size="small"
                  plain
                  @click.stop="adminCancelVisible = true"
                >邮箱验证取消</el-button>
                <el-button
                  v-if="!['ENABLED', 'ACTIVE', 'RUNNING'].includes(row.status)"
                  size="small"
                  :loading="togglingDomainId === row.id"
                  :disabled="togglingDomainId === row.id"
                  @click.stop="enable(row)"
                >
                  启用
                </el-button>
                <el-button
                  v-else
                  size="small"
                  type="warning"
                  :loading="togglingDomainId === row.id"
                  :disabled="togglingDomainId === row.id"
                  @click.stop="pause(row)"
                >
                  暂停
                </el-button>
                <!-- 删除按钮使用真实域名删除接口并带二次确认，更新时间：2026-08-30 15:35 CST。 -->
                <el-button
                  size="small"
                  type="danger"
                  plain
                  :loading="deletingDomainId === row.id"
                  :disabled="deletingDomainId === row.id"
                  @click.stop="deleteCdnDomain(row)"
                >
                  删除
                </el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>

        <!-- V1.7-flow-integration, 2026-09-09 CST: pure-IP rows share the mature list/search area instead of a second management entry. -->
        <div v-if="!loading && filteredPureIpServices.length" class="unified-service-rows" data-test="pure-ip-service-rows">
          <article v-for="service in filteredPureIpServices" :key="service.id" class="unified-service-row">
            <div class="unified-service-identity">
              <span class="unified-service-kind">纯 IP</span>
              <strong>{{ service.name }}</strong>
              <span>{{ unifiedProtocolSummary(service) }}</span>
            </div>
            <div class="unified-service-access">
              <small>访问 IP</small>
              <code>{{ unifiedPublicIp(service) }}</code>
            </div>
            <div class="unified-service-state">
              <span class="status-pill" :class="statusClass(unifiedLifecycle(service))">{{ unifiedStatusText(service) }}</span>
              <small>{{ unifiedActionFeedback[service.id] || unifiedLastError(service) || '各协议独立发布，不影响其他操作' }}</small>
            </div>
            <div class="domain-actions unified-service-actions">
              <el-button size="small" @click="retryUnifiedPublish(service)">重新发布</el-button>
              <el-button
                v-if="unifiedLifecycle(service) === 'ACTIVE'"
                size="small"
                :loading="unifiedActionServiceId === service.id"
                :disabled="unifiedActionServiceId === service.id"
                @click="migrateUnifiedPublicIp(service)"
              >迁移公网 IP</el-button>
              <el-button
                size="small"
                type="danger"
                plain
                :loading="unifiedActionServiceId === service.id"
                :disabled="unifiedActionServiceId === service.id"
                @click="removeUnifiedService(service)"
              >删除</el-button>
            </div>
          </article>
        </div>

        <el-dialog v-model="packageDialogVisible" title="域名套餐" width="560px" append-to-body>
          <section v-if="domainPlanOverview?.activePush" class="package-choice-card">
            <h3>{{ domainPlanOverview.activePush.planName }}</h3>
            <p>{{ describePushExpiry(domainPlanOverview.activePush, domainPlanOverview.serverTime) }}；到期后继续服务，直到管理员手动续期、替换或取消。</p>
          </section>
          <section v-if="domainPlan(packageDomain)?.billingMode === 'FREE'" class="package-choice-card">
            <h3>免费套餐按天加速</h3>
            <p>优先使用积分加速，每 1 积分抵扣 1 天；免费天数暂停消耗，积分不足后自动续用免费剩余时间。</p>
            <!-- V1.9 (2026-09-10): use one fixed business label; the switch alone expresses state. -->
            <div class="package-renew-row package-renew-row--daily">
              <span class="package-renew-label">自动续费</span>
              <el-switch
                data-test="upgrade-renew-switch"
                aria-label="免费套餐自动续费"
                :model-value="domainPlan(packageDomain)?.dailyAutoRenew"
                @change="setDailyBilling(Boolean($event))"
              />
              <span class="package-renew-rate">1 积分/天</span>
            </div>
          </section>
          <section v-if="domainPlan(packageDomain)?.billingMode === 'MONTHLY'" class="package-choice-card">
            <h3>按月套餐自动续费</h3>
            <p>默认开启；欠费后进入 90 天保护期。保持开启时，积分补足会自动扣费恢复。</p>
            <el-switch
              :model-value="domainPlan(packageDomain)?.monthlyAutoRenew"
              active-text="自动续费"
              @change="setMonthlyBilling(Boolean($event))"
            />
          </section>
          <section v-if="domainPlanOverview?.partitions?.length" class="package-choice-card">
            <h3>购买套餐已按独立分区管理</h3>
            <p v-if="domainPlan(packageDomain)?.billingMode === 'PARTITION'">当前所属分区：{{ packageLabel(domainPlan(packageDomain)) }}</p>
            <p>分区续费、自动续费和域名迁移统一在套餐页处理。</p>
            <a href="/packages">前往套餐页管理分区</a>
          </section>
          <section v-if="!domainPlanOverview?.activePush && !domainPlanOverview?.partitions?.length" class="package-choice-card">
            <h3>按月套餐</h3>
            <template v-if="domainPlanOverview?.plans.length">
              <el-radio-group v-model="selectedMonthlyPlanId" class="package-plan-options">
                <el-radio
                  v-for="plan in domainPlanOverview.plans"
                  :key="plan.id"
                  :value="plan.id"
                  class="package-plan-option"
                  :data-test="`monthly-plan-${plan.planCode}`"
                >
                  {{ plan.planName }} · {{ plan.pointPrice }} 积分/月
                </el-radio>
              </el-radio-group>
              <el-select v-model="selectedMonthlyPeriods">
                <el-option :value="1" label="1 个月" />
                <el-option :value="6" label="6 个月（9 折）" />
                <el-option :value="12" label="12 个月（8.5 折）" />
              </el-select>
              <div class="package-renew-row package-renew-row--monthly">
                <span class="package-renew-label">自动续费</span>
                <el-switch
                  v-model="selectedMonthlyAutoRenew"
                  data-test="monthly-purchase-auto-renew"
                  aria-label="按月套餐自动续费"
                />
              </div>
              <div v-if="selectedMonthlyPlan" class="package-order-preview" data-test="monthly-order-preview">
                <span>{{ selectedMonthlyPlan.planName }}</span>
                <span>{{ selectedMonthlyPeriods }} 个月</span>
                <strong>{{ formatPlanPoints(selectedMonthlyPayablePoints) }} 积分</strong>
              </div>
              <div class="package-choice-actions">
                <el-button
                  type="primary"
                  data-test="activate-monthly-plan"
                  :loading="packageActionDomainId === packageDomain?.id"
                  :disabled="!selectedMonthlyPlan || packageActionDomainId === packageDomain?.id"
                  @click="purchaseMonthlyPlan"
                >立即生效</el-button>
              </div>
            </template>
            <p v-else>按月套餐还在设计，后台发布后会自动显示在这里。</p>
          </section>
        </el-dialog>

        <el-dialog v-model="rechargeChoiceVisible" title="积分不足" width="440px" append-to-body>
          <p>{{ rechargeFailureMessage }}</p>
          <p>请选择充值网络，充值页面将在新窗口打开；当前页面和表单会完整保留。</p>
          <div class="recharge-network-actions">
            <el-button type="primary" @click="chooseRechargeNetwork('BSC')">BSC 充值</el-button>
            <el-button type="success" @click="chooseRechargeNetwork('TRX')">TRX 充值</el-button>
          </div>
        </el-dialog>

        <el-dialog v-model="adminCancelVisible" title="取消管理员专属套餐" width="480px" append-to-body>
          <el-alert type="warning" :closable="false" title="取消后立即暂停现有域名并进入 15 天保护期；恢复免费套餐仍需删除域名并完整重新添加。" />
          <el-button :loading="adminCancelSending" :disabled="adminCancelCodeSent || adminCancelSending || adminCancelling" @click="requestAdminCancelCode">
            {{ adminCancelSending ? '发送中…' : adminCancelCodeSent ? '验证码已发送' : '发送邮箱验证码' }}
          </el-button>
          <el-input v-model="adminCancelCode" maxlength="6" placeholder="请输入邮箱验证码" />
          <template #footer>
            <el-button type="danger" :loading="adminCancelling" :disabled="adminCancelCode.length !== 6 || adminCancelling || adminCancelSending" @click="confirmAdminCancel">{{ adminCancelling ? '提交中…' : '确认取消' }}</el-button>
          </template>
        </el-dialog>

        <el-card v-if="focusedDomain" class="diagnosis-card">
          <template #header>
            <div class="diagnosis-header">
              <span>接入诊断</span>
              <span class="diagnosis-tag">{{ diagnosis.tag }}</span>
            </div>
          </template>
          <div class="diagnosis-layout">
            <section class="diagnosis-visual">
              <p class="section-kicker">接入流程</p>
              <div class="access-flow">
                <div v-for="(step, index) in accessFlow" :key="step.name" class="flow-step">
                  <span class="flow-step-index">{{ index + 1 }}</span>
                  <div>
                    <strong>{{ step.name }}</strong>
                    <span>{{ step.status }}</span>
                  </div>
                </div>
              </div>
            </section>
            <section class="diagnosis-main">
              <div class="diagnosis-result-card" :class="focusedDomain.accessMode === 'REDIRECT_301' ? `root301-result--${focusedRootPublication.tone}` : domainStatusGroup(focusedDomain) === 'NORMAL' ? undefined : `root301-result--${domainStatusGroup(focusedDomain) === 'ABNORMAL' ? 'bad' : 'waiting'}`">
                <span class="diagnosis-result-icon" aria-hidden="true">{{ focusedDomain.accessMode === 'REDIRECT_301' ? (focusedRootPublication.tone === 'ok' ? '✓' : focusedRootPublication.tone === 'bad' ? '!' : '…') : domainStatusGroup(focusedDomain) === 'NORMAL' ? '✓' : domainStatusGroup(focusedDomain) === 'ABNORMAL' ? '!' : '…' }}</span>
                <div>
                  <p class="section-kicker">当前状态</p>
                  <h2>{{ diagnosis.title }}</h2>
                  <p>{{ diagnosis.reason }}</p>
                </div>
              </div>
              <div v-if="diagnosis.dnsStatusLabel || diagnosis.taskId || diagnosis.lastCheckedAt" class="dns-status-grid">
                <span v-if="diagnosis.dnsStatusLabel"><strong>DNS 状态</strong>{{ diagnosis.dnsStatusLabel }}</span>
                <span v-if="diagnosis.taskId"><strong>检测任务 #{{ diagnosis.taskId }}</strong></span>
                <span v-if="diagnosis.taskStatusLabel"><strong>任务状态</strong>{{ diagnosis.taskStatusLabel }}</span>
                <span v-if="diagnosis.lastCheckedAt"><strong>最近检测</strong>{{ displayTimeOrDash(diagnosis.lastCheckedAt) }}</span>
              </div>
              <div
                v-if="focusedCertificate"
                class="focused-certificate-status"
                :data-test="`focused-certificate-${focusedDomain.id}`"
              >
                <span class="certificate-pill" :class="`certificate-pill--${focusedCertificate.tone}`">
                  {{ focusedCertificate.label }}
                </span>
                <p v-if="focusedCertificate.reason">{{ focusedCertificate.reason }}</p>
                <el-button
                  v-if="focusedCertificate.canReissue"
                  size="small"
                  data-test="reissue-focused-certificate"
                  :loading="certificateActionDomainId === focusedDomain.id"
                  :disabled="certificateActionDomainId === focusedDomain.id"
                  @click="reissueAutoCertificate(focusedDomain)"
                >
                  自动证书重签
                </el-button>
              </div>
              <section v-if="focusedDomain.accessMode === 'REDIRECT_301'" class="root301-status-grid" aria-label="301 接入状态">
                <div v-if="focusedDomain.certificateState?.dns?.recordName && focusedDomain.certificateState?.status === 'WAITING_DNS'" class="root301-state" data-test="root301-certificate-dns">
                  <strong>证书 DNS 验证</strong>
                  <span>验证记录：<code>{{ focusedDomain.certificateState.dns.recordName }}</code></span>
                  <span v-if="focusedDomain.certificateState.dns.cnameTarget">CNAME 记录值：<code>{{ focusedDomain.certificateState.dns.cnameTarget }}</code></span>
                </div>
                <div class="root301-state" data-test="root301-probe">
                  <span class="certificate-pill" :class="`certificate-pill--${focusedRootProbe.tone}`">{{ focusedRootProbe.label }}</span>
                  <code v-if="focusedDomain.redirectTarget">{{ focusedDomain.redirectTarget }}</code>
                  <p v-if="focusedRootProbe.reason">{{ focusedRootProbe.reason }}</p>
                  <span v-if="focusedDomain.redirectTargetProbe?.httpStatus">HTTP {{ focusedDomain.redirectTargetProbe.httpStatus }}</span>
                  <small v-if="focusedDomain.redirectTargetProbe?.checkedAt">最近检测：{{ displayTimeOrDash(focusedDomain.redirectTargetProbe.checkedAt) }}</small>
                </div>
                <div class="root301-state" data-test="root301-publication">
                  <span class="certificate-pill" :class="`certificate-pill--${focusedRootPublication.tone}`">{{ focusedRootPublication.label }}</span>
                  <p v-if="focusedRootPublication.reason">{{ focusedRootPublication.reason }}</p>
                </div>
              </section>
              <div class="diagnosis-address-grid">
                <div class="diagnosis-address-item">
                  <p class="section-kicker">检测域名</p>
                  <code>{{ diagnosisDomain }}</code>
                </div>
                <div class="diagnosis-address-item">
                  <p class="section-kicker">接入记录值</p>
                  <DomainAccessTargets v-if="dnsRecordTypeFor(focusedDomain) === 'CNAME'" :domain-id="focusedDomain.id" :domain="focusedDomain.domain" @targets="frozenAccessTargets[focusedDomain.id] = $event" />
                  <div class="copy-line">
                    <code v-if="dnsRecordTypeFor(focusedDomain) !== 'CNAME'">{{ diagnosis.address }}</code>
                    <el-button v-if="dnsRecordTypeFor(focusedDomain) !== 'CNAME'" size="small" :disabled="!diagnosis.address || diagnosis.address === '暂无数据' || diagnosis.address === rootAddressWaiting || accessCopyCountdown > 0" @click="copyAccessAddress()">
                      {{ accessCopyCountdown > 0 ? `已复制 ${accessCopyCountdown} 秒` : '复制' }}
                    </el-button>
                    <el-button
                      size="small"
                      data-test="recheck-focused-domain"
                      :loading="recheckingDomainId === focusedDomain.id || dnsLoadingDomainId === focusedDomain.id"
                      :disabled="recheckingDomainId === focusedDomain.id"
                      @click="recheckDomain()"
                    >
                      重新检测
                    </el-button>
                  </div>
                </div>
              </div>
              <p class="section-kicker">建议操作</p>
              <p class="next-step-summary">{{ diagnosis.nextStep }}</p>
              <div class="diagnosis-actions">
                <RouterLink
                  :data-test="`apply-free-ssl-${focusedDomain.id}`"
                  class="free-ssl-link"
                  :to="freeSslRoute(focusedDomain)"
                >
                  {{ freeSslCtaText(focusedDomain) }}
                </RouterLink>
              </div>
              <ol v-if="!accessDnsEffective" class="next-steps">
                <li>登录你的 DNS 服务商控制台。</li>
                <li>按页面给出的记录类型、记录名和记录值完成 DNS 配置。</li>
                <li>等待 DNS 生效后点击“重新检测”。</li>
              </ol>
            </section>
            <aside class="diagnosis-faq">
              <p class="section-kicker">常见问题</p>
              <a href="https://hotxcdn.net" target="_blank" rel="noopener noreferrer">如何添加 DNS 接入记录？</a>
              <a href="https://hotxcdn.net" target="_blank" rel="noopener noreferrer">DNS 解析不生效怎么办？</a>
              <a href="https://hotxcdn.net" target="_blank" rel="noopener noreferrer">接入后多久可以生效？</a>
            </aside>
          </div>
        </el-card>
      </div>

      <div
        v-if="createFormVisible"
        class="domain-workbench-splitter"
        :class="{ 'domain-workbench-splitter--active': isCreatePanelResizing }"
        role="separator"
        aria-label="调整配置面板和域名内容的宽度"
        aria-orientation="vertical"
        :aria-valuemin="CREATE_PANEL_MIN_WIDTH"
        :aria-valuemax="CREATE_PANEL_MAX_WIDTH"
        :aria-valuenow="createPanelWidth"
        tabindex="0"
        title="左右拖动调整两侧宽度"
        @pointerdown="startCreatePanelResize"
        @pointermove="resizeCreatePanel"
        @pointerup="finishCreatePanelResize"
        @pointercancel="finishCreatePanelResize"
        @keydown="resizeCreatePanelWithKeyboard"
      >
        <span class="domain-workbench-splitter-grip" aria-hidden="true" />
      </div>

      <aside
        v-if="createFormVisible"
        class="create-domain-panel"
        :aria-label="isPureIpCreate ? '添加纯 IP 加速完整配置' : '添加域名完整配置'"
      >
        <div class="create-panel-header">
          <div>
            <p class="section-kicker">域名管理 / {{ isPureIpCreate ? '纯 IP 加速' : '添加域名' }}</p>
            <h2>{{ isPureIpCreate ? '纯 IP 加速' : (freeCdnIntent ? '申请免费 CDN' : '添加域名') }}</h2>
            <p v-if="isPureIpCreate">沿用现有接入侧栏填写服务、协议和源站；保存后系统自动选择可用节点并返回访问 IP。</p>
            <p v-else>填写网站接入信息，提交后系统将创建域名并生成接入配置；证书签发失败不会阻塞域名保存。</p>
          </div>
          <el-button plain @click="cancelCreateForm">关闭</el-button>
        </div>

        <section v-if="freeCdnIntent" class="free-cdn-intent-note" data-test="free-cdn-intent-note">
          <strong>免费 CDN 申请</strong>
          <p>默认选择免费 CDN 套餐，也可以主动改选已启用的购买套餐；已有正式套餐不会被降级。</p>
        </section>

        <el-card
          v-if="isDomainCreate"
          class="create-section create-domain-entry-guide"
          :class="{ 'create-domain-entry-guide--active': createDomainGuideActive }"
        >
          <template #header>
            <div class="domain-entry-header">
              <span>加速域名 <b class="required-star" aria-hidden="true">*</b></span>
              <span v-if="createDomainGuideActive" class="domain-entry-cue">先填这里</span>
            </div>
          </template>
          <div class="domain-entry-input-wrap">
            <el-input
              v-model="createForm.domain"
              data-test="create-domain-input"
              class="domain-entry-input"
              :class="{ 'required-control--error': showCreateIssue('name') }"
              data-required-field="name"
              placeholder="请输入加速域名，如 www.example.com"
              @blur="markCreateFieldTouched('name')"
            />
            <p v-if="showCreateIssue('name')" class="required-error">{{ createIssue('name')?.message }}</p>
          </div>
          <p class="field-help">支持主域名、子域名和泛域名；提交后生成唯一接入配置。</p>
        </el-card>

        <el-card v-if="isPureIpCreate" class="create-section create-domain-entry-guide">
          <template #header>服务名称 <b class="required-star" aria-hidden="true">*</b></template>
          <el-input
            v-model="createForm.serviceName"
            data-test="create-pure-ip-name"
            :class="{ 'required-control--error': showCreateIssue('name') }"
            data-required-field="name"
            placeholder="例如：游戏登录入口"
            @blur="markCreateFieldTouched('name')"
          />
          <p v-if="showCreateIssue('name')" class="required-error">{{ createIssue('name')?.message }}</p>
          <p class="field-help">服务名称用于列表识别；访问 IP 将由系统从可用生产节点自动分配。</p>
        </el-card>

        <!--
          HotX V1.7 pure-IP node modes.
          Updated: 2026-09-09 CST; version: V1.7-mode-guidance; parent baseline: dbf4516c6af4426c457268848bf3cb5700883353.
          Both modes stay visible as required by the product tree. Component
          readiness is disclosed here, while the existing save-then-publish
          pipeline remains responsible for returning the real release result.
        -->
        <el-card v-if="isPureIpCreate" class="create-section pure-ip-mode-section" data-test="pure-ip-mode-section">
          <template #header>节点模式</template>
          <div class="pure-ip-mode-picker" role="group" aria-label="纯 IP 节点模式">
            <button
              type="button"
              class="pure-ip-mode-option"
              :class="{ 'pure-ip-mode-option--active': createForm.deploymentMode === 'SINGLE_NODE' }"
              :aria-pressed="createForm.deploymentMode === 'SINGLE_NODE'"
              data-test="pure-ip-mode-single"
              @click="createForm.deploymentMode = 'SINGLE_NODE'"
            >
              <span><strong>单节点模式</strong><small>默认</small></span>
              <p>自动选择一个可用生产节点，并返回该节点公网 IP。</p>
            </button>
            <button
              type="button"
              class="pure-ip-mode-option"
              :class="{ 'pure-ip-mode-option--active': createForm.deploymentMode === 'COMPONENT' }"
              :aria-pressed="createForm.deploymentMode === 'COMPONENT'"
              data-test="pure-ip-mode-component"
              @click="createForm.deploymentMode = 'COMPONENT'"
            >
              <span><strong>智能组件模式</strong><small>方案模式</small></span>
              <p>通过 Component Gateway 识别服务身份并统一接入。</p>
            </button>
          </div>
          <p class="field-help">默认使用单节点；切换模式不会改变下方成熟的协议、源站和保存流程。</p>
          <div
            v-if="createForm.deploymentMode === 'COMPONENT'"
            class="component-readiness-note"
            data-test="component-readiness-note"
          >
            <strong>组件模式成熟度说明</strong>
            <p>HTTP/HTTPS 方案设计已就绪；TCP/UDP 仍待组件协议 PoC 验收。当前配置可以保存，系统会继续执行发布并显示真实发布结果。</p>
          </div>
        </el-card>

          <!-- 根域名 A 记录与子域名 CNAME 指引，更新时间：2026-09-15 20:01 CST；父基线 bae151b85。
               A 记录的真实地址只来自创建后服务端返回的 expectedValues/DNS 诊断，创建前只呈现等待态。 -->
          <el-card v-if="isDomainCreate && normalizedCreateDomain" class="create-section dns-copy-summary-card">
          <template #header>
            <div class="dns-copy-summary-header">
              <span>DNS 配置值</span>
              <small>复制后粘贴到 DNS 服务商</small>
            </div>
          </template>
          <div class="dns-copy-summary-grid">
            <div class="dns-copy-summary-item">
              <div>
                  <span>{{ isCreateRootDomain ? 'DNS 名称（根域名）' : 'DNS 名称（主机记录）' }}</span>
                <code>{{ previewDnsHostRecord }}</code>
                <small>对应完整域名：{{ previewAccessDomain }}</small>
              </div>
              <button
                type="button"
                class="dns-summary-copy-button"
                :class="{ 'dns-summary-copy-button--copied': dnsHostCopied }"
                @click="copyPreviewDnsHostRecord"
              >
                {{ dnsHostCopied ? '已复制' : '复制' }}
              </button>
            </div>
            <div v-if="previewDnsRecordType === 'CNAME'" class="dns-copy-summary-item">
              <DomainAccessTargets :domain="normalizedCreateDomain" :selection="accessPreviewSelection(createForm.planCode, createPlanAutoRenew, selectedPartitionSelection)" @targets="cnamePreviewTargets = $event" />
            </div>
            <div v-else class="dns-copy-summary-item">
              <div>
                  <span>{{ previewDnsRecordType }} 记录值（指向地址）</span>
                  <code>{{ previewDnsRecordValue }}</code>
                  <small>{{ previewDnsRecordHint }}</small>
              </div>
              <button
                type="button"
                class="dns-summary-copy-button"
                  :class="{ 'dns-summary-copy-button--copied': accessGuideCopied }"
                  :disabled="!canCopyPreviewDnsRecordValue"
                  @click="copyPreviewCnameTarget"
              >
                {{ accessGuideCopied ? '已复制' : '复制' }}
              </button>
            </div>
          </div>
        </el-card>

          <!-- DNS 接入动图指引，更新时间：2026-09-16 01:18 CST；父基线 d7d38c0fd9a86ebfd04ad7843168cb0becb05652。
               参照免费证书 DNS 指引动画，把平台记录、复制动作和 DNS 服务商表单放在同一画面；只改 UI 演示，不改提交、复制或检测逻辑。 -->
          <el-card v-if="isDomainCreate" :key="accessGuideAnimationKey" class="create-section create-access-guide create-access-guide--compare create-access-guide--animated">
            <template #header>
              <div class="access-guide-header">
                <span>接入地址</span>
                <span class="access-guide-badge">在 DNS 服务商处添加 {{ previewDnsRecordType }}</span>
                <button type="button" class="dns-guide-replay-button" @click="replayAccessGuide">播放指引</button>
              </div>
            </template>
            <div v-if="!normalizedCreateDomain" class="dns-guide-empty">
              <strong>填写加速域名后自动生成</strong>
              <p>系统会在这里生成 DNS 名称、接入记录值和逐项填写指引。</p>
          </div>
          <template v-else>
            <div class="dns-guide-domain">
              <span>需要配置的域名</span>
              <strong>{{ previewAccessDomain }}</strong>
              <small>请在该域名的 DNS 设置中添加以下记录</small>
            </div>
            <section
              class="dns-guide-animation domain-dns-guide-animation guide-playing"
              :aria-label="`${previewDnsRecordType} 记录动图填写指引`"
            >
              <div class="guide-panel platform-panel">
                <div class="guide-panel-title">
                  <span>平台给你的记录</span>
                  <strong>先复制，再去 DNS 填写</strong>
                </div>
                <div class="guide-records">
                  <div class="guide-record-item">
                    <span>记录类型</span>
                    <strong>{{ previewDnsRecordType }}</strong>
                  </div>
                  <div class="guide-record-item">
                    <span>主机记录</span>
                    <strong>{{ previewDnsHostRecord }}</strong>
                    <button class="guide-copy copy-name" type="button">复制</button>
                  </div>
                  <div class="guide-record-item">
                    <span>记录值</span>
                    <code>{{ previewDnsRecordValue }}</code>
                    <button
                      type="button"
                      class="guide-copy copy-value"
                      :class="{ 'copy-value--copied': accessGuideCopied }"
                      :disabled="!canCopyPreviewDnsRecordValue"
                      @click="copyPreviewCnameTarget"
                    >
                      {{ canCopyPreviewDnsRecordValue ? (accessGuideCopied ? '已复制' : '复制') : '等待' }}
                    </button>
                  </div>
                </div>
                <span class="mouse-tip tip-name">鼠标点击：复制主机记录</span>
                <span class="mouse-tip tip-value">鼠标点击：复制记录值</span>
                <span class="cursor-left" aria-hidden="true" />
              </div>

              <div class="guide-panel dns-panel">
                <div class="guide-panel-title">
                  <span>DNS 服务商创建记录</span>
                  <strong>保存后回平台检测</strong>
                </div>
                <div class="dns-window">
                  <div class="dns-top"><span>‹</span><strong>创建记录集</strong></div>
                  <div class="dns-form">
                    <div class="dns-field name-field focus-name">
                      <span class="field-label">DNS 名称</span>
                      <span class="typed-name">{{ previewDnsHostRecord }}</span>
                    </div>
                    <div class="select-row">
                      <span>记录类型：{{ previewDnsRecordType }}</span>
                      <span>TTL：5 分钟</span>
                    </div>
                    <div class="dns-field focus-value">
                      <span class="field-label">记录值</span>
                      <span class="typed-value">{{ previewDnsRecordValue }}</span>
                    </div>
                    <div class="dns-actions">
                      <button class="create-btn" type="button">创建</button>
                      <span>创建后返回平台点击“重新检测”</span>
                    </div>
                  </div>
                </div>
                <span class="mouse-tip tip-dns">粘贴到 DNS 名称</span>
                <span class="mouse-tip tip-paste">粘贴记录值</span>
                <span class="cursor" aria-hidden="true" />
              </div>
            </section>
            <div class="dns-guide-tip">
              <span aria-hidden="true">提</span>
              <p>添加完成后，DNS 生效通常需要 5 分钟至 24 小时。生效后返回平台进行检测。</p>
            </div>
          </template>
        </el-card>

        <el-card v-if="isDomainCreate" class="create-section">
            <template #header>接入模式</template>
            <el-radio-group v-model="createForm.accessMode" class="access-mode-picker" @change="markAccessModeAsManuallySelected">
            <el-radio-button label="CDN">CDN 加速</el-radio-button>
            <el-radio-button label="REDIRECT_301">301 跳转</el-radio-button>
          </el-radio-group>
          <p class="field-help">CDN 加速需要源站；301 跳转只保存跳转目标，不要求源站。</p>
        </el-card>

        <!-- CDN 源站前置必填区，更新时间：2026-08-30 20:35 CST。切换 301 跳转时自动隐藏，不产生无效源站配置。 -->
        <el-card
          v-if="isPureIpCreate || !isRedirectAccessMode"
          class="create-section origin-required-guide"
          :class="{ 'origin-required-guide--active': createOriginGuideActive }"
        >
          <template #header>
            <div class="required-field-header">
              <span>源站配置</span>
              <span class="origin-required-badge">CDN 必填</span>
            </div>
          </template>
          <!-- V1.7-flow-integration, 2026-09-09 CST, parent c65f36872: protocols live in the mature source card. -->
          <div class="frontend-protocol-picker" data-test="frontend-protocol-picker">
            <div>
              <strong>加速协议 <b class="required-star" aria-hidden="true">*</b></strong>
              <span>{{ isPureIpCreate ? '默认 TCP，可多选' : '默认 HTTP + HTTPS，可继续添加 TCP / UDP' }}</span>
            </div>
            <div
              class="frontend-protocol-options"
              :class="{ 'required-group--error': showCreateIssue('protocols') }"
              data-required-field="protocols"
            >
              <el-checkbox :model-value="createForm.httpEnabled" @change="toggleFrontendProtocol('HTTP', Boolean($event))">HTTP</el-checkbox>
              <el-checkbox :model-value="createForm.httpsEnabled" @change="toggleFrontendProtocol('HTTPS', Boolean($event))">HTTPS</el-checkbox>
              <el-checkbox :model-value="createForm.tcpEnabled" @change="toggleFrontendProtocol('TCP', Boolean($event))">TCP</el-checkbox>
              <el-checkbox :model-value="createForm.udpEnabled" @change="toggleFrontendProtocol('UDP', Boolean($event))">UDP</el-checkbox>
            </div>
          </div>
          <p v-if="showCreateIssue('protocols')" class="required-error">{{ createIssue('protocols')?.message }}</p>
          <div class="acceleration-region-field">
            <label for="domain-acceleration-region">加速区域</label>
            <el-select
              id="domain-acceleration-region"
              v-model="createForm.accelerationRegion"
              data-test="acceleration-region-select"
              class="full-width"
            >
              <el-option
                v-for="option in ACCELERATION_REGION_OPTIONS"
                :key="option.value"
                :label="option.label"
                :value="option.value"
              />
            </el-select>
          </div>
          <el-alert
            v-if="isPureIpCreate"
            class="node-certificate-note"
            type="success"
            :closable="false"
            title="选择 HTTPS 时使用节点公网 IP 证书，由节点自动申请、部署并续期证书，无需上传。"
          />
          <div v-if="createOriginGuideActive" class="origin-guide-message">
            <span aria-hidden="true" />
            <strong>{{ !createForm.originAddress.trim() ? '请填写网站真实源站的 IP 或域名' : '请至少选择一个回源端口' }}</strong>
          </div>
          <div class="origin-grid">
            <div class="origin-address-label">
              <strong>{{ isPureIpCreate ? '服务真实源站' : '网站真实源站' }} <b class="required-star" aria-hidden="true">*</b></strong>
            </div>
            <el-input
              v-model="createForm.originAddress"
              data-test="create-origin-address-input"
              class="origin-address-input"
              :class="{
                'origin-address-input--filled': createForm.originAddress.trim(),
                'required-control--error': showCreateIssue('originAddress')
              }"
              data-required-field="originAddress"
              size="large"
              :placeholder="isPureIpCreate ? '请输入服务源站 IPv4、IPv6 或域名' : '请输入源站 IP 或域名，如 origin.example.com'"
              @blur="normalizeOriginAddressField"
            />
            <p v-if="showCreateIssue('originAddress')" class="required-error">{{ createIssue('originAddress')?.message }}</p>
            <div v-if="isDomainCreate && normalizedCreateDomain.startsWith('*.')" class="field-help">
              <p>泛域名默认保留访客访问的子域名；单独添加的子域名优先使用自己的站点配置。</p>
              <label>固定回源 Host（可选）<el-input v-model="createForm.wildcardOriginHost" aria-label="泛域名固定回源 Host" placeholder="留空跟随访问域名；同一站点可填 origin.example.com" maxlength="253" /></label>
              <label>HTTPS 回源 TLS SNI（可选）<el-input v-model="createForm.wildcardOriginTlsSni" aria-label="泛域名回源 TLS SNI" placeholder="留空使用回源 Host" maxlength="253" /></label>
            </div>
            <div v-if="isDomainCreate" class="origin-port-selector">
              <div class="origin-port-heading">
                <strong>选择回源端口</strong>
                <span>默认 HTTPS 443；主备回源协议须一致</span>
              </div>
              <div class="origin-port-options">
                <el-checkbox v-model="createForm.originPort443Enabled">HTTPS（443）</el-checkbox>
                <el-checkbox v-model="createForm.originPort80Enabled">HTTP（80）</el-checkbox>
                <el-checkbox v-model="createForm.customOriginPortEnabled">自定义端口</el-checkbox>
              </div>
              <div v-if="createForm.customOriginPortEnabled" class="custom-origin-port-row">
                <el-input-number
                  v-model="createForm.originPort"
                  :min="1"
                  :max="65535"
                  controls-position="right"
                />
                <el-select v-model="createForm.originProtocol">
                  <el-option label="HTTPS 回源" value="HTTPS" />
                  <el-option label="HTTP 回源" value="HTTP" />
                  <!-- 自定义端口双协议回源，更新时间：2026-08-30 20:57 CST。接口原生支持 HTTP_HTTPS，提交后按 HTTP 与 HTTPS 双协议回源。 -->
                  <el-option label="HTTP + HTTPS 回源" value="HTTP_HTTPS" />
                </el-select>
              </div>
              <p v-if="customOriginPortIsDuplicate" class="origin-port-warning">自定义端口不能与已选的 80 或 443 重复。</p>
              <div v-if="selectedOriginEndpoints.length" class="origin-endpoint-preview">
                <span
                  v-for="(endpoint, index) in selectedOriginEndpoints"
                  :key="`${endpoint.protocol}-${endpoint.port}`"
                >
                  {{ index === 0 ? '主端点' : '备用端点' }} · {{ endpoint.protocol }}:{{ endpoint.port }}
                </span>
              </div>
            </div>
            <div v-if="isPureIpCreate && (createForm.httpEnabled || createForm.httpsEnabled)" class="protocol-port-grid">
              <label v-if="createForm.httpEnabled">
                <span>HTTP 访问端口 80 · 回源端口</span>
                <el-input-number v-model="createForm.pureIpHttpOriginPort" :min="1" :max="65535" controls-position="right" />
              </label>
              <label v-if="createForm.httpsEnabled">
                <span>HTTPS 访问端口 443 · 回源端口</span>
                <el-input-number v-model="createForm.pureIpHttpsOriginPort" :min="1" :max="65535" controls-position="right" />
              </label>
            </div>
            <div v-if="selectedLayer4Protocols.length" class="protocol-port-grid protocol-port-grid--l4">
              <label v-if="createForm.tcpEnabled">
                <span>TCP 访问端口 <b class="required-star" aria-hidden="true">*</b></span>
                <el-input-number v-model="createForm.tcpListenPort" data-required-field="tcpListenPort" :min="1" :max="65535" controls-position="right" @change="syncLayer4ListenPort('TCP', Number($event))" />
                <span>TCP 回源端口 <b class="required-star" aria-hidden="true">*</b></span>
                <el-input-number v-model="createForm.tcpOriginPort" data-required-field="tcpOriginPort" :min="1" :max="65535" controls-position="right" />
              </label>
              <label v-if="createForm.udpEnabled">
                <span>UDP 访问端口 <b class="required-star" aria-hidden="true">*</b></span>
                <el-input-number v-model="createForm.udpListenPort" data-required-field="udpListenPort" :min="1" :max="65535" controls-position="right" @change="syncLayer4ListenPort('UDP', Number($event))" />
                <span>UDP 回源端口 <b class="required-star" aria-hidden="true">*</b></span>
                <el-input-number v-model="createForm.udpOriginPort" data-required-field="udpOriginPort" :min="1" :max="65535" controls-position="right" />
              </label>
            </div>
          </div>
          <p class="field-help">
            {{ isPureIpCreate
              ? '支持 IPv4、IPv6 或域名源站；所选协议属于同一个服务，并使用同一节点公网 IP。'
              : '支持 IP、域名或负载均衡地址；HTTP/HTTPS 沿用成熟域名流程，TCP/UDP 作为同一域名的独立协议端点发布。' }}
          </p>
        </el-card>

        <el-card v-if="isRedirectAccessMode" class="create-section">
          <template #header>301 跳转目标</template>
          <el-input
            v-model="createForm.redirectTarget"
            data-test="create-redirect-target-input"
            :placeholder="previewRedirectTarget"
          />
          <p class="field-help">根域名默认建议跳转到 www 域名，也可以填写完整目标地址。</p>
        </el-card>

        <!-- 访问端口卡片已移除，更新时间：2026-08-30 21:12 CST。系统自动兼容 HTTP 80 与 HTTPS 443；上方只配置回源端口和协议。 -->

        <el-card class="create-section">
          <template #header>选择套餐 <b class="required-star" aria-hidden="true">*</b></template>
          <!-- 保留成熟测试与无障碍表单控件；视觉选择由下方方案 B 套餐行承担。 -->
          <el-select
            :model-value="createForm.planCode"
            class="create-plan-select-compat"
            data-test="create-plan-select"
            data-required-field="plan"
            :disabled="Boolean(domainPlanOverview?.activePush)"
            @update:model-value="handleCreatePlanSelectionChange"
          >
            <el-option
              v-for="option in createPlanOptions"
              :key="option.value"
              :label="option.label"
              :value="option.value"
              :disabled="isCreatePlanOptionDisabled(option)"
            />
          </el-select>
          <div
            class="create-plan-list"
            data-test="create-plan-options"
            data-visible-row-limit="4"
            data-required-field="plan"
            tabindex="-1"
            :class="{ 'required-control--error': showCreateIssue('plan') }"
            role="radiogroup"
            aria-label="选择套餐"
          >
            <button
              v-for="option in createPlanRows"
              :key="option.value"
              class="create-plan-row"
              :class="{
                'create-plan-row--selected': createForm.planCode === option.value,
                'create-plan-row--disabled': isCreatePlanOptionDisabled(option)
              }"
              type="button"
              role="radio"
              :aria-checked="createForm.planCode === option.value"
              :disabled="isCreatePlanOptionDisabled(option)"
              @click="markCreateFieldTouched('plan'); handleCreatePlanSelectionChange(option.value)"
            >
              <span class="create-plan-row__radio" aria-hidden="true"></span>
              <span class="create-plan-row__name">
                <strong>{{ option.choice.kind === 'FREE' ? '免费版/7天' : option.label }}</strong>
                <small v-if="option.preview || option.partitionRow?.isNew">（新）</small>
                <small v-else-if="option.partitionRow">（已有）</small>
              </span>
              <span class="create-plan-row__points">
                <span class="create-plan-row__coin" aria-hidden="true"></span>
                {{ option.choice.kind === 'FREE' ? 0 : option.choice.pointPrice }}积分/月
              </span>
              <span v-if="option.preview" class="create-plan-row__quota create-plan-row__quota--available">
                {{ option.preview.quotaLabel.replace(/\s+/g, '') }}
              </span>
              <span
                v-else-if="option.partitionRow"
                :class="`create-plan-row__quota create-plan-row__quota--${option.partitionRow.quotaTone}`"
              >
                {{ option.partitionRow.quotaLabel.replace(/\s+/g, '') }}
              </span>
              <span
                v-else-if="option.freeQuota"
                :class="`create-plan-row__quota create-plan-row__quota--${option.freeQuota.full ? 'full' : 'available'}`"
              >
                {{ option.freeQuota.quotaLabel.replace(/\s+/g, '') }}
              </span>
              <span v-else class="create-plan-row__quota create-plan-row__quota--available">专属额度</span>
              <span v-if="option.preview" class="create-plan-row__details-a11y">
                {{ option.preview.postSubmitQuotaLabel }} · 登录后按实时套餐确认
              </span>
              <span v-else-if="option.partitionRow" class="create-plan-row__details-a11y">
                {{ option.partitionRow.unavailableReason || option.partitionRow.postSubmitQuotaLabel }}
              </span>
              <span v-else-if="option.freeQuota" class="create-plan-row__details-a11y">
                {{ option.label }} · {{ option.freeQuota.full ? '额度已满 · 请改选其他套餐' : `${option.freeQuota.postSubmitQuotaLabel} · 免费版/7 天` }}
              </span>
            </button>
          </div>
          <div v-if="selectedPartitionSelection?.mode === 'NEW'" class="create-plan-renewal">
            <span>自动续费</span>
            <el-switch v-model="createPlanAutoRenew" data-test="paid-auto-renew" />
          </div>
          <p v-if="showCreateIssue('plan')" class="required-error">{{ createIssue('plan')?.message }}</p>
          <div class="selected-plan-card create-plan-selection-a11y" data-test="selected-plan-card" aria-live="polite">
            <span>当前选择</span>
            <strong>{{ selectedPlanLabel }}</strong>
            <p>{{ selectedPlanHint }}</p>
          </div>
        </el-card>

        <!-- SSL 紧凑选项样式定位修正，更新时间：2026-08-30 21:10 CST。自动免费证书继续作为默认推荐项。 -->
        <el-card v-if="isDomainCreate" class="create-section create-ssl-card">
          <template #header>SSL 证书</template>
          <el-radio-group v-if="!isRedirectAccessMode" v-model="createForm.sslMode">
            <el-radio
              v-for="option in sslModeOptions"
              :key="option.value"
              :label="option.value"
            >
              {{ option.label }}
            </el-radio>
          </el-radio-group>
          <p class="field-help">{{ sslModeHint }}</p>
        </el-card>

        <el-card v-if="isDomainCreate" class="create-section">
          <template #header>缓存设置</template>
          <div class="cache-row">
            <span>默认使用推荐缓存规则</span>
            <el-button size="small" plain>配置缓存规则</el-button>
          </div>
        </el-card>

        <el-card v-if="isDomainCreate" class="create-section">
          <template #header>WebSocket 协议</template>
          <div class="cache-row">
            <span>开启后将保留 WebSocket 长连接。</span>
            <el-switch v-model="createForm.websocketEnabled" />
          </div>
        </el-card>

        <el-card class="create-section summary-section">
          <template #header>配置摘要</template>
          <dl>
            <div :class="{ 'summary-missing': Boolean(createIssue('name')) }"><dt>{{ isPureIpCreate ? '服务名称' : '加速域名' }}</dt><dd>{{ isPureIpCreate ? (createForm.serviceName || '待填写') : (normalizedCreateDomain || '待填写') }}</dd></div>
            <div :class="{ 'summary-missing': Boolean(createIssue('plan')) }"><dt>套餐</dt><dd>{{ selectedPlanLabel }}</dd></div>
            <div v-if="isDomainCreate"><dt>接入模式</dt><dd>{{ createForm.accessMode === 'REDIRECT_301' ? '301 跳转' : 'CDN 加速' }}</dd></div>
            <div v-if="isPureIpCreate"><dt>节点模式</dt><dd>{{ createForm.deploymentMode === 'COMPONENT' ? '智能组件模式' : '单节点模式' }}</dd></div>
            <div><dt>接入地址</dt><dd>{{ isPureIpCreate ? (createForm.deploymentMode === 'COMPONENT' ? '保存后生成组件接入配置' : '保存后自动分配节点公网 IP') : previewDnsRecordValue }}</dd></div>
            <div><dt>加速区域</dt><dd>{{ selectedAccelerationRegionLabel }}</dd></div>
            <div :class="{ 'summary-missing': Boolean(createIssue('protocols')) }"><dt>加速协议</dt><dd>{{ selectedFrontendProtocols.join(' + ') || '待选择' }}</dd></div>
            <div v-if="isDomainCreate && isRedirectAccessMode"><dt>跳转目标</dt><dd>{{ normalizedRedirectTarget || previewRedirectTarget }}</dd></div>
            <div v-else :class="{ 'summary-missing': Boolean(createIssue('originAddress')) }"><dt>源站</dt><dd>{{ createForm.originAddress || '待填写' }} · {{ isPureIpCreate ? unifiedOriginSummary : originEndpointSummary }}</dd></div>
            <div><dt>SSL 证书</dt><dd>{{ isPureIpCreate ? (createForm.httpsEnabled ? '节点自动申请、部署并续期' : '当前协议不需要') : sslModeSummaryText(createForm.sslMode) }}</dd></div>
            <div v-if="isDomainCreate"><dt>缓存设置</dt><dd>默认规则</dd></div>
            <div v-if="isDomainCreate"><dt>WebSocket 协议</dt><dd>{{ createForm.websocketEnabled ? '已开启' : '已关闭' }}</dd></div>
          </dl>
          <el-button
            class="submit-access-button"
            data-test="submit-domain-access"
            type="primary"
            :loading="submitting"
            :disabled="submitting"
            @click="submitDomainAccess"
          >
            {{ isPureIpCreate ? '保存并发布' : '确认提交' }}
          </el-button>
          <p v-if="createSubmitFeedback" class="submit-feedback" data-test="submit-domain-feedback">
            {{ createSubmitFeedback }}
          </p>
        </el-card>
      </aside>

    </section>
    <el-card class="domain-deletion-history" data-test="domain-deletion-history">
      <template #header>
        <div class="domain-deletion-history__header">
          <strong>删除记录</strong>
          <span>记录来自当前账号的服务器审计</span>
        </div>
      </template>
      <p
        v-if="domainPlanOverview?.deletionHistoryReadStatus === 'PARTIAL_MALFORMED_IGNORED'"
        class="domain-deletion-history__notice"
      >{{ domainPlanOverview.malformedDeletionHistoryCount }} 条异常历史已安全忽略</p>
      <p v-if="!deletionHistory.length" class="domain-deletion-history__empty">暂无删除记录</p>
      <div v-else class="domain-deletion-history__list">
        <article v-for="item in deletionHistory" :key="item.domainId" class="domain-deletion-history__item">
          <div>
            <strong>{{ item.domain }}</strong>
            <span>域名 #{{ item.domainId }}</span>
          </div>
          <span>{{ deletionCauseText(item) }}</span>
          <span :class="item.source === 'AUTO' ? 'is-auto' : 'is-manual'">
            {{ item.source === 'AUTO' ? '自动删除' : '手动删除' }}
          </span>
          <time>{{ displayDateTime(item.deletedAt) }}</time>
        </article>
      </div>
    </el-card>
    <DomainConfigDialog v-model="configFormVisible" :domain="configuredDomain" @saved="load" />
  </section>
</template>

<style scoped>
.domains-page {
  gap: 22px;
}

/* 域名套餐生命周期组件，更新时间：2026-09-04 20:40 CST。 */
.domain-package-cell { display: flex; flex-wrap: wrap; align-items: center; gap: 8px; }
.domain-package-cell strong { color: #124f3a; }
.domain-package-cell .cell-subtext { width: 100%; }
.protection-countdown { color: #c76516; font-weight: 700; }
.domain-deletion-history { margin-top: 18px; }
.domain-deletion-history__header { display: flex; align-items: baseline; justify-content: space-between; gap: 16px; }
.domain-deletion-history__header span,
.domain-deletion-history__empty { color: #718096; font-size: 13px; }
.domain-deletion-history__notice { margin: 0 0 12px; color: #9a5a16; }
.domain-deletion-history__list { display: grid; gap: 10px; }
.domain-deletion-history__item { display: grid; grid-template-columns: minmax(190px, 1.4fr) minmax(180px, 1fr) 90px minmax(150px, auto); gap: 14px; align-items: center; padding: 12px 14px; border: 1px solid #e2e8f0; border-radius: 12px; }
.domain-deletion-history__item > div { display: grid; gap: 3px; }
.domain-deletion-history__item > div span,
.domain-deletion-history__item time { color: #718096; font-size: 13px; }
.domain-deletion-history__item .is-auto { color: #b45309; }
.domain-deletion-history__item .is-manual { color: #475569; }
.package-dialog-note { padding: 12px 14px; border-radius: 12px; background: #f5f8ef; color: #486357; }
.package-choice-card { margin-top: 14px; padding: 16px; border: 1px solid #dbe7df; border-radius: 14px; }
.package-choice-card h3 { margin: 0 0 8px; }
.package-choice-card p { color: #65756e; }
.package-choice-card .el-radio-group { display: grid; gap: 8px; margin-bottom: 12px; }
.package-choice-card .el-select { width: 100%; margin: 0 0 12px; }
/* HotX Domain Plan Modal V1.9, 2026-09-10. Stable switch labels, readable plan cards,
   and a separate bottom action prevent accidental purchase and state-label drift. */
.package-renew-row {
  display: flex;
  align-items: center;
  gap: 12px;
  min-height: 40px;
  padding: 10px 12px;
  border: 1px solid #d8e6dc;
  border-radius: 12px;
  background: #f7faf5;
}
.package-renew-label { color: #173f30; font-weight: 750; }
.package-renew-rate { margin-left: auto; color: #c83d32; font-weight: 700; }
.package-plan-options { width: 100%; }
.package-plan-option {
  box-sizing: border-box;
  width: 100%;
  min-height: 42px;
  margin: 0 !important;
  padding: 10px 12px;
  border: 1px solid #dce7df;
  border-radius: 10px;
  background: #fbfdfb;
}
.package-order-preview {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto auto;
  gap: 12px;
  align-items: center;
  margin-top: 12px;
  padding: 11px 12px;
  border-radius: 10px;
  background: #f4f8f1;
  color: #52675d;
}
.package-order-preview strong { color: #15563d; }
.package-choice-actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 16px;
  padding-top: 14px;
  border-top: 1px solid #e4ebe6;
}
.package-choice-actions .el-button { min-width: 132px; }
@media (max-width: 640px) {
  .package-order-preview { grid-template-columns: 1fr; gap: 4px; }
  .package-choice-actions .el-button { width: 100%; }
}

.domains-page .page-title-row {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  align-items: start;
  gap: 16px;
}

.domains-page .page-title-row > div:first-child {
  max-width: 720px;
}

.entry-action-button,
.submit-access-button {
  border-color: #113c29;
  background: #123f2a;
  font-weight: 800;
}

.add-domain-guide {
  /* Domain guide alignment V1.0 | 2026-09-10 CST | parent 15a7174ab7c0ae4e186433f093ac283da5bd1ea5: keep the 100% width inclusive of padding and border so every page card shares one right edge. */
  position: relative;
  overflow: hidden;
  display: grid;
  grid-template-columns: auto minmax(240px, 1fr) repeat(3, minmax(150px, auto));
  align-items: center;
  box-sizing: border-box;
  width: 100%;
  gap: 8px 16px;
  border: 1px solid rgba(18, 63, 42, 0.14);
  border-radius: 12px;
  padding: 12px 14px 12px 16px;
  background: rgba(255, 255, 255, 0.86);
  box-shadow: 0 14px 32px rgba(23, 35, 29, 0.1);
}

.add-domain-guide::before {
  content: none;
}

.add-domain-guide::after {
  content: none;
}

.add-domain-guide--animated {
  background:
    linear-gradient(110deg, rgba(255, 255, 255, 0) 18%, rgba(255, 255, 255, 0.62) 42%, rgba(255, 255, 255, 0) 64%) -220px 0 / 220px 100% no-repeat,
    rgba(255, 255, 255, 0.82);
  animation: add-domain-guide-shimmer 3.4s ease-in-out 2;
}

.add-domain-guide strong {
  position: relative;
  z-index: 2;
  color: #132b20;
  font-size: 16px;
  white-space: nowrap;
}

.add-domain-guide > span:last-of-type {
  position: relative;
  z-index: 2;
  grid-column: 2 / 3;
  color: #617268;
  font-size: 12px;
  font-weight: 700;
}

.guide-step-badge {
  position: relative;
  z-index: 2;
  grid-row: span 2;
  border-radius: 999px;
  padding: 6px 10px;
  color: #ffffff;
  background: #d48924;
  font-size: 12px;
  font-weight: 900;
  box-shadow: 0 0 0 0 rgba(212, 137, 36, 0.28);
  animation: add-domain-badge-pulse 2.6s ease-in-out 2;
}

.add-domain-guide .entry-action-button {
  --entry-base: #0b5b3e;
  --entry-highlight: #1a7652;
  --entry-deep: #07492f;
  --entry-border: #084a31;
  --entry-label: #ffffff;
  --entry-shadow: rgba(11, 91, 62, 0.3);
  --entry-shadow-strong: rgba(6, 50, 33, 0.38);
  --entry-tilt-x: 0deg;
  --entry-tilt-y: 0deg;
  position: relative;
  z-index: 2;
  grid-row: 1 / 3;
  width: 154px;
  min-height: 44px;
  margin: 0;
  overflow: hidden;
  border: 1px solid var(--entry-border);
  border-radius: 10px;
  padding: 0 22px;
  color: var(--entry-label);
  background: linear-gradient(145deg, var(--entry-highlight) 0%, var(--entry-base) 70%, var(--entry-deep) 100%);
  background-size: 145% 100%;
  font-size: 14px;
  font-weight: 800;
  text-shadow: 0 1px 1px rgba(0, 0, 0, 0.14);
  box-shadow:
    inset 0 1px 0 rgba(255, 255, 255, 0.42),
    inset 0 -5px 8px rgba(0, 0, 0, 0.15),
    0 10px 14px -7px var(--entry-shadow-strong),
    0 18px 30px -14px var(--entry-shadow);
  transform: perspective(760px) rotateX(var(--entry-tilt-x)) rotateY(var(--entry-tilt-y));
  transform-origin: 50% 70%;
  translate: 0 0;
  scale: 1;
  touch-action: manipulation;
  transition:
    transform 140ms ease-out,
    translate 220ms cubic-bezier(0.16, 1, 0.3, 1),
    scale 220ms cubic-bezier(0.16, 1, 0.3, 1),
    background-position 220ms ease,
    box-shadow 220ms ease,
    filter 220ms ease;
  animation:
    entry-action-reveal 0.52s cubic-bezier(0.16, 1, 0.3, 1) both,
    add-domain-cta-pulse 4.1s ease-in-out 0.62s infinite;
  will-change: transform;
}

.add-domain-guide .entry-action-button::before {
  content: '';
  position: absolute;
  inset: 1px 7px auto;
  height: 42%;
  border-radius: 9px 9px 55% 55%;
  pointer-events: none;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.3), rgba(255, 255, 255, 0));
  mix-blend-mode: soft-light;
}

.add-domain-guide .add-domain-button {
  grid-column: 3 / 4;
}

.add-domain-guide .pure-ip-button {
  --entry-base: #b9541c;
  --entry-highlight: #cf6b2b;
  --entry-deep: #913e13;
  --entry-border: #9b4618;
  --entry-shadow: rgba(151, 65, 19, 0.32);
  --entry-shadow-strong: rgba(100, 42, 12, 0.4);
  grid-column: 4 / 5;
  animation-delay: 0.1s, 0.98s;
}

.add-domain-guide .free-cdn-button {
  --entry-base: #d1aa35;
  --entry-highlight: #e7cb64;
  --entry-deep: #b58c1f;
  --entry-border: #b79026;
  --entry-label: #30280b;
  --entry-shadow: rgba(145, 111, 24, 0.3);
  --entry-shadow-strong: rgba(100, 77, 16, 0.38);
  grid-column: 5 / 6;
  animation-delay: 0.2s, 1.34s;
}

.add-domain-guide .entry-action-button::after {
  content: '';
  position: absolute;
  inset: -30% auto -30% -45%;
  width: 32%;
  pointer-events: none;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.66), transparent);
  transform: skewX(-18deg);
  animation: entry-action-shine 4.1s cubic-bezier(0.22, 0.7, 0.25, 1) 0.72s infinite;
}

.add-domain-guide .pure-ip-button::after {
  animation-delay: 1.08s;
}

.add-domain-guide .free-cdn-button::after {
  animation-delay: 1.44s;
}

.add-domain-guide .entry-action-button:hover,
.add-domain-guide .entry-action-button:focus-visible {
  --entry-tilt-x: -3deg;
  --entry-tilt-y: 1deg;
  border-color: var(--entry-border);
  color: var(--entry-label);
  background-position: 100% 0;
  translate: 0 -4px;
  scale: 1.018;
  filter: saturate(1.04);
  box-shadow:
    inset 0 1px 0 rgba(255, 255, 255, 0.52),
    inset 0 -5px 8px rgba(0, 0, 0, 0.12),
    0 14px 18px -8px var(--entry-shadow-strong),
    0 24px 36px -15px var(--entry-shadow);
}

.add-domain-guide .entry-action-button:focus-visible {
  outline: 2px solid var(--entry-border);
  outline-offset: 3px;
}

.add-domain-guide .entry-action-button:active {
  translate: 0 1px;
  scale: 0.992;
  box-shadow:
    inset 0 2px 7px rgba(0, 0, 0, 0.2),
    0 7px 12px -7px var(--entry-shadow-strong);
}

@keyframes entry-action-reveal {
  from { opacity: 0; clip-path: inset(0 0 0 24%); filter: blur(3px); }
  to { opacity: 1; clip-path: inset(0); filter: blur(0); }
}

@keyframes entry-action-shine {
  0%, 14% { opacity: 0; transform: translateX(0) skewX(-18deg); }
  24% { opacity: 1; }
  42%, 100% { opacity: 0; transform: translateX(520%) skewX(-18deg); }
}

@keyframes add-domain-cta-pulse {
  0%, 15%, 46%, 100% {
    box-shadow:
      inset 0 1px 0 rgba(255, 255, 255, 0.42),
      inset 0 -5px 8px rgba(0, 0, 0, 0.15),
      0 10px 14px -7px var(--entry-shadow-strong),
      0 18px 30px -14px var(--entry-shadow);
  }

  28% {
    box-shadow:
      inset 0 1px 0 rgba(255, 255, 255, 0.5),
      inset 0 -5px 8px rgba(0, 0, 0, 0.12),
      0 14px 18px -8px var(--entry-shadow-strong),
      0 23px 34px -14px var(--entry-shadow);
  }
}

@keyframes add-domain-guide-shimmer {
  0%,
  38% {
    background-position: -220px 0, 0 0, 0 0;
  }

  72%,
  100% {
    background-position: calc(100% + 220px) 0, 0 0, 0 0;
  }
}

@keyframes add-domain-arrow-flow {
  0%,
  100% {
    opacity: 0.45;
    transform: translate(-6px, -50%);
  }

  50% {
    opacity: 1;
    transform: translate(0, -50%);
  }
}

@keyframes add-domain-arrow-head {
  0%,
  100% {
    opacity: 0.55;
    transform: translate(-5px, -50%) rotate(45deg);
  }

  50% {
    opacity: 1;
    transform: translate(0, -50%) rotate(45deg);
  }
}

@keyframes add-domain-badge-pulse {
  0%,
  100% {
    box-shadow: 0 0 0 0 rgba(212, 137, 36, 0.28);
  }

  50% {
    box-shadow: 0 0 0 7px rgba(212, 137, 36, 0);
  }
}

@media (prefers-reduced-motion: reduce) {
  .add-domain-guide--animated,
  .guide-step-badge,
  .add-domain-guide .entry-action-button,
  .add-domain-guide .entry-action-button::after {
    animation: none;
  }

  .add-domain-guide .entry-action-button:hover,
  .add-domain-guide .entry-action-button:focus-visible {
    --entry-tilt-x: 0deg;
    --entry-tilt-y: 0deg;
    translate: 0 0;
    scale: 1;
    transition: none;
  }
}

.domain-summary-card :deep(.el-card__body) {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  padding: 0;
}

.summary-item {
  display: grid;
  min-height: 82px;
  align-content: center;
  gap: 8px;
  padding: 18px 24px;
  border-right: 1px solid rgba(23, 35, 29, 0.1);
}

.summary-item:last-child {
  border-right: 0;
}

.summary-item span {
  color: #52675d;
  font-weight: 700;
}

.summary-item strong {
  color: #1d2d25;
  font-size: 28px;
  line-height: 1;
}

.summary-dot {
  display: inline-block;
  width: 9px;
  height: 9px;
  border-radius: 999px;
}

.summary-dot.ok {
  background: #3c8c50;
}

.summary-dot.warning {
  background: #e6982d;
}

.summary-dot.danger {
  background: #e4584f;
}

.summary-dot.muted {
  background: #9aa69f;
}

.domain-draft-notice,
.free-cdn-intent-note {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  border: 1px solid rgba(212, 137, 36, 0.32);
  border-radius: 8px;
  padding: 12px 14px;
  color: #3d2b12;
  background: #fff8e8;
}

.domain-draft-notice strong,
.free-cdn-intent-note strong {
  color: #173625;
}

.domain-draft-notice p,
.free-cdn-intent-note p {
  margin: 4px 0 0;
  color: #6c5a38;
  font-size: 13px;
}

.draft-notice-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.draft-action-link {
  display: inline-flex;
  align-items: center;
  min-height: 32px;
  border: 1px solid rgba(18, 63, 42, 0.18);
  border-radius: 8px;
  padding: 0 12px;
  color: #123f2a;
  background: #ffffff;
  font-size: 13px;
  font-weight: 900;
}

.draft-action-link--primary {
  color: #ffffff;
  border-color: #123f2a;
  background: #123f2a;
}

.domain-workbench {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 18px;
}

/* Keep the selected C09-style domain page behavior:
   when adding a domain or applying for free CDN, the form is a right-side workbench
   panel. It must not jump above the domain list as a full-width block, because that
   breaks the user's selected flow and makes the page feel like a different version.
   Certificate issuance UI is intentionally not controlled here. */
.domain-workbench.with-create-panel {
  /* V1.7-resizable-workbench, 2026-09-09 CST: the middle track is an
     interactive separator; the right pane always receives the remaining room. */
  grid-template-columns: minmax(360px, var(--create-panel-width, 430px)) 22px minmax(0, 1fr);
  align-items: start;
  gap: 0;
}

.domain-workbench.with-create-panel > .create-domain-panel {
  order: -1;
}

.domain-workbench.with-create-panel > .domain-list-panel {
  order: 1;
}

.domain-workbench-splitter {
  position: sticky;
  top: 18px;
  order: 0;
  z-index: 4;
  display: grid;
  width: 22px;
  height: calc(100vh - 36px);
  place-items: center;
  outline: none;
  cursor: col-resize;
  touch-action: none;
}

.domain-workbench-splitter::before {
  position: absolute;
  width: 2px;
  height: 100%;
  border-radius: 999px;
  background: rgba(18, 63, 42, 0.12);
  content: '';
  transition: background 160ms ease, box-shadow 160ms ease;
}

.domain-workbench-splitter-grip {
  position: relative;
  width: 8px;
  height: 54px;
  border: 1px solid rgba(18, 63, 42, 0.2);
  border-radius: 999px;
  opacity: 0;
  background: #ffffff;
  box-shadow: 0 8px 24px rgba(18, 63, 42, 0.14);
  transition: opacity 160ms ease, transform 160ms ease, border-color 160ms ease;
}

.domain-workbench-splitter:hover::before,
.domain-workbench-splitter:focus-visible::before,
.domain-workbench-splitter--active::before {
  width: 3px;
  background: #16845c;
  box-shadow: 0 0 0 5px rgba(22, 132, 92, 0.1);
}

.domain-workbench-splitter:hover .domain-workbench-splitter-grip,
.domain-workbench-splitter:focus-visible .domain-workbench-splitter-grip,
.domain-workbench-splitter--active .domain-workbench-splitter-grip {
  border-color: rgba(22, 132, 92, 0.45);
  opacity: 1;
  transform: scaleY(1.05);
}

.domain-workbench.is-resizing,
:global(body.domain-workbench-resizing) {
  cursor: col-resize;
  user-select: none;
}

.domain-list-panel {
  display: grid;
  min-width: 0;
  gap: 18px;
  overflow: hidden;
  container-name: domain-list-panel;
  container-type: inline-size;
}

.domain-filter-card :deep(.el-card__body) {
  padding: 16px;
}

.domain-filter-row {
  display: grid;
  grid-template-columns: minmax(220px, 360px) minmax(0, 1fr);
  align-items: center;
  gap: 12px;
}

.domain-filter-controls {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
}

/* 筛选与刷新按钮布局，更新时间：2026-08-30 15:35 CST。窄屏时允许自然换行，避免挤压搜索框。 */
.domain-filter-tabs {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 8px;
}

.domain-name-cell,
.domain-status-cell,
.certificate-status-cell {
  display: grid;
  gap: 6px;
}

.domain-name-cell strong {
  color: #1d2d25;
  font-size: 14px;
}

.domain-name-cell span,
.cell-subtext {
  color: #6a786f;
  font-size: 12px;
  font-weight: 700;
}

.status-pill {
  display: inline-flex;
  align-items: center;
  width: max-content;
  border-radius: 999px;
  padding: 4px 10px;
  font-size: 12px;
  font-weight: 800;
}

.status-ok {
  color: #12622d;
  background: #e7f5df;
}

.status-waiting {
  color: #1552a0;
  background: #e7f0ff;
}

.status-paused {
  color: #5b6470;
  background: #eef1f0;
}

.status-bad {
  color: #b82121;
  background: #fde9e7;
}

.status-muted {
  color: #52675d;
  background: #eef4ef;
}

.certificate-pill {
  display: inline-flex;
  align-items: center;
  width: max-content;
  max-width: 100%;
  border-radius: 999px;
  padding: 4px 10px;
  font-size: 12px;
  font-weight: 900;
}

.certificate-pill--ok {
  color: #12622d;
  background: #e7f5df;
}

.certificate-pill--waiting {
  color: #1552a0;
  background: #e7f0ff;
}

.certificate-pill--bad {
  color: #b82121;
  background: #fde9e7;
}

.certificate-pill--muted {
  color: #52675d;
  background: #eef4ef;
}

.table-copy-line,
.copy-line {
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;
  gap: 8px;
}

.table-copy-line code,
.copy-line code {
  border-radius: 999px;
  padding: 5px 9px;
  color: #123f2a;
  background: #eef8ec;
  overflow-wrap: anywhere;
}

.table-copy-line code {
  max-width: 100%;
  white-space: normal;
}

.access-address-cell code {
  border-radius: 12px;
  line-height: 1.55;
}

.config-overview,
.domain-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.config-chip {
  display: inline-flex;
  align-items: center;
  min-height: 28px;
  border: 1px solid rgba(18, 63, 42, 0.12);
  border-radius: 999px;
  padding: 4px 10px;
  color: #17492e;
  background: #f2faf0;
  font-size: 12px;
  font-weight: 800;
}

.config-chip.is-enabled {
  color: #12622d;
  border-color: rgba(47, 123, 73, 0.24);
  background: #e7f5df;
}

.config-chip.is-muted {
  color: #6a786f;
  background: #f2f5f2;
}

.cache-row,
.port-grid {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.diagnosis-header {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
}

.diagnosis-tag {
  border-radius: 999px;
  padding: 4px 10px;
  color: #2f5b8f;
  background: #e7f0ff;
  font-size: 12px;
  font-weight: 800;
}

.diagnosis-layout {
  display: grid;
  grid-template-columns: 210px minmax(0, 1fr) 220px;
  gap: 18px;
}

.diagnosis-visual {
  display: grid;
  align-content: center;
  gap: 12px;
  min-height: 150px;
  padding: 16px;
  border-radius: 16px;
  background: #f7faf5;
}

.access-flow {
  display: grid;
  gap: 10px;
}

.flow-step {
  display: flex;
  align-items: center;
  gap: 10px;
  border: 1px solid rgba(18, 63, 42, 0.12);
  border-radius: 14px;
  padding: 10px 12px;
  background: #fff;
}

.flow-step-index {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 26px;
  width: 26px;
  height: 26px;
  border-radius: 999px;
  color: #ffffff;
  background: #2f7b49;
  font-size: 13px;
  font-weight: 900;
}

.flow-step div {
  display: grid;
  gap: 3px;
}

.flow-step strong {
  color: #143d28;
  font-size: 13px;
}

.flow-step span {
  color: #607166;
  font-size: 12px;
  font-weight: 700;
}

.diagnosis-main h2 {
  margin: 0 0 8px;
  font-size: 20px;
}

.diagnosis-result-card {
  display: grid;
  grid-template-columns: auto minmax(0, 1fr);
  align-items: center;
  gap: 14px;
  border: 1px solid rgba(47, 123, 73, 0.18);
  border-radius: 18px;
  padding: 14px 16px;
  background:
    radial-gradient(circle at 0% 0%, rgba(64, 140, 83, 0.14), transparent 11rem),
    #f7fbf4;
}

.diagnosis-result-card p {
  margin: 0;
}

.diagnosis-result-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border-radius: 999px;
  color: #ffffff;
  background: #2f7b49;
  box-shadow: 0 12px 26px rgba(47, 123, 73, 0.22);
  font-size: 24px;
  font-weight: 900;
}

/* Root301 pending/failed facts must not use a success checkmark or green panel. */
.root301-result--waiting { background: #fffaf0; border-color: #ead9b3; }
.root301-result--waiting .diagnosis-result-icon { background: #986918; box-shadow: none; }
.root301-result--bad { background: #fff4f3; border-color: #edceca; }
.root301-result--bad .diagnosis-result-icon { background: #b34438; box-shadow: none; }
.root301-result--muted { background: #f5f6f6; border-color: #d9dedd; }
.root301-result--muted .diagnosis-result-icon { background: #66736c; box-shadow: none; }

.dns-status-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin: 14px 0;
}

.dns-status-grid span {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border: 1px solid rgba(18, 63, 42, 0.12);
  border-radius: 999px;
  padding: 6px 10px;
  color: #254535;
  background: #f7fbf4;
  font-size: 12px;
}

.dns-status-grid strong {
  color: #123f2a;
}

.root301-status-grid { display: grid; gap: 10px; margin: 12px 0; }
.root301-state { display: grid; justify-items: start; gap: 6px; padding: 12px; border: 1px solid var(--el-border-color-lighter); border-radius: 8px; }
.root301-state p { margin: 0; }
.root301-state code { overflow-wrap: anywhere; word-break: break-word; }
.root301-state small { color: var(--el-text-color-secondary); }

.focused-certificate-status {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  margin: 0 0 14px;
  border: 1px solid rgba(18, 63, 42, 0.1);
  border-radius: 8px;
  padding: 10px 12px;
  background: #ffffff;
}

.focused-certificate-status p {
  flex: 1 1 220px;
  margin: 0;
  color: #6a4b28;
  font-size: 13px;
  font-weight: 800;
  overflow-wrap: anywhere;
}

.diagnosis-address-grid {
  display: grid;
  grid-template-columns: minmax(0, 0.9fr) minmax(0, 1.2fr);
  gap: 12px;
  margin: 0 0 14px;
}

.diagnosis-address-item {
  display: grid;
  gap: 8px;
  border: 1px solid rgba(18, 63, 42, 0.1);
  border-radius: 16px;
  padding: 12px;
  background: #ffffff;
}

.diagnosis-address-item code {
  width: max-content;
  max-width: 100%;
  border-radius: 999px;
  padding: 6px 10px;
  color: #123f2a;
  background: #eef8ec;
  overflow-wrap: anywhere;
  white-space: normal;
}

.next-steps {
  margin: 0 0 14px;
  padding-left: 20px;
  color: #34483d;
  line-height: 1.7;
}

.next-step-summary {
  margin: 0 0 8px;
  color: #214b32;
  font-weight: 800;
}

.diagnosis-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin: 0 0 12px;
}

.free-ssl-link {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 34px;
  border: 1px solid #113c29;
  border-radius: 8px;
  padding: 0 14px;
  color: #ffffff;
  background: #123f2a;
  font-size: 13px;
  font-weight: 800;
  text-decoration: none;
}

/* HotX V1.7 unified-flow UI, updated 2026-09-09 CST, version V1.7-mode-guidance, parent dbf4516c6a. */
.pure-ip-mode-picker {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
}

.pure-ip-mode-option {
  display: grid;
  gap: 9px;
  min-height: 108px;
  border: 1px solid #d4e3da;
  border-radius: 12px;
  padding: 15px 16px;
  color: #30493c;
  background: #fbfdfb;
  text-align: left;
  cursor: pointer;
  transition: border-color 160ms ease, box-shadow 160ms ease, transform 160ms ease, background 160ms ease;
}

.pure-ip-mode-option:hover,
.pure-ip-mode-option:focus-visible {
  border-color: #5a9776;
  outline: none;
  transform: translateY(-1px);
}

.pure-ip-mode-option--active {
  border-color: #117a50;
  background: #eef8f1;
  box-shadow: inset 0 0 0 1px rgba(17, 122, 80, 0.18), 0 8px 20px rgba(17, 86, 57, 0.09);
}

.pure-ip-mode-option span {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}

.pure-ip-mode-option strong {
  color: #143d2a;
  font-size: 15px;
}

.pure-ip-mode-option small {
  border-radius: 999px;
  padding: 3px 8px;
  color: #176d4a;
  background: #e0f1e6;
  font-size: 11px;
  font-weight: 800;
}

.pure-ip-mode-option p,
.component-readiness-note p {
  margin: 0;
  color: #66796f;
  font-size: 12px;
  line-height: 1.65;
}

.component-readiness-note {
  display: grid;
  gap: 5px;
  margin-top: 12px;
  border: 1px solid #e6c574;
  border-radius: 10px;
  padding: 11px 13px;
  color: #65460d;
  background: #fff8df;
}

.component-readiness-note p {
  color: #725b2d;
}

.frontend-protocol-picker {
  display: grid;
  grid-template-columns: minmax(180px, 0.8fr) minmax(260px, 1.2fr);
  align-items: center;
  gap: 14px;
  margin-bottom: 16px;
  padding: 14px 16px;
  border: 1px solid #d5e5dc;
  border-radius: 12px;
  background: #f5faf5;
}

.frontend-protocol-picker > div:first-child,
.frontend-protocol-options,
.protocol-port-grid label,
.unified-service-state,
.unified-service-identity,
.unified-service-access {
  display: flex;
  gap: 8px;
}

.frontend-protocol-picker > div:first-child,
.unified-service-state,
.unified-service-identity,
.unified-service-access {
  flex-direction: column;
}

.frontend-protocol-picker span,
.unified-service-row small,
.unified-service-row .unified-service-identity > span:last-child {
  color: #6a7d73;
  font-size: 12px;
}

.frontend-protocol-options {
  flex-wrap: wrap;
  align-items: center;
}

.node-certificate-note {
  margin-bottom: 16px;
}

.protocol-port-grid {
  grid-column: 1 / -1;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
}

.protocol-port-grid label {
  display: grid;
  grid-template-columns: minmax(120px, 1fr) minmax(120px, auto);
  align-items: center;
  padding: 12px;
  border: 1px solid #dce8e1;
  border-radius: 10px;
  background: #fff;
}

.protocol-port-grid--l4 label {
  grid-template-columns: minmax(110px, 1fr) minmax(120px, auto);
}

.unified-protocol-badge,
.unified-service-kind {
  width: max-content;
  padding: 3px 8px;
  border-radius: 999px;
  color: #0c714f;
  font-size: 12px;
  font-weight: 800;
  background: #e9f8ee;
}

.unified-service-rows {
  border: 1px solid #e0e8e3;
  border-radius: 12px;
  background: #fff;
}

.unified-service-row {
  display: grid;
  grid-template-columns: minmax(200px, 1.25fr) minmax(150px, 0.8fr) minmax(230px, 1.1fr) auto;
  align-items: center;
  gap: 20px;
  padding: 18px 20px;
}

.unified-service-row + .unified-service-row {
  border-top: 1px solid #e8eeea;
}

.unified-service-access code {
  color: #104b36;
  font-weight: 800;
}

.unified-service-actions {
  justify-content: flex-end;
}

.diagnosis-faq {
  display: grid;
  align-content: start;
  gap: 10px;
  border-left: 1px solid rgba(23, 35, 29, 0.08);
  padding-left: 18px;
}

.diagnosis-faq a {
  color: #225b39;
  font-weight: 700;
}

.create-domain-panel {
  position: sticky;
  top: 18px;
  display: grid;
  min-width: 0;
  max-height: calc(100vh - 36px);
  gap: 14px;
  overflow: auto;
  border: 1px solid rgba(18, 63, 42, 0.2);
  border-radius: 22px;
  padding: 20px;
  background: rgba(255, 255, 255, 0.9);
  box-shadow: 0 22px 70px rgba(21, 47, 34, 0.16);
  container-name: create-domain-panel;
  container-type: inline-size;
}

.create-domain-panel :deep(.el-input),
.create-domain-panel :deep(.el-input-number),
.create-domain-panel :deep(.el-select) {
  min-width: 0;
  max-width: 100%;
}

@container create-domain-panel (max-width: 520px) {
  .frontend-protocol-picker,
  .protocol-port-grid,
  .pure-ip-mode-picker {
    grid-template-columns: minmax(0, 1fr);
  }

  .protocol-port-grid label,
  .protocol-port-grid--l4 label {
    grid-template-columns: minmax(0, 1fr);
  }

  .create-panel-header {
    flex-wrap: wrap;
  }

  .create-panel-header > .el-button {
    margin-left: auto;
  }
}

@container domain-list-panel (max-width: 900px) {
  .domain-filter-row,
  .diagnosis-layout,
  .diagnosis-address-grid,
  .unified-service-row {
    grid-template-columns: minmax(0, 1fr);
  }

  .domain-filter-controls,
  .diagnosis-faq {
    border-left: 0;
    padding-left: 0;
  }

  .diagnosis-faq {
    border-top: 1px solid rgba(23, 35, 29, 0.08);
    padding-top: 16px;
  }

  .unified-service-actions,
  .domain-filter-controls {
    justify-content: flex-start;
  }
}

.create-panel-header {
  display: flex;
  justify-content: space-between;
  gap: 18px;
  border-bottom: 1px solid rgba(23, 35, 29, 0.1);
  padding-bottom: 14px;
}

.create-panel-header h2 {
  margin: 0;
  font-size: 26px;
}

.create-panel-header p {
  margin: 6px 0 0;
  color: #607166;
}

/* Console 0.1.102 / 2026-09-15 17:00 CST / parent 779e1d1306e415b64cff81a062437427f1cd1d23.
 * CDN-PACKAGE-COMPACT-ROW-VISUAL-FIX-20260915: 严格复现选定方案 B，一行展示套餐、积分和额度；四行后才滚动。 */
.create-plan-list {
  display: grid;
  gap: 6px;
  max-block-size: 198px;
  overflow-y: auto;
  padding: 2px 4px 2px 2px;
  scroll-behavior: smooth;
  scrollbar-color: #9fc4ae transparent;
  scrollbar-width: thin;
}

.create-plan-list::-webkit-scrollbar {
  width: 6px;
}

.create-plan-list::-webkit-scrollbar-thumb {
  border-radius: 999px;
  background: #9fc4ae;
}

.create-plan-list::-webkit-scrollbar-track {
  background: transparent;
}

.create-plan-select-compat {
  position: absolute;
  inline-size: 1px;
  block-size: 1px;
  opacity: 0;
  pointer-events: none;
}

.create-plan-row {
  display: grid;
  grid-template-columns: 14px minmax(70px, 1fr) max-content max-content;
  column-gap: 5px;
  align-items: center;
  min-height: 44px;
  border: 1px solid #d7e4db;
  border-radius: 8px;
  padding: 6px;
  color: #243d2e;
  background: #fff;
  cursor: pointer;
  text-align: left;
}

.create-plan-row:hover,
.create-plan-row:focus-visible {
  border-color: #21875c;
  outline: 2px solid rgba(33, 135, 92, 0.18);
  outline-offset: 1px;
}

.create-plan-row--selected {
  border-color: #168155;
  background: #eff9f2;
}

.create-plan-row--disabled {
  color: #8a948e;
  background: #f5f6f5;
  cursor: not-allowed;
  opacity: 0.82;
}

.create-plan-row__radio {
  display: grid;
  inline-size: 14px;
  block-size: 14px;
  place-items: center;
  border: 1px solid #9eb7a8;
  border-radius: 50%;
  background: #fff;
}

.create-plan-row__radio::after {
  inline-size: 7px;
  block-size: 7px;
  border-radius: 50%;
  background: #147b53;
  content: '';
  transform: scale(0);
  transition: transform 140ms ease-out;
}

.create-plan-row--selected .create-plan-row__radio::after {
  transform: scale(1);
}

.create-plan-row__name {
  display: flex;
  min-width: 0;
  align-items: baseline;
  gap: 2px;
}

.create-plan-row__name strong {
  overflow: hidden;
  color: #173a29;
  font-size: 12px;
  font-weight: 800;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.create-plan-row__name small {
  flex: 0 0 auto;
  color: #587064;
  font-size: 10px;
  font-weight: 700;
}

.create-plan-row__points {
  display: inline-flex;
  min-height: 22px;
  align-items: center;
  gap: 3px;
  border: 1px solid #f0d488;
  border-radius: 999px;
  padding: 2px 5px;
  color: #77520a;
  background: #fff3c8;
  font-size: 10.5px;
  font-weight: 800;
  line-height: 1;
  white-space: nowrap;
}

.create-plan-row__coin {
  inline-size: 8px;
  block-size: 8px;
  border: 1.5px solid #d89a16;
  border-radius: 50%;
  box-shadow: inset 0 0 0 1px #fff3c8;
}

.create-plan-row__quota {
  justify-self: end;
  font-size: 10.5px;
  font-weight: 800;
  white-space: nowrap;
}

.create-plan-row__quota--available {
  color: #13734d;
}

.create-plan-row__quota--warning {
  color: #a86608;
}

.create-plan-row__quota--full,
.create-plan-row__quota--muted {
  color: #8a938d;
}

.create-plan-row__details-a11y,
.create-plan-selection-a11y {
  position: absolute;
  inline-size: 1px;
  block-size: 1px;
  margin: -1px;
  overflow: hidden;
  clip-path: inset(50%);
  white-space: nowrap;
}

.create-section :deep(.el-card__body) {
  display: grid;
  gap: 10px;
}

/* 接入地址分步动画，更新时间：2026-08-30 20:35 CST。动画只承担操作引导，不触发复制或提交。 */
.create-access-guide {
  overflow: visible;
  border-color: rgba(32, 132, 84, 0.3);
  background: linear-gradient(145deg, #ffffff 0%, #f3fbf5 100%);
}

/* 来源：console-google-popup-return-20260915；CST 2026-09-15 18:13；父基线 4a9da857e3a1caa6d06408a7b39dc76daae633ab。
 * CNAME 对照区只显示低干扰的流向扫光，表达“平台记录 → DNS 服务商”；不改动记录内容、复制行为或布局尺寸。
 * 使用独立遮罩层，避免 Element Plus 卡片背景样式覆盖动画而出现“状态在跑、画面不动”的假引导。 */
.create-access-guide--animated {
  position: relative;
  isolation: isolate;
  overflow: hidden;
}

.create-access-guide--animated::before {
  content: none;
}

@keyframes access-guide-cname-flow {
  0%, 30% { transform: translateX(-115%); }
  70%, 100% { transform: translateX(115%); }
}

@media (prefers-reduced-motion: reduce) {
  .create-access-guide--animated::before {
    animation: none;
  }
}

.access-guide-header,
.required-field-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}

.access-guide-badge,
.origin-required-badge {
  display: inline-flex;
  align-items: center;
  min-height: 26px;
  border-radius: 999px;
  padding: 4px 10px;
  color: #12613b;
  background: #e5f7e9;
  font-size: 11px;
  font-weight: 900;
}

.access-guide-value {
  position: relative;
  display: grid;
  grid-template-columns: auto minmax(0, 1fr);
  align-items: center;
  gap: 10px;
  overflow: hidden;
  border: 1px solid rgba(24, 115, 71, 0.2);
  border-radius: 12px;
  padding: 11px 12px;
  background: #f7fbf7;
}

.access-guide-value::after {
  content: "";
  position: absolute;
  inset: 0 auto 0 -35%;
  width: 28%;
  background: linear-gradient(90deg, transparent, rgba(236, 169, 58, 0.2), transparent);
  transform: skewX(-18deg);
  animation: access-guide-shimmer 3.2s ease-in-out infinite;
}

.access-guide-value > span {
  border-radius: 999px;
  padding: 4px 8px;
  color: #ffffff;
  background: #12613b;
  font-size: 11px;
  font-weight: 900;
}

.access-guide-value code {
  min-width: 0;
  color: #19412d;
  font-size: 12px;
  font-weight: 800;
  overflow-wrap: anywhere;
}

.access-guide-steps {
  position: relative;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 6px;
  padding-top: 12px;
}

.access-guide-cursor {
  position: absolute;
  top: -2px;
  left: 11%;
  z-index: 2;
  width: 13px;
  height: 17px;
  clip-path: polygon(0 0, 100% 58%, 62% 68%, 45% 100%);
  background: #dc9222;
  filter: drop-shadow(0 3px 4px rgba(170, 101, 10, 0.28));
  animation: access-guide-cursor-tour 6s ease-in-out infinite;
}

.access-guide-step {
  display: grid;
  justify-items: center;
  gap: 4px;
  border: 1px solid rgba(24, 115, 71, 0.1);
  border-radius: 10px;
  padding: 9px 4px 8px;
  color: #557065;
  background: rgba(255, 255, 255, 0.78);
  font-size: 10px;
  text-align: center;
  animation: access-guide-step-focus 6s ease-in-out infinite;
}

.access-guide-step strong {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  color: #ffffff;
  background: #16663f;
  font-size: 11px;
}

.access-guide-step--two {
  animation-delay: 2s;
}

.access-guide-step--three {
  animation-delay: 4s;
}

/* CDN 源站必填引导，更新时间：2026-08-30 20:35 CST。用户输入源站后呼吸效果立即停止。 */
.origin-required-guide {
  border-color: rgba(220, 146, 34, 0.28);
  background: linear-gradient(145deg, #ffffff 0%, #fffbf2 100%);
}

.origin-required-badge {
  color: #8d5609;
  background: #fff0cf;
}

.access-port-default-badge {
  display: inline-flex;
  align-items: center;
  min-height: 26px;
  border-radius: 999px;
  padding: 4px 10px;
  color: #12613b;
  background: #e5f7e9;
  font-size: 11px;
  font-weight: 900;
}

/* 回源端口多选区，更新时间：2026-08-30 20:46 CST。预览顺序与真实主、备用端点的保存顺序保持一致。 */
.origin-port-selector {
  display: grid;
  gap: 10px;
  border: 1px solid rgba(24, 115, 71, 0.14);
  border-radius: 12px;
  padding: 11px;
  background: rgba(247, 251, 247, 0.9);
}

.origin-port-heading {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 6px;
  color: #244d36;
  font-size: 12px;
}

.origin-port-heading span {
  color: #708077;
  font-size: 11px;
}

.origin-port-options,
.custom-origin-port-row,
.origin-endpoint-preview {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 9px;
}

.custom-origin-port-row :deep(.el-input-number),
.custom-origin-port-row :deep(.el-select) {
  width: min(100%, 160px);
}

.origin-endpoint-preview span {
  display: inline-flex;
  align-items: center;
  min-height: 27px;
  border-radius: 999px;
  padding: 4px 9px;
  color: #145b38;
  background: #e8f7eb;
  font-size: 11px;
  font-weight: 800;
}

.origin-port-warning {
  margin: 0;
  color: #c34732;
  font-size: 11px;
  font-weight: 700;
}

.origin-guide-message {
  display: flex;
  align-items: center;
  gap: 9px;
  border-radius: 10px;
  padding: 9px 10px;
  color: #79500f;
  background: #fff5df;
  font-size: 12px;
}

.origin-guide-message > span {
  width: 10px;
  height: 10px;
  flex: 0 0 auto;
  border-radius: 50%;
  background: #e59c25;
  box-shadow: 0 0 0 0 rgba(229, 156, 37, 0.36);
  animation: origin-guide-dot-pulse 1.8s ease-out infinite;
}

.origin-required-guide--active .origin-address-input :deep(.el-input__wrapper) {
  box-shadow: 0 0 0 1px rgba(229, 156, 37, 0.72) inset, 0 0 0 0 rgba(229, 156, 37, 0.2);
  animation: origin-input-breathe 2.2s ease-in-out infinite;
}

@keyframes access-guide-shimmer {
  0%, 18% { left: -35%; }
  70%, 100% { left: 118%; }
}

@keyframes access-guide-cursor-tour {
  0%, 26% { left: 11%; }
  34%, 59% { left: 48%; }
  67%, 92% { left: 84%; }
  100% { left: 11%; }
}

@keyframes access-guide-step-focus {
  0%, 100% {
    color: #557065;
    border-color: rgba(24, 115, 71, 0.1);
    background: rgba(255, 255, 255, 0.78);
    transform: translateY(0);
  }
  8%, 27% {
    color: #174d31;
    border-color: rgba(220, 146, 34, 0.52);
    background: #fff8e9;
    transform: translateY(-2px);
  }
}

@keyframes origin-guide-dot-pulse {
  0% { box-shadow: 0 0 0 0 rgba(229, 156, 37, 0.36); }
  75%, 100% { box-shadow: 0 0 0 9px rgba(229, 156, 37, 0); }
}

@keyframes origin-input-breathe {
  0%, 100% { box-shadow: 0 0 0 1px rgba(229, 156, 37, 0.6) inset, 0 0 0 0 rgba(229, 156, 37, 0.12); }
  50% { box-shadow: 0 0 0 1px rgba(229, 156, 37, 0.9) inset, 0 0 0 7px rgba(229, 156, 37, 0.12); }
}

@media (prefers-reduced-motion: reduce) {
  .access-guide-value::after,
  .access-guide-cursor,
  .access-guide-step,
  .origin-guide-message > span,
  .origin-required-guide--active .origin-address-input :deep(.el-input__wrapper) {
    animation: none;
  }
}

.create-domain-entry-guide {
  position: relative;
  overflow: visible;
}

.create-domain-entry-guide :deep(.el-card__body) {
  position: relative;
}

.domain-entry-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.domain-entry-cue {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border-radius: 999px;
  padding: 5px 10px;
  color: #ffffff;
  background: #d48924;
  font-size: 12px;
  font-weight: 900;
  box-shadow: 0 0 0 0 rgba(212, 137, 36, 0.28);
  animation: domain-entry-cue-pulse 2.2s ease-in-out infinite;
}

.domain-entry-cue::before {
  content: "→";
  font-size: 14px;
  line-height: 1;
}

.domain-entry-input-wrap {
  position: relative;
}

.domain-entry-input {
  position: relative;
  z-index: 1;
}

.create-domain-entry-guide--active .domain-entry-input-wrap::before {
  content: "";
  position: absolute;
  top: 50%;
  left: -22px;
  z-index: 3;
  width: 16px;
  height: 16px;
  background: #d48924;
  clip-path: polygon(0 0, 100% 50%, 0 100%, 28% 50%);
  transform: translate(-4px, -50%);
  animation: domain-entry-arrow-nudge 1.45s ease-in-out infinite;
}

.create-domain-entry-guide--active .domain-entry-input-wrap::after {
  content: "";
  position: absolute;
  inset: -8px;
  z-index: 0;
  border: 1px solid rgba(212, 137, 36, 0.38);
  border-radius: 13px;
  background:
    linear-gradient(90deg, rgba(212, 137, 36, 0.1), rgba(255, 255, 255, 0) 62%),
    rgba(255, 252, 242, 0.7);
  pointer-events: none;
  animation: domain-entry-field-glow 2.2s ease-in-out infinite;
}

.create-domain-entry-guide--active .domain-entry-input :deep(.el-input__wrapper) {
  border-color: rgba(212, 137, 36, 0.5);
  box-shadow: 0 0 0 1px rgba(212, 137, 36, 0.22), 0 12px 26px rgba(212, 137, 36, 0.12);
}

@keyframes domain-entry-cue-pulse {
  0%,
  100% {
    transform: translateX(0);
    box-shadow: 0 0 0 0 rgba(212, 137, 36, 0.28);
  }

  50% {
    transform: translateX(2px);
    box-shadow: 0 0 0 7px rgba(212, 137, 36, 0);
  }
}

@keyframes domain-entry-arrow-nudge {
  0%,
  100% {
    opacity: 0.58;
    transform: translate(-4px, -50%) rotate(-45deg);
  }

  50% {
    opacity: 1;
    transform: translate(2px, -50%) rotate(-45deg);
  }
}

@keyframes domain-entry-field-glow {
  0%,
  100% {
    opacity: 0.72;
    box-shadow: 0 0 0 0 rgba(212, 137, 36, 0.12);
  }

  50% {
    opacity: 1;
    box-shadow: 0 0 0 8px rgba(212, 137, 36, 0);
  }
}

@media (prefers-reduced-motion: reduce) {
  .domain-entry-cue,
  .create-domain-entry-guide--active .domain-entry-input-wrap::before,
  .create-domain-entry-guide--active .domain-entry-input-wrap::after {
    animation: none;
  }
}

.field-help {
  margin: 0;
  color: #69786f;
  font-size: 13px;
  line-height: 1.5;
}

.readonly-input {
  border: 1px solid #dce6dd;
  border-radius: 10px;
  padding: 10px 12px;
  color: #607166;
  background: #f3f5f1;
  overflow-wrap: anywhere;
}

.full-width {
  width: 100%;
}

.selected-plan-card {
  margin-top: 10px;
  border: 1px solid rgba(18, 127, 87, 0.16);
  border-radius: 8px;
  padding: 10px 12px;
  background: #f3fbf6;
}

.selected-plan-card span {
  display: block;
  color: #65756b;
  font-size: 12px;
  font-weight: 800;
}

.selected-plan-card strong {
  display: block;
  margin-top: 4px;
  color: #0f3a27;
  font-size: 16px;
}

.selected-plan-card p {
  margin: 6px 0 0;
  color: #5f7065;
  font-size: 13px;
  line-height: 1.5;
}

.access-mode-picker {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.origin-grid {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 10px;
}

/* DNS 对照、宽源站输入与紧凑证书选项，更新时间：2026-08-30 21:07 CST。对应用户选定的方案二与方案三视觉。 */
.dns-copy-summary-card {
  border-color: rgba(23, 112, 68, 0.3);
  background: linear-gradient(145deg, #ffffff, #f4fbf5);
}

/* DNS summary typography V1.3; 2026-09-16 02:19:54 CST;
   parent bd5ea8e6ff2795295b1609a0a20331ac3f27e6be.
   Keep typography local to the summary: readable labels/help at 14px and DNS
   data at 16px, without changing the guide's animation geometry or timing. */
.dns-copy-summary-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.dns-copy-summary-header span {
  color: #172a35;
  font-size: 16px;
  font-weight: 700;
  line-height: 1.5;
}

.dns-copy-summary-header small {
  color: #52665c;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.5;
}

.dns-copy-summary-grid {
  display: grid;
  gap: 8px;
}

.dns-copy-summary-item {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: center;
  gap: 9px;
  border: 1px solid rgba(23, 112, 68, 0.18);
  border-radius: 11px;
  padding: 10px;
  background: rgba(255, 255, 255, 0.92);
}

.dns-copy-summary-item > div {
  display: grid;
  min-width: 0;
  gap: 4px;
}

.dns-copy-summary-item span {
  color: #496257;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.5;
}

.dns-copy-summary-item code {
  color: #0e5f39;
  font-family: "SFMono-Regular", Consolas, monospace;
  font-size: 16px;
  font-weight: 600;
  font-variant-ligatures: none;
  line-height: 1.55;
  overflow-wrap: anywhere;
  white-space: normal;
}

.dns-copy-summary-item small {
  color: #52665c;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.5;
  overflow-wrap: anywhere;
}

.dns-copy-summary-item .dns-summary-copy-button {
  font-size: 14px;
  font-weight: 600;
}

.dns-summary-copy-button {
  min-width: 54px;
  min-height: 34px;
  border: 1px solid #075b34;
  border-radius: 8px;
  padding: 6px 10px;
  color: #ffffff;
  background: linear-gradient(145deg, #19834e, #075b34);
  box-shadow: 0 6px 14px rgba(7, 91, 52, 0.18);
  font: inherit;
  font-size: 11px;
  font-weight: 900;
  cursor: pointer;
}

.dns-summary-copy-button--copied {
  border-color: #188a54;
  background: linear-gradient(145deg, #26a162, #137548);
}

.dns-guide-empty {
  display: grid;
  justify-items: center;
  gap: 6px;
  border: 1px dashed rgba(23, 112, 68, 0.3);
  border-radius: 12px;
  padding: 22px 14px;
  color: #5f7568;
  background: #f7fbf7;
  text-align: center;
}

.dns-guide-empty strong {
  color: #174f32;
  font-size: 14px;
}

.dns-guide-empty p {
  margin: 0;
  font-size: 11px;
  line-height: 1.55;
}

.create-access-guide--compare :deep(.el-card__body) {
  gap: 12px;
}

.dns-guide-domain {
  display: grid;
  gap: 3px;
  border: 1px solid rgba(24, 115, 71, 0.18);
  border-radius: 12px;
  padding: 11px 12px;
  background: linear-gradient(135deg, #f4fbf5, #ffffff);
}

.dns-guide-domain span {
  color: #6a796f;
  font-size: 10px;
  font-weight: 800;
}

.dns-guide-domain strong {
  color: #0f5d39;
  font-size: 16px;
  overflow-wrap: anywhere;
}

.dns-guide-domain small {
  color: #68786f;
  font-size: 11px;
}

/* 来源：console-domain-access-guide-cert-copy-20260916；CST 2026-09-16 01:31；父基线 d7d38c0fd9a86ebfd04ad7843168cb0becb05652。
 * 域名接入指引直接复用 HTTPS 证书 DNS 动画语言：左侧平台记录、右侧 DNS 服务商表单、鼠标点击/粘贴路径。
 * 只缩放尺寸和替换字段内容，不改变创建域名、复制、检测、301 或节点分配逻辑。 */
.create-access-guide :deep(.el-card__body) {
  overflow-x: auto;
}

.domain-dns-guide-animation {
  display: grid;
  grid-template-columns: minmax(230px, 0.9fr) minmax(265px, 1.1fr);
  gap: 12px;
  min-width: 520px;
  margin-top: 2px;
  padding: 12px;
  overflow: hidden;
  border: 1px solid #9fd7bb;
  border-radius: 8px;
  background: #eef6f1;
  animation: domainHotxGuideEnter 0.32s ease both;
}

.domain-dns-guide-animation .guide-panel {
  position: relative;
  min-height: 320px;
  overflow: hidden;
  border: 1px solid #d4e7dd;
  border-radius: 8px;
  padding: 12px;
  background: #f7fbf8;
  box-shadow: inset 0 0 0 1px rgba(13, 124, 89, 0.05);
}

.domain-dns-guide-animation .guide-panel-title,
.domain-dns-guide-animation .select-row,
.domain-dns-guide-animation .dns-actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 7px;
}

.domain-dns-guide-animation .guide-panel-title {
  justify-content: space-between;
  margin-bottom: 10px;
}

.domain-dns-guide-animation .guide-panel-title span {
  color: #2f3b35;
  font-size: 14px;
  font-weight: 950;
  line-height: 1.2;
}

.domain-dns-guide-animation .guide-panel-title strong {
  border: 1px solid #98d7b7;
  border-radius: 999px;
  padding: 4px 9px;
  color: #0d7c59;
  background: #e6f8ef;
  font-size: 10px;
  font-weight: 900;
  line-height: 1.2;
  white-space: nowrap;
}

.domain-dns-guide-animation .guide-records {
  display: grid;
  gap: 10px;
  border: 1px solid #9fd7bb;
  border-radius: 8px;
  padding: 11px;
  background: #fbfffc;
}

.domain-dns-guide-animation .guide-record-item {
  position: relative;
  min-height: 48px;
  border: 1px solid #d4e7dd;
  border-radius: 8px;
  padding: 10px 72px 10px 10px;
  background: #ffffff;
}

.domain-dns-guide-animation .guide-record-item span,
.domain-dns-guide-animation .field-label {
  color: #5d7369;
  font-size: 11px;
  font-weight: 850;
}

.domain-dns-guide-animation .guide-record-item strong,
.domain-dns-guide-animation .guide-record-item code {
  display: block;
  margin-top: 6px;
  color: #2f3733;
  font-size: 12px;
  font-weight: 950;
  line-height: 1.35;
  overflow-wrap: anywhere;
}

.domain-dns-guide-animation .guide-record-item code {
  font-size: 11px;
}

.domain-dns-guide-animation .guide-copy {
  position: absolute;
  right: 8px;
  top: 27px;
  border: 1px solid #d4e7dd;
  border-radius: 7px;
  padding: 7px 10px;
  color: #0d4939;
  background: #ffffff;
  font: inherit;
  font-size: 11px;
  font-weight: 850;
  cursor: pointer;
}

.domain-dns-guide-animation .guide-copy:disabled {
  color: #c7d0ca;
  cursor: not-allowed;
}

.domain-dns-guide-animation .copy-name {
  animation: domainHotxCopyName 8s infinite;
}

.domain-dns-guide-animation .copy-value {
  animation: domainHotxCopyValue 8s infinite;
}

.domain-dns-guide-animation .copy-value--copied {
  border-color: #78c9a2;
  color: #ffffff;
  background: #0d7c59;
}

.domain-dns-guide-animation .dns-window {
  overflow: hidden;
  border: 1px solid #ccd7e0;
  border-radius: 8px;
  background: #ffffff;
  box-shadow: 0 8px 18px rgba(24, 45, 37, 0.08);
}

.domain-dns-guide-animation .dns-top {
  display: flex;
  align-items: center;
  gap: 9px;
  height: 34px;
  border-bottom: 1px solid #dfe5eb;
  padding: 0 10px;
  color: #334155;
  font-size: 12px;
}

.domain-dns-guide-animation .dns-top span {
  color: #1a73e8;
  font-size: 19px;
}

.domain-dns-guide-animation .dns-form {
  padding: 12px;
}

.domain-dns-guide-animation .dns-field {
  position: relative;
  display: flex;
  align-items: center;
  min-height: 39px;
  margin-bottom: 12px;
  border: 1px solid #aebdca;
  border-radius: 4px;
  padding: 8px 10px;
  background: #ffffff;
}

.domain-dns-guide-animation .field-label {
  position: absolute;
  top: -9px;
  left: 8px;
  padding: 0 4px;
  color: #1a73e8;
  background: #ffffff;
}

.domain-dns-guide-animation .typed-name,
.domain-dns-guide-animation .typed-value {
  display: inline-block;
  max-width: 0;
  overflow: hidden;
  color: #2f3733;
  white-space: nowrap;
  font-size: 12px;
  font-weight: 950;
}

.domain-dns-guide-animation .typed-value {
  text-overflow: clip;
}

.domain-dns-guide-animation .typed-name {
  animation: domainHotxTypeName 8s infinite;
}

.domain-dns-guide-animation .typed-value {
  animation: domainHotxTypeValue 8s infinite;
}

.domain-dns-guide-animation .focus-name {
  animation: domainHotxFocusName 8s infinite;
}

.domain-dns-guide-animation .focus-value {
  animation: domainHotxFocusValue 8s infinite;
}

.domain-dns-guide-animation .select-row {
  margin: 8px 0 12px;
}

.domain-dns-guide-animation .select-row span {
  min-width: 82px;
  border: 1px solid #b8c7d4;
  border-radius: 4px;
  padding: 7px 9px;
  background: #ffffff;
  font-size: 11px;
  font-weight: 850;
}

.domain-dns-guide-animation .create-btn {
  border: 0;
  border-radius: 5px;
  padding: 8px 13px;
  color: #ffffff;
  background: #0d7c59;
  font-weight: 900;
  animation: domainHotxCreate 8s infinite;
}

.domain-dns-guide-animation .dns-actions span {
  min-width: 0;
  color: #40534a;
  font-size: 11px;
  line-height: 1.4;
}

.domain-dns-guide-animation .cursor,
.domain-dns-guide-animation .cursor-left {
  position: absolute;
  width: 22px;
  height: 22px;
  border-radius: 50% 50% 50% 0;
  opacity: 0;
  background: rgba(13, 124, 89, 0.92);
  box-shadow: 0 8px 20px rgba(13, 73, 57, 0.26);
  transform: rotate(-20deg);
}

.domain-dns-guide-animation .cursor::after,
.domain-dns-guide-animation .cursor-left::after {
  position: absolute;
  top: 8px;
  left: 8px;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #ffffff;
  content: '';
}

.domain-dns-guide-animation .cursor {
  animation: domainHotxCursor 8s infinite;
}

.domain-dns-guide-animation .cursor-left {
  animation: domainHotxCursorLeft 8s infinite;
}

.domain-dns-guide-animation .mouse-tip {
  position: absolute;
  z-index: 3;
  border: 1px solid #9fd7bb;
  border-radius: 999px;
  padding: 5px 9px;
  color: #0d4939;
  background: #ffffff;
  box-shadow: 0 8px 18px rgba(13, 73, 57, 0.1);
  font-size: 10px;
  font-weight: 900;
  opacity: 0;
  pointer-events: none;
  white-space: nowrap;
}

.domain-dns-guide-animation .tip-name,
.domain-dns-guide-animation .tip-value {
  right: 14px;
}

.domain-dns-guide-animation .tip-name {
  top: 126px;
  animation: domainHotxTipName 8s infinite;
}

.domain-dns-guide-animation .tip-value {
  top: 232px;
  animation: domainHotxTipValue 8s infinite;
}

.domain-dns-guide-animation .tip-dns,
.domain-dns-guide-animation .tip-paste {
  left: 32px;
}

.domain-dns-guide-animation .tip-dns {
  top: 76px;
  animation: domainHotxTipDns 8s infinite;
}

.domain-dns-guide-animation .tip-paste {
  top: 168px;
  animation: domainHotxTipPaste 8s infinite;
}

@keyframes domainHotxGuideEnter {
  from {
    opacity: 0;
    transform: translateY(8px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes domainHotxCopyName {
  0%, 100% { background: #ffffff; color: #0d4939; transform: scale(1); }
  5%, 18% { background: #0d4939; color: #ffffff; transform: scale(1.03); }
}

@keyframes domainHotxCopyValue {
  0%, 45%, 100% { background: #ffffff; color: #0d4939; transform: scale(1); }
  50%, 62% { background: #0d4939; color: #ffffff; transform: scale(1.03); }
}

@keyframes domainHotxFocusName {
  0%, 22%, 100% { border-color: #aebdca; box-shadow: none; }
  25%, 43% { border-color: #1a73e8; box-shadow: 0 0 0 2px rgba(26, 115, 232, 0.12); }
}

@keyframes domainHotxFocusValue {
  0%, 58%, 100% { border-color: #aebdca; box-shadow: none; }
  61%, 78% { border-color: #1a73e8; box-shadow: 0 0 0 2px rgba(26, 115, 232, 0.12); }
}

@keyframes domainHotxTypeName {
  0%, 24% { clip-path: inset(0 100% 0 0); }
  34%, 100% { clip-path: inset(0); }
}

@keyframes domainHotxTypeValue {
  0%, 60% { clip-path: inset(0 100% 0 0); }
  75%, 100% { clip-path: inset(0); }
}

@keyframes domainHotxCursor {
  0%, 20% { left: 26px; top: 68px; opacity: 0; }
  24%, 42% { left: 30px; top: 84px; opacity: 1; }
  48%, 64% { left: 30px; top: 84px; opacity: 0; }
  68%, 82% { left: 30px; top: 174px; opacity: 1; }
  88%, 100% { left: 70px; top: 212px; opacity: 0; }
}

@keyframes domainHotxCursorLeft {
  0%, 3% { right: 28px; top: 142px; opacity: 0; }
  6%, 18% { right: 30px; top: 145px; opacity: 1; }
  22%, 46% { right: 30px; top: 145px; opacity: 0; }
  50%, 62% { right: 30px; top: 250px; opacity: 1; }
  66%, 100% { right: 30px; top: 250px; opacity: 0; }
}

@keyframes domainHotxCreate {
  0%, 80%, 100% { transform: scale(1); filter: none; }
  84%, 90% { transform: scale(0.96); filter: brightness(0.92); }
}

@keyframes domainHotxTipName {
  0%, 4%, 21%, 100% { opacity: 0; transform: translateY(3px); }
  7%, 18% { opacity: 1; transform: translateY(0); }
}

@keyframes domainHotxTipDns {
  0%, 23%, 45%, 100% { opacity: 0; transform: translateY(3px); }
  27%, 42% { opacity: 1; transform: translateY(0); }
}

@keyframes domainHotxTipValue {
  0%, 48%, 65%, 100% { opacity: 0; transform: translateY(3px); }
  52%, 62% { opacity: 1; transform: translateY(0); }
}

@keyframes domainHotxTipPaste {
  0%, 66%, 86%, 100% { opacity: 0; transform: translateY(3px); }
  70%, 83% { opacity: 1; transform: translateY(0); }
}

.dns-guide-motion-stage {
  position: relative;
  display: grid;
  grid-template-columns: minmax(0, 1fr) 34px minmax(0, 1fr);
  gap: 8px;
  align-items: stretch;
}

.dns-guide-panel {
  position: relative;
  min-width: 0;
  display: grid;
  gap: 10px;
  border: 1px solid rgba(24, 115, 71, 0.24);
  border-radius: 13px;
  padding: 12px;
  background: rgba(255, 255, 255, 0.88);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.72);
}

.dns-guide-panel--platform {
  background: linear-gradient(145deg, rgba(244, 251, 246, 0.96), rgba(255, 255, 255, 0.94));
}

.dns-guide-panel--dns {
  background: linear-gradient(145deg, rgba(255, 255, 255, 0.96), rgba(248, 252, 249, 0.94));
}

.dns-guide-panel-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.dns-guide-panel-title span {
  color: #145b38;
  font-size: 11px;
  font-weight: 900;
}

.dns-guide-panel-title strong {
  border-radius: 999px;
  padding: 4px 8px;
  color: #127346;
  background: #e5f7e9;
  font-size: 9px;
  font-weight: 900;
  white-space: nowrap;
}

.dns-guide-record-list {
  display: grid;
  gap: 8px;
}

.dns-guide-record-card {
  position: relative;
  display: grid;
  gap: 5px;
  min-width: 0;
  border: 1px solid rgba(24, 115, 71, 0.16);
  border-radius: 9px;
  padding: 9px;
  background: rgba(255, 255, 255, 0.9);
}

.dns-guide-record-card small,
.dns-provider-label {
  color: #6a796f;
  font-size: 10px;
  font-weight: 800;
}

.dns-guide-record-card strong,
.dns-guide-record-card code {
  color: #105c38;
  font-size: 12px;
  font-weight: 900;
  overflow-wrap: anywhere;
}

.dns-guide-record-card code {
  font-size: 10px;
  line-height: 1.4;
}

.dns-guide-copy-pill {
  justify-self: start;
  min-height: 31px;
  border: 1px solid #075b34;
  border-radius: 7px;
  padding: 6px 8px;
  color: #ffffff;
  background: linear-gradient(145deg, #17804c, #075b34);
  box-shadow: 0 5px 12px rgba(7, 91, 52, 0.18);
  font: inherit;
  font-size: 10px;
  font-weight: 900;
  cursor: pointer;
  animation: dns-guide-copy-breathe 2.2s ease-in-out infinite;
}

.dns-guide-copy-pill:disabled {
  border-color: #cfd9d1;
  color: #839188;
  background: #eef2ef;
  box-shadow: none;
  cursor: not-allowed;
  animation: none;
}

.dns-guide-copy-pill--copied {
  background: linear-gradient(145deg, #22975d, #0d7243);
}

.dns-guide-bridge {
  position: absolute;
  left: calc(50% - 17px);
  top: 48%;
  display: grid;
  place-items: center;
  width: 34px;
  height: 30px;
}

.dns-guide-bridge span {
  width: 100%;
  border-top: 1px dashed rgba(23, 112, 68, 0.64);
}

.dns-guide-bridge i {
  position: absolute;
  width: 7px;
  height: 7px;
  border-radius: 999px;
  background: #177044;
  animation: dns-guide-dot-flow 2.4s ease-in-out infinite;
}

.dns-provider-window {
  overflow: hidden;
  border: 1px solid rgba(27, 119, 72, 0.24);
  border-radius: 10px;
  background: #ffffff;
  box-shadow: 0 8px 18px rgba(14, 68, 40, 0.08);
}

.dns-provider-top {
  display: flex;
  align-items: center;
  gap: 7px;
  border-bottom: 1px solid #dfece3;
  padding: 7px 9px;
  color: #2b5570;
  background: #f8fbff;
  font-size: 11px;
  font-weight: 900;
}

.dns-provider-form {
  display: grid;
  gap: 8px;
  padding: 9px;
}

.dns-provider-field {
  position: relative;
  display: grid;
  gap: 5px;
  border: 1px solid #d5e4dc;
  border-radius: 7px;
  padding: 8px;
  background: #ffffff;
}

.dns-provider-field--value {
  border-color: rgba(224, 154, 36, 0.55);
  box-shadow: 0 0 0 0 rgba(224, 154, 36, 0.18);
  animation: dns-provider-value-focus 2.6s ease-in-out infinite;
}

.dns-provider-value {
  min-width: 0;
  color: #1e4030;
  font-size: 11px;
  font-weight: 800;
}

.dns-provider-value--wrap {
  font-size: 9px;
  line-height: 1.45;
  overflow-wrap: anywhere;
}

.dns-provider-select-row {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 7px;
}

.dns-provider-select-row span {
  border: 1px solid #d5e4dc;
  border-radius: 7px;
  padding: 6px 7px;
  color: #345241;
  background: #fbfdfb;
  font-size: 10px;
  font-weight: 800;
}

.dns-provider-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #5d6f64;
  font-size: 10px;
}

.dns-provider-actions button {
  border: 0;
  border-radius: 6px;
  padding: 7px 12px;
  color: #ffffff;
  background: #0e7445;
  font-size: 10px;
  font-weight: 900;
}

.dns-guide-mouse {
  position: absolute;
  z-index: 3;
  width: 15px;
  height: 20px;
  clip-path: polygon(0 0, 100% 58%, 62% 68%, 45% 100%);
  background: #e7a126;
  filter: drop-shadow(0 3px 4px rgba(170, 101, 10, 0.28));
  pointer-events: none;
}

.dns-guide-mouse--copy {
  right: 22px;
  bottom: 20px;
  animation: dns-guide-copy-cursor 3.6s ease-in-out infinite;
}

.dns-guide-mouse--paste {
  right: 26px;
  bottom: 70px;
  animation: dns-guide-paste-cursor 3.6s ease-in-out infinite;
}

.dns-guide-mouse-tip {
  position: absolute;
  z-index: 2;
  border-radius: 999px;
  padding: 4px 7px;
  color: #80520f;
  background: #fff4d8;
  font-size: 9px;
  font-weight: 900;
  white-space: nowrap;
}

.dns-guide-mouse-tip--copy {
  right: 38px;
  bottom: 8px;
}

.dns-guide-mouse-tip--paste {
  right: 42px;
  bottom: 52px;
}

.dns-guide-tip {
  display: grid;
  grid-template-columns: auto minmax(0, 1fr);
  align-items: center;
  gap: 8px;
  border-radius: 10px;
  padding: 9px 10px;
  color: #596c61;
  background: #f3f8f2;
}

.dns-guide-tip > span {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  color: #ffffff;
  background: #dfa021;
  font-size: 10px;
  font-weight: 900;
}

.dns-guide-tip p {
  margin: 0;
  font-size: 10px;
  line-height: 1.5;
}

.origin-address-label {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  color: #173f2b;
  font-size: 12px;
}

.origin-address-label span {
  border-radius: 999px;
  padding: 3px 8px;
  color: #8b590d;
  background: #fff1d4;
  font-size: 10px;
  font-weight: 900;
}

.origin-address-input :deep(.el-input__wrapper) {
  min-height: 52px;
  border-radius: 11px;
  padding-inline: 14px;
  box-shadow: 0 0 0 1px rgba(22, 108, 65, 0.38) inset;
}

.origin-address-input :deep(.el-input__inner) {
  color: #145a38;
  font-size: 15px;
  font-weight: 800;
}

.origin-address-input--filled :deep(.el-input__wrapper) {
  box-shadow: 0 0 0 1px #168052 inset, 0 8px 22px rgba(22, 128, 82, 0.1);
}

.origin-port-selector {
  border: 0;
  padding: 0;
  background: transparent;
}

.origin-port-options {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  align-items: stretch;
  gap: 7px;
}

.origin-port-options :deep(.el-checkbox) {
  display: flex;
  align-items: center;
  min-width: 0;
  min-height: 58px;
  margin: 0;
  border: 1px solid #d9ded9;
  border-radius: 10px;
  padding: 8px;
  background: #ffffff;
  white-space: normal;
}

.origin-port-options :deep(.el-checkbox.is-checked) {
  border-color: #157146;
  background: linear-gradient(145deg, #effaf2, #ffffff);
  box-shadow: 0 7px 16px rgba(21, 113, 70, 0.11);
}

.origin-port-options :deep(.el-checkbox__label) {
  min-width: 0;
  padding-left: 5px;
  font-size: 10px;
  font-weight: 800;
  line-height: 1.35;
}

.custom-origin-port-row {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
}

.custom-origin-port-row :deep(.el-input-number),
.custom-origin-port-row :deep(.el-select) {
  width: 100%;
}

.create-ssl-card :deep(.el-radio-group) {
  display: grid;
  width: 100%;
  gap: 7px;
}

.create-ssl-card :deep(.el-radio) {
  display: grid;
  grid-template-columns: auto minmax(0, 1fr);
  align-items: center;
  width: 100%;
  min-height: 50px;
  margin: 0;
  border: 1px solid #dce2dc;
  border-radius: 11px;
  padding: 8px 10px;
  background: #ffffff;
}

.create-ssl-card :deep(.el-radio.is-checked) {
  border-color: rgba(20, 121, 72, 0.55);
  background: linear-gradient(90deg, #eaf8ed, #f8fcf8);
  box-shadow: 0 7px 18px rgba(20, 121, 72, 0.09);
}

.create-ssl-card :deep(.el-radio__label) {
  color: #263d30;
  font-size: 12px;
  font-weight: 800;
  white-space: normal;
}

.create-ssl-card :deep(.el-radio:nth-child(1) .el-radio__label)::after,
.create-ssl-card :deep(.el-radio:nth-child(2) .el-radio__label)::after,
.create-ssl-card :deep(.el-radio:nth-child(3) .el-radio__label)::after {
  display: block;
  margin-top: 3px;
  color: #748078;
  font-size: 9px;
  font-weight: 600;
}

.create-ssl-card :deep(.el-radio:nth-child(1) .el-radio__label)::after {
  content: "平台自动申请并续期证书";
}

.create-ssl-card :deep(.el-radio:nth-child(2) .el-radio__label)::after {
  content: "使用已有证书手动配置";
}

.create-ssl-card :deep(.el-radio:nth-child(3) .el-radio__label)::after {
  content: "以后可在域名管理中继续配置";
}

@keyframes dns-guide-dot-flow {
  0%, 20% { transform: translateX(-13px); opacity: 0.24; }
  55%, 85% { transform: translateX(13px); opacity: 1; }
  100% { transform: translateX(13px); opacity: 0; }
}

@keyframes dns-guide-copy-breathe {
  0%, 100% { box-shadow: 0 5px 12px rgba(7, 91, 52, 0.18), 0 0 0 0 rgba(231, 161, 38, 0.2); }
  50% { box-shadow: 0 7px 18px rgba(7, 91, 52, 0.22), 0 0 0 6px rgba(231, 161, 38, 0); }
}

@keyframes dns-guide-copy-cursor {
  0%, 100% { transform: translate(0, 0); opacity: 0.58; }
  50% { transform: translate(-5px, -5px); opacity: 1; }
}

@keyframes dns-guide-paste-cursor {
  0%, 100% { transform: translate(-2px, 2px); opacity: 0.58; }
  50% { transform: translate(-8px, -3px); opacity: 1; }
}

@keyframes dns-provider-value-focus {
  0%, 100% { box-shadow: 0 0 0 0 rgba(224, 154, 36, 0.14); }
  50% { box-shadow: 0 0 0 5px rgba(224, 154, 36, 0); }
}

@media (prefers-reduced-motion: reduce) {
  .dns-guide-bridge i,
  .dns-guide-copy-pill,
  .dns-guide-mouse,
  .dns-provider-field--value {
    animation: none;
  }
}

.summary-section dl {
  display: grid;
  gap: 8px;
  margin: 0;
}

.summary-section dl div {
  display: grid;
  grid-template-columns: 96px minmax(0, 1fr);
  gap: 10px;
}

.summary-section dt {
  color: #67766d;
  font-weight: 800;
}

.summary-section dd {
  margin: 0;
  overflow-wrap: anywhere;
}

.submit-access-button {
  width: 100%;
  margin-top: 10px;
}

.submit-feedback {
  margin: 10px 0 0;
  border: 1px solid rgba(18, 127, 87, 0.18);
  border-radius: 8px;
  padding: 10px 12px;
  color: #0d6f4f;
  font-size: 13px;
  font-weight: 800;
  background: #eefaf3;
}

@media (max-width: 1180px) {
  .domain-workbench.with-create-panel,
  .diagnosis-layout,
  .diagnosis-address-grid {
    grid-template-columns: 1fr;
  }

  .create-domain-panel {
    position: static;
    max-height: none;
  }

  .domain-workbench-splitter {
    display: none;
  }

  .domain-workbench.with-create-panel {
    gap: 18px;
  }

  .add-domain-guide,
  .domain-draft-notice,
  .free-cdn-intent-note {
    grid-template-columns: 1fr;
    flex-direction: column;
    align-items: stretch;
  }

  .add-domain-guide .add-domain-button,
  .add-domain-guide .pure-ip-button,
  .add-domain-guide .free-cdn-button,
  .add-domain-guide strong,
  .add-domain-guide > span:last-of-type,
  .guide-step-badge {
    grid-column: auto;
    grid-row: auto;
    width: 100%;
  }

  .frontend-protocol-picker,
  .protocol-port-grid,
  .unified-service-row,
  .pure-ip-mode-picker {
    grid-template-columns: 1fr;
  }
}
/* V1.0 shared-entry validation and region layout, 2026-09-10 CST.
 * Required state is visible without changing the established card hierarchy. */
.required-star {
  color: #d64545;
  font: inherit;
}

.required-error {
  margin: 7px 0 0;
  color: #c93636;
  font-size: 12px;
  font-weight: 700;
}

.required-control--error :deep(.el-input__wrapper),
.required-control--error :deep(.el-select__wrapper),
.required-group--error {
  box-shadow: 0 0 0 1px #e35b5b inset !important;
}

.required-group--error {
  border-radius: 10px;
  background: #fff5f4;
}

.acceleration-region-field {
  display: grid;
  gap: 8px;
  margin-top: 14px;
}

.acceleration-region-field > label,
.create-plan-renewal > span {
  color: #284c3c;
  font-size: 13px;
  font-weight: 800;
}

.create-plan-renewal {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-top: 12px;
  padding: 11px 13px;
  border: 1px solid #d9e8dc;
  border-radius: 11px;
  background: #f7fbf6;
}

.summary-section .summary-missing {
  color: #bd3030;
  background: #fff3f2;
}

.summary-section .summary-missing dt,
.summary-section .summary-missing dd {
  color: inherit;
}
/* HotX Root301 UI text fit 2026-09-16 CST, baseline d7d38c0fd:
   only improves readable font sizes and wrapping for the existing DNS guide animation; layout and animation format stay unchanged. */
.access-guide-header > span:first-child {
  color: #172a35;
  font-size: 16px;
  font-weight: 800;
  line-height: 1.35;
}

.access-guide-badge {
  font-size: 12px;
  font-weight: 800;
  line-height: 1.35;
}

.dns-guide-domain span,
.domain-dns-guide-animation .guide-record-item span,
.domain-dns-guide-animation .field-label {
  font-size: 12px;
  font-weight: 800;
  line-height: 1.45;
}

.dns-guide-domain small {
  font-size: 12px;
  line-height: 1.45;
}

.dns-summary-copy-button,
.dns-guide-replay-button,
.domain-dns-guide-animation .guide-copy,
.domain-dns-guide-animation .create-btn {
  font-size: 13px;
  font-weight: 800;
  line-height: 1.2;
}

.dns-guide-domain strong {
  font-size: 17px;
  line-height: 1.4;
  overflow-wrap: anywhere;
  white-space: normal;
}

.domain-dns-guide-animation .guide-panel-title span {
  font-size: 14px;
  line-height: 1.35;
}

.domain-dns-guide-animation .guide-panel-title strong {
  font-size: 12px;
  line-height: 1.35;
}

.domain-dns-guide-animation .guide-record-item strong,
.domain-dns-guide-animation .guide-record-item code {
  font-size: 13px;
  line-height: 1.45;
  overflow-wrap: anywhere;
  white-space: normal;
}

.domain-dns-guide-animation .typed-name,
.domain-dns-guide-animation .typed-value {
  display: block;
  width: 100%;
  min-width: 0;
  max-width: 100%;
  font-size: 13px;
  line-height: 1.45;
  overflow: visible;
  overflow-wrap: anywhere;
  white-space: normal;
}

.domain-dns-guide-animation .select-row span,
.domain-dns-guide-animation .dns-actions span {
  font-size: 12px;
  line-height: 1.4;
}

.domain-dns-guide-animation .mouse-tip {
  font-size: 12px;
  line-height: 1.25;
  white-space: nowrap;
}

.dns-guide-tip p {
  font-size: 12px;
  line-height: 1.45;
}

/* DNS guide text-fit V1.2; 2026-09-16 02:05:47 CST;
   parent d7d38c0fd9a86ebfd04ad7843168cb0becb05652 + UI_TEXT_FIT_BLANKFIX_PREVIEW_SWITCHED.
   Floating labels cross the field border, so the field must not clip its children.
   Reveal text with clip-path instead of animating its layout width: wrapping reserves
   the final text height throughout playback, without zero-width growth or truncation. */
.domain-dns-guide-animation .dns-form {
  gap: 8px;
}

.domain-dns-guide-animation .dns-field {
  align-items: flex-start;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  height: auto;
  min-height: 0;
  overflow: visible;
  padding: 18px 10px 8px;
}

.domain-dns-guide-animation .focus-name {
  min-height: 58px;
}

.domain-dns-guide-animation .focus-value {
  min-height: 78px;
}

/* DNS guide cursor focus V1.4; 2026-09-16 02:32:56 CST;
   parent 4bad29e8741c1ed469e72ea4c80018264c868514.
   Text-fit changes made the record cards taller; keep the mouse pointer centered
   on the copy buttons instead of the old, higher text baseline. */
.domain-dns-guide-animation .tip-name {
  top: 162px;
}

.domain-dns-guide-animation .tip-value {
  top: 242px;
}

@keyframes domainHotxCursorLeft {
  0%, 3% { right: 46px; top: 199px; opacity: 0; }
  6%, 18% { right: 46px; top: 199px; opacity: 1; }
  22%, 46% { right: 46px; top: 199px; opacity: 0; }
  50%, 62% { right: 46px; top: 279px; opacity: 1; }
  66%, 100% { right: 46px; top: 279px; opacity: 0; }
}

</style>
<!-- HotX Console 0.1.123 truthful acceleration diagnosis; updated 2026-09-30 17:44:13 CST; parent 7802b5dd00343a540af8d604dda2fb1f84324635; change DOMAIN-FIRST-ROUTE-HEALTH-20260930. -->
